var _defs, _rect, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _rect342, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _rect349, _rect350, _rect351, _rect352, _rect353, _rect354, _rect355, _rect356, _rect357, _rect358, _rect359, _rect360, _rect361, _rect362, _rect363, _rect364, _rect365, _rect366, _rect367, _rect368, _rect369, _rect370, _rect371, _rect372, _rect373, _rect374, _rect375, _rect376, _rect377, _rect378, _rect379, _rect380, _rect381, _rect382, _rect383, _rect384, _rect385, _rect386, _rect387, _rect388, _rect389, _rect390, _rect391, _rect392, _rect393, _rect394, _rect395, _rect396, _rect397, _rect398, _rect399, _rect400, _rect401, _rect402, _rect403, _rect404, _rect405, _rect406, _rect407, _rect408, _rect409, _rect410, _rect411, _rect412, _rect413, _rect414, _rect415, _rect416, _rect417, _rect418, _rect419, _rect420, _rect421, _rect422, _rect423, _rect424, _rect425, _rect426, _rect427, _rect428, _rect429, _rect430, _rect431, _rect432, _rect433, _rect434, _rect435, _rect436, _rect437, _rect438, _rect439, _rect440, _rect441, _rect442, _rect443, _rect444, _rect445, _rect446, _rect447, _rect448, _rect449, _rect450, _rect451, _rect452, _rect453, _rect454, _rect455, _rect456, _rect457, _rect458, _rect459, _rect460, _rect461, _rect462, _rect463, _rect464, _rect465, _rect466, _rect467, _rect468, _rect469, _rect470, _rect471, _rect472, _rect473, _rect474, _rect475, _rect476, _rect477, _rect478, _rect479, _rect480, _rect481, _rect482, _rect483, _rect484, _rect485, _rect486, _rect487, _rect488, _rect489, _rect490, _rect491, _rect492, _rect493, _rect494, _rect495, _rect496, _rect497, _rect498, _rect499, _rect500, _rect501, _rect502, _rect503, _rect504, _rect505, _rect506, _rect507, _rect508, _rect509, _rect510, _rect511, _rect512, _rect513, _rect514, _rect515, _rect516, _rect517, _rect518, _rect519, _rect520, _rect521, _rect522, _rect523, _rect524, _rect525, _rect526, _rect527, _rect528, _rect529, _rect530, _rect531, _rect532, _rect533, _rect534, _rect535, _rect536, _rect537, _rect538, _rect539, _rect540, _rect541, _rect542, _rect543, _rect544, _rect545, _rect546, _rect547, _rect548, _rect549, _rect550, _rect551, _rect552, _rect553, _rect554, _rect555, _rect556, _rect557, _rect558, _rect559, _rect560, _rect561, _rect562, _rect563, _rect564, _rect565, _rect566, _rect567, _rect568, _rect569, _rect570, _rect571, _rect572, _rect573, _rect574, _rect575, _rect576, _rect577, _rect578, _rect579, _rect580, _rect581, _rect582, _rect583, _rect584, _rect585, _rect586, _rect587, _rect588, _rect589, _rect590, _rect591, _rect592, _rect593, _rect594, _rect595, _rect596, _rect597, _rect598, _rect599, _rect600, _rect601, _rect602, _rect603, _rect604, _rect605, _rect606, _rect607, _rect608, _rect609, _rect610, _rect611, _rect612, _rect613, _rect614, _rect615, _rect616, _rect617, _rect618, _rect619, _rect620, _rect621, _rect622, _rect623, _rect624, _rect625, _rect626, _rect627, _rect628, _rect629, _rect630, _rect631, _rect632, _rect633, _rect634, _rect635, _rect636, _rect637, _rect638, _rect639, _rect640, _rect641, _rect642, _rect643, _rect644, _rect645, _rect646, _rect647, _rect648, _rect649, _rect650, _rect651, _rect652, _rect653, _rect654, _rect655, _rect656, _rect657, _rect658, _rect659, _rect660, _rect661, _rect662, _rect663, _rect664, _rect665, _rect666, _rect667, _rect668, _rect669, _rect670, _rect671, _rect672, _rect673, _rect674, _rect675, _rect676, _rect677, _rect678, _rect679, _rect680, _rect681, _rect682, _rect683, _rect684, _rect685, _rect686, _rect687, _rect688, _rect689, _rect690, _rect691, _rect692, _rect693, _rect694, _rect695, _rect696, _rect697, _rect698, _rect699, _rect700, _rect701, _rect702, _rect703, _rect704, _rect705, _rect706, _rect707, _rect708, _rect709, _rect710, _rect711, _rect712, _rect713, _rect714, _rect715, _rect716, _rect717, _rect718, _rect719, _rect720, _rect721, _rect722, _rect723, _rect724, _rect725, _rect726, _rect727, _rect728, _rect729, _rect730, _rect731, _rect732, _rect733, _rect734, _rect735, _rect736, _rect737, _rect738, _rect739, _rect740, _rect741, _rect742, _rect743, _rect744, _rect745, _rect746, _rect747, _rect748, _rect749, _rect750, _rect751, _rect752, _rect753, _rect754, _rect755, _rect756, _rect757, _rect758, _rect759, _rect760, _rect761, _rect762, _rect763, _rect764, _rect765, _rect766, _rect767, _rect768, _rect769, _rect770, _rect771, _rect772, _rect773, _rect774, _rect775, _rect776, _rect777, _rect778, _rect779, _rect780, _rect781, _rect782, _rect783, _rect784, _rect785, _rect786, _rect787, _rect788, _rect789, _rect790, _rect791, _rect792, _rect793, _rect794, _rect795, _rect796, _rect797, _rect798, _rect799, _rect800, _rect801, _rect802, _rect803, _rect804, _rect805, _rect806, _rect807, _rect808, _rect809, _rect810, _rect811, _rect812, _rect813, _rect814, _rect815, _rect816, _rect817, _rect818, _rect819, _rect820, _rect821, _rect822, _rect823, _rect824, _rect825, _rect826, _rect827, _rect828, _rect829, _rect830, _rect831, _rect832, _rect833, _rect834, _rect835, _rect836, _rect837, _rect838, _rect839, _rect840, _rect841, _rect842, _rect843, _rect844, _rect845, _rect846, _rect847, _rect848, _rect849, _rect850, _rect851, _rect852, _rect853, _rect854, _rect855, _rect856, _rect857, _rect858, _rect859, _rect860, _rect861, _rect862, _rect863, _rect864, _rect865, _rect866, _rect867, _rect868, _rect869, _rect870, _rect871, _rect872, _rect873, _rect874, _rect875, _rect876, _rect877, _rect878, _rect879, _rect880, _rect881, _rect882, _rect883, _rect884, _rect885, _rect886, _rect887, _rect888, _rect889, _rect890, _rect891, _rect892, _rect893, _rect894, _rect895, _rect896, _rect897, _rect898, _rect899, _rect900, _rect901, _rect902, _rect903, _rect904, _rect905, _rect906, _rect907, _rect908, _rect909, _rect910, _rect911, _rect912, _rect913, _rect914, _rect915, _rect916, _rect917, _rect918, _rect919, _rect920, _rect921, _rect922, _rect923, _rect924, _rect925, _rect926, _rect927, _rect928, _rect929, _rect930, _rect931, _rect932, _rect933, _rect934, _rect935, _rect936, _rect937, _rect938, _rect939, _rect940, _rect941, _rect942, _rect943, _rect944, _rect945, _rect946, _rect947, _rect948, _rect949, _rect950, _rect951, _rect952, _rect953, _rect954, _rect955, _rect956, _rect957, _rect958, _rect959, _rect960, _rect961, _rect962, _rect963, _rect964, _rect965, _rect966, _rect967, _rect968, _rect969, _rect970, _rect971, _rect972, _rect973, _rect974, _rect975, _rect976, _rect977, _rect978, _rect979, _rect980, _rect981, _rect982, _rect983, _rect984, _rect985, _rect986, _rect987, _rect988, _rect989, _rect990, _rect991, _rect992, _rect993, _rect994, _rect995, _rect996, _rect997, _rect998, _rect999, _rect1000, _rect1001, _rect1002, _rect1003, _rect1004, _rect1005, _rect1006, _rect1007, _rect1008, _rect1009, _rect1010, _rect1011, _rect1012, _rect1013, _rect1014, _rect1015, _rect1016, _rect1017, _rect1018, _rect1019, _rect1020, _rect1021, _rect1022, _rect1023, _rect1024, _rect1025, _rect1026, _rect1027, _rect1028, _rect1029, _rect1030, _rect1031, _rect1032, _rect1033, _rect1034, _rect1035, _rect1036, _rect1037, _rect1038, _rect1039, _rect1040, _rect1041, _rect1042, _rect1043, _rect1044, _rect1045, _rect1046, _rect1047, _rect1048, _rect1049, _rect1050, _rect1051, _rect1052, _rect1053, _rect1054, _rect1055, _rect1056, _rect1057, _rect1058, _rect1059, _rect1060, _rect1061, _rect1062, _rect1063, _rect1064, _rect1065, _rect1066, _rect1067, _rect1068, _rect1069, _rect1070, _rect1071, _rect1072, _rect1073, _rect1074, _rect1075, _rect1076, _rect1077, _rect1078, _rect1079, _rect1080, _rect1081, _rect1082, _rect1083, _rect1084, _rect1085, _rect1086, _rect1087, _rect1088, _rect1089, _rect1090, _rect1091, _rect1092, _rect1093, _rect1094, _rect1095, _rect1096, _rect1097, _rect1098, _rect1099, _rect1100, _rect1101, _rect1102, _rect1103, _rect1104, _rect1105, _rect1106, _rect1107, _rect1108, _polygon2, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuideMaterial1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 339.35 266.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-6{fill:none;stroke-miterlimit:10;stroke-width:0.25px;}.cls-1{stroke:#6b7b84;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#812990;}.cls-4{fill:#6b7b84;}.cls-5{fill:#231f20;}.cls-6{stroke:#ffcb05;}.cls-7{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 106.42,
    y1: 228.9,
    x2: 156.03,
    y2: 228.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d60f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#812990"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 289.62,
    y1: 228.9,
    x2: 339.23,
    y2: 228.9,
    xlinkHref: "#linear-gradient"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.13,
    y: 0.13,
    width: 155.91,
    height: 249.45
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "156.03 249.57 131.23 208.24 106.42 249.57 156.03 249.57"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55,70.64l-.91.13a3.28,3.28,0,0,1-.46.1c-.35,0-.53-.44-1-.54-.12,0,0,0-.18-.06s.06,0-.23-.12c0,.33-.07.24-.07.49a1.85,1.85,0,0,0,.2.83c.09.18.13.12.12.39a1.65,1.65,0,0,0,.14,1,2.91,2.91,0,0,1,.37.75c.48,0,.41,0,.47.14.45,0,.16-.1.41-.14,0,0,.47.11.35-.48.34.09.18.27.4.25s.09-.17.12-.38-.09-.06.23-.21l-.07-.41c0-.48.11,0,.28.07l.2-1.45c0-.11.15-.06-.13-.47C54.89,70.61,55.08,70.62,55,70.64Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.14,69.41c0,.19.11.11-.14.13l.28.61c.12-.06.08-.05.27-.06,0-.42,0-.27-.14-.48S55.32,69.45,55.14,69.41Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.7,68.86c-.07.28,0,0-.09.22s-.12.61.3.39C51.91,69,52,69,51.7,68.86Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.41,64a2.6,2.6,0,0,0-.84.13c-.5.13-.28.24-.12.48a3.07,3.07,0,0,0,1.19-.17c.23,0,.25,0,.12-.24h-.35Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.31,60.63a.86.86,0,0,0-.06-.23l-.78-.29c-.56-.21-1.12-.42-1.66-.64s-1.12-.46-1.75-.77-1.33-.67-2-1.1a4.59,4.59,0,0,1-1.66-1.89,5.88,5.88,0,0,1-.38-1h-.13a3.37,3.37,0,0,0-.75.1L50.4,55a9.6,9.6,0,0,1-1.92.37h-.25c-.24,0-.49,0-.73,0a4.63,4.63,0,0,1-.54,0,9.79,9.79,0,0,1-1.15-.21l-.4-.08-.32.36a1,1,0,0,1,.21.2A1.36,1.36,0,0,1,45.59,57a2.06,2.06,0,0,1-1.79,1.31l-.65,0H43a2.18,2.18,0,0,1-1.77-1.16,1.56,1.56,0,0,1,.13-1.72l0,0,.29-.43a4.15,4.15,0,0,0,.32-.5c.06-.12.12-.24.17-.36a2.35,2.35,0,0,1-2-1.5,4.67,4.67,0,0,1-.31-1.43l-.2.05-.31.08a3,3,0,0,1-.27.3,1.74,1.74,0,0,1-1.22.57,1.71,1.71,0,0,1-.49-.07h-.07a1.57,1.57,0,0,1-.92-.29,1.14,1.14,0,0,1-.51-.35,1.2,1.2,0,0,1-.23-1,4.48,4.48,0,0,1,.78-1.7l.1-.13a1.55,1.55,0,0,1,.48-1,6.4,6.4,0,0,1,.62-.56l.17-.14a2.69,2.69,0,0,1,.34-.27,2.08,2.08,0,0,1,.33-.91,3.86,3.86,0,0,1,1.13-1.11l.7-.41.35-.19.32-.19.18-.12a1.08,1.08,0,0,1,1-.06,1.07,1.07,0,0,1,.6,1.24s-.26.91-.35,1.2a2.71,2.71,0,0,1-.5.95c.22.14.48.31.74.51a5.16,5.16,0,0,1,.58.55h.45l.16,0A4,4,0,0,0,45,47.59l.16-.09a9.13,9.13,0,0,1,2.13-1,14.48,14.48,0,0,1,3.8-.54h.5c.7,0,1.41,0,2.06.07a12.36,12.36,0,0,1,1.58.21A9.26,9.26,0,0,1,59,47.87a.72.72,0,0,0-.37-.53c-.2-.09-.1,0-.24-.12l0,0-.16-.12c-.24-.15-.2,0-.29-.33l-.09,0,0,0c-.15,0-.1-.27-.24-.44s.06.13-.29,0c-.2-.09,0,0-.12-.08a.3.3,0,0,0-.14-.07l-.12,0c-.56-.23-.46-.32-.46-.89-.49-.13-.19-.5-.16-.82.06-.5-.25-.56-.12-1.1-.68,0-.41-.68-.6-1.4l0-.67c0-.14,0,.06.08-.19L55.37,41c-.65-.38-.52-.68-.71-.8l-.47.15c-.14.1,0,.07-.22.12-.45-.42-.24-1.31-.39-1.87-.06-.24-.11-.58-.43-.66a1,1,0,0,1,.2-.41c-.16-.08-.24-.06-.4-.14a2,2,0,0,0-.22-1.1c-.13-.22,0-.24-.34-.27-.08.32,0,.13-.34.27a1.86,1.86,0,0,1-.26,1.06l0,0-.06.08a1.34,1.34,0,0,0-.28.68h.2c0,.31,0,.13-.15.32s-.08,0,0,.34-.24.38-.21.76.11.17.1.42-.07.2-.06.39c0,.51.21.38,0,.87s-.15,1-.47,1.52a7.27,7.27,0,0,0-.35.75,1,1,0,0,1-.78.3,3.15,3.15,0,0,1-.69-.34c-.13-.07-.24-.11-.3-.24s0-.09-.08-.2c-.16-.35-.61-.32-.94-.44s-.44-.58-1.23-.89L46,41.55a2.79,2.79,0,0,1-.32-.23L45.41,41c-.08-.07-.22-.15-.32-.23l-.29-.18c-.28-.15-.24,0-.25-.38.16-.05.33-.33.46-.52s0,0,.08-.12l.06-.15s0,0,0,0l.14-.34c-.28-.11,0,0-.27-.07.11-.16.08-.07.14-.27.35-.17.26-.07.48,0,.41-.6.17-.22.26-.57s.28-.37.42-.59l-.25-.16c-.28-.15-.22.11-.22-.39a1.3,1.3,0,0,0-.56.41c-.07-.09-.07.14-.07-.2a1,1,0,0,1-.34.13c.2-.26.11,0,.21-.27a1.79,1.79,0,0,0-.9.34c-.17-.12-.27-.11-.34-.34-.34,0-.09,0-.41.14a1.59,1.59,0,0,0-.55-.28v-.13c-.36,0-.61.23-.92-.12,0,0-.15-.26-.18-.3-.25.07-.14.07-.34.21,0-.17-.09-.25-.31-.39s0,0-.14,0l-.38,0s.1,0-.2.06v.21c.26.07,0,0,.19.09l0,0,0,0c.2.09.22,0,.54,0a1.54,1.54,0,0,1,.13.62l-.5.17,0,0-.62.07c-.26,0-.17-.06-.27-.26l-.18.09-.17.1c-.2.15.1.06-.23.18a.69.69,0,0,1-.32,0c0,.18,0,.17-.15.39s0,.21-.33.24c0,.49.05.21.14.54l-.22.08c-.35.08-.18.08-.31.42s-.29.1-.43.74c.22.15.27.15.31.29a.54.54,0,0,1,0,.25c-.65,0-.36,0-.6,0a2.64,2.64,0,0,0-.77-.12c0,.5,0,.16-.14.29l0,0-.1.16c0-.47.1-.14.13-.54-.58-.16-.56-.78-1.14-.88s0-.14-.51-.15c-.12.25,0,.3-.27.48.07-.33,0-.11,0-.21-.25.06-.15.07-.34.21,0-.32-.08-.27-.35-.14.05.21,0,.15.21.21a.8.8,0,0,0-.15.41l-.4-.34c-.18.35,0,.23-.26.42l-.09,0a2.43,2.43,0,0,0-.2.14c.1.37.18.07.07.34-.24,0-.26.1-.42.31l0,0-.05.06a1.14,1.14,0,0,1-.11.11c-.1.09-.22.13-.25.34a.6.6,0,0,0,.17.39c-.15.18-.13.12-.14.41l-.3-.1c-.32-.07-.16.17-.25-.1h-.34c0,.46-.17.35-.07.55s.25.18.41.41c-.17.07-.06,0-.27,0,0,.36.08.12,0,.48-.21-.15-.1-.11-.34-.55s-.26-.15-.21-.62c-.29.08-.27.22-.41.42l-.33.35a1.2,1.2,0,0,0-.27.54c0,.2.12.31.12.68,0,0,0,0,0,0l.18,0c0,.15,0,.08-.1.18l-.06.07c-.1.11,0,0-.11.1l-.11.09-.05,0-.08.06c-.17.14-.13.16-.21.34l0,.09c-.41,1.09-.66,1.09-1.89,1.55-.23.08,0,0-.25.07s-.18-.16-.46,0-.05.16-.28.34-.39-.11-1,.55a.55.55,0,0,1-.42.17c-.35,0-.09-.2-.55.1,0-.36.08-.13-.13-.21-.06.22-.05.18-.23.32-.41.31-.08-.09-.68.56l-.07.07-.21.27-.06.08c-.32.36-1,.21-1,1.3H22A4.79,4.79,0,0,1,22,50a1.6,1.6,0,0,0-.49,1.23c.23.08.07-.11.19.17a1,1,0,0,1-.05.84,1.09,1.09,0,0,0-.14.38v.49c0,.16.07.11.23.3s.05.25.35.6l0,0c.08.1.09.14.17.25.27.35.39.17.39,1H22.5a1.1,1.1,0,0,0-.75-.89c0,.63.17.21.21.68-.16-.1-.07-.08-.27-.13,0,.35.06.12-.14.2.44.67,1.14.92,1.31,1.77.07.38.47.59.61.91s0,0,.11.22l.22.2a1,1,0,0,1,.23.59c.23,1.45,1.11,1.75,1.2,2.62V62c0,.31,0,.26.11.56s0,.4-.1.63a1.53,1.53,0,0,1-.4-.06c0,.49,0,1,.42.94s.78.7,1.73.54a3.64,3.64,0,0,0,1.05-.13c.27-.16.3-.32.4-.43l0,0,.1-.11.06-.07.21-.13c.16,0,.41,0,.48-.24,0,0,0-.11,0-.13.1-.38.65-.37,1-.49l.79-.11h.16c.25,0-.07,0,.18,0l.1,0,0,0c.24.11-.18.06.25.09.06-.15.15-.23.58-.22s.8.21,1-.72a.65.65,0,0,1,.13-.35c.17-.2.28-.11.56-.27,1.09-.63.66-.75,1.9-.77a3.69,3.69,0,0,0,1.32-.4c.8-.32.72-.55,2-.55a3.1,3.1,0,0,0,.78-.11c.31,0,.91.43,1.14.58.4-.1.19-.28.67,0,.29.17.49.11.84.19.09.21,0,0,0,.34.22,0,.22-.09.41,0-.06.16-.13.11-.17.26l.14.39c.17.15.3,0,.48.21s.11.29.36.6a1.14,1.14,0,0,1,.22.67s0,0,0,0h-.07l-.17.18c.41,0,.3.3.68.39.13,0,0,0,.14,0s0,0,.14.06l0-.27c-.05-.21,0-.27.4-.74s.73-.33.92-.68a1.72,1.72,0,0,1,.3-.51c.17-.18.05.07.15-.19l0,0,.06.08a1.16,1.16,0,0,1,.11.16c-.21,0-.17,0-.28.13.15.31.16.27,0,.46a1.63,1.63,0,0,0-.34,1.08c0,.4-.09.31-.47.31-.06.25-.11.19-.15.48a1.52,1.52,0,0,0,.49-.14c.29-.07.32.16.48-.2l.28-.82.13.21s0,0,0,0l.05.09a.08.08,0,0,1,0,0c.38.77-.25.79-.29,1.25a2.22,2.22,0,0,0,.68-.13s0,0,0,0,0,0,0,0c.43.36.88.83.69,1.46v0l0,.34a1.13,1.13,0,0,0,.29.43l.28.46c.22.24.53.13.77.41l.19.22c.21-.07.21-.15.42-.09l.15.06.06,0c.18,0,.09,0,.26.08s.7.39.76.54c.38,0,1.12-1,1.3-.27.35,0,.36-.24.63-.27l0,.09c-.09.2-.05-.12-.09.25l.32.29.1.1.21.08a.55.55,0,0,1,.12.29.34.34,0,0,0,.21-.49c.8,0,1-.8,1.89-.77.56,0,1,.19,1.4-.13l.14-.19c.1-.25,0-.31,0-.52l.36-1a1.35,1.35,0,0,1,.73-.89c.2-.17,0-.05.07-.18v0l0-.18a1.43,1.43,0,0,1,.37-.66c.41-.33.24-.56.84-1.21l.4-.23,0,0,.13-.1C60.49,61.58,60.41,61.1,60.31,60.63Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.09,44.66s0,0,0,0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42.74,49.06a7.34,7.34,0,0,0-.69-.68A10.11,10.11,0,0,0,41,47.69a1.67,1.67,0,0,0-.54-.2.72.72,0,0,0-.33,0,2.23,2.23,0,0,1,.57-.65,2.08,2.08,0,0,0,.76-1l.35-1.19,0,0-.53.32c-.34.2-.68.37-1,.58a2.64,2.64,0,0,0-.83.8,1.11,1.11,0,0,0-.16.83c0,.21-.1.21-.1.21a1.44,1.44,0,0,0-.61.36c-.24.21-.5.42-.73.65a.66.66,0,0,0-.19.37,1,1,0,0,1-.28.61,3.38,3.38,0,0,0-.61,1.3c0,.17,0,.23.22.2a.51.51,0,0,0,.56.21.09.09,0,0,1,.07,0c.36.17.53.14.86-.18a2.85,2.85,0,0,0,.23-.26c.16-.25.43-.27.68-.34a2,2,0,0,0,.85-.34s.19-.16.27,0a2.36,2.36,0,0,1,.34.44A2.07,2.07,0,0,1,41,51a4.08,4.08,0,0,0,.24,1.25,1.34,1.34,0,0,0,1.57.83,2.58,2.58,0,0,1,1.35,0l.27.11-.51,0c-.09,0-.13,0-.17.11-.24.56-.47,1.13-.75,1.68-.18.35-.44.67-.65,1s-.31.45-.16.69a1.21,1.21,0,0,0,1,.67c.23,0,.46,0,.7,0a1.07,1.07,0,0,0,.8-.59.37.37,0,0,0-.1-.39c-.07.18-.2.2-.35.22a.58.58,0,0,0-.23.1c0-.16.15-.15.28-.19l-.05-.3s-.06,0-.07.05a.34.34,0,0,1-.46.15l-.19-.06c-.2-.06-.24,0-.26.16a.92.92,0,0,1,0,.15.43.43,0,0,1,0-.54c.26-.32.52-.63.8-.93A10.23,10.23,0,0,0,45.61,53a1.09,1.09,0,0,0,.15-.39.77.77,0,0,0-.37-.81,7.31,7.31,0,0,0-1-.58A.67.67,0,0,1,44,50.4l.08.26c.08.25.31.32.5.43s.64.3.94.48a.94.94,0,0,1,.31,1.52c-.17.26-.33.53-.49.79-.06.1-.07.16.08.19.56.1,1.1.26,1.65.32a8.84,8.84,0,0,0,1.36,0,15.7,15.7,0,0,0,2.45-.52,3.73,3.73,0,0,1,1.45-.09s.06,0,.1,0c0-.27-.06-.52-.08-.77s0-.43-.07-.65a5.22,5.22,0,0,0-.5-2.09c-.06-.11-.14-.21-.22-.33a1.36,1.36,0,0,1,.47.42,2.47,2.47,0,0,1,.38,1c.13.63.2,1.27.31,1.9a7.24,7.24,0,0,0,.57,2,3.7,3.7,0,0,0,1.29,1.48c.63.38,1.28.72,1.94,1.05s1.11.51,1.68.74,1.41.54,2.12.8l1,.37a.62.62,0,0,1,.41.39l-.56-.28,0,0a5.72,5.72,0,0,1,.17.59c.11.53.2,1.06.29,1.6s.14.83.2,1.25c0,.23,0,.46,0,.7a1.45,1.45,0,0,0,.32,1l.22.2a7.08,7.08,0,0,1,1.2,1.47A1.15,1.15,0,0,0,64,67h.33a.17.17,0,0,0,0-.1.39.39,0,0,1,0-.52,1.77,1.77,0,0,0,.15-.38c0-.22-.11-.38-.22-.54l-.13-.17-.28.36,0,0a.64.64,0,0,0,.09-.73,1.13,1.13,0,0,0-.45-.62,1.11,1.11,0,0,1-.54-.93c-.07-.48-.12-1-.17-1.44a5.93,5.93,0,0,1-.06-.84c0-.41.08-.81.11-1.22a.9.9,0,0,0-.24-.66,5.6,5.6,0,0,0-1.12-.83c-.71-.49-1.42-1-2.09-1.51A9.65,9.65,0,0,1,57,54.21,3,3,0,0,1,56.61,53a1.92,1.92,0,0,1,.13-1A4.32,4.32,0,0,0,57,53.77c.37-.1.7-.24.76-.64a2.25,2.25,0,0,0,0-.73c0-.23.08-.36.31-.31a1.12,1.12,0,0,1,.71.54c.56.84,1.1,1.69,1.65,2.54.33.52.66,1,1,1.55.47.68.94,1.36,1.43,2a11.75,11.75,0,0,0,.87,1c.27.3.56.58.85.85A10,10,0,0,0,66.34,62,10.45,10.45,0,0,0,69,63.14a16.69,16.69,0,0,0,2,.42,8.22,8.22,0,0,0,1.64.1,11.18,11.18,0,0,0,1.74-.21,9.2,9.2,0,0,0,2.6-.89c.4-.2.77-.46,1.15-.69,0,0,.07,0,.07-.07a2.51,2.51,0,0,0,0-.27.58.58,0,0,0-.22,0l-.61.26a12.41,12.41,0,0,1-2.21.8,11.16,11.16,0,0,1-1.53.29,13.78,13.78,0,0,1-1.7,0A7.08,7.08,0,0,1,69,62a8.34,8.34,0,0,1-2-1.36l-.65-.62a14.69,14.69,0,0,1-1.55-1.89,28.8,28.8,0,0,1-1.65-2.71l-1.1-2a19,19,0,0,0-1.78-2.81,13.32,13.32,0,0,0-1.41-1.5A8,8,0,0,0,55,47.24a10,10,0,0,0-1.44-.2c-.82,0-1.65-.09-2.47-.06a13.54,13.54,0,0,0-3.53.49,9.16,9.16,0,0,0-2.06,1,4.73,4.73,0,0,1-1.4.61,1.57,1.57,0,0,1-.37,0,7.68,7.68,0,0,0-.83,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M132.83,38.21h-.55v1.56H132V38.21h-.56v-.33h1.43Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M134.86,37.88v1.89h-.32V38.43l-.63,1-.62-1v1.34H133V37.88h.35l.59.92.6-.92Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83,42.78v.61A4.61,4.61,0,0,0,82,42.81a4,4,0,0,0-1.39-.22,4.15,4.15,0,0,0-1.63.31,3.9,3.9,0,0,0-1.28.86A3.78,3.78,0,0,0,76.81,45a3.93,3.93,0,0,0-.31,1.57,4,4,0,0,0,1.16,2.83,4.06,4.06,0,0,0,1.28.86,4.15,4.15,0,0,0,1.63.31h.16a4.27,4.27,0,0,0,1.64-.31V48.13h0a2.29,2.29,0,0,1-.75.48,2.59,2.59,0,0,1-.88.16c-.13,0-.25,0-.37,0h0a3,3,0,0,1-.52-.13,2.15,2.15,0,0,1-.74-.48,2.1,2.1,0,0,1,0-3.09,2.28,2.28,0,0,1,.74-.47,2.43,2.43,0,0,1,.89-.17,2.26,2.26,0,0,1,1.63.64A2,2,0,0,1,83,46.6v4H85V42.78Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.9,50.6l-4.26-4.11V50.6H68.72V39.77h1.92v4.1l4.26-4.08h2.72L72,45.18l5.62,5.42Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90,42.59a3.48,3.48,0,0,1,1.43.28,3.17,3.17,0,0,1,1.1.77,3.45,3.45,0,0,1,.7,1.15,3.82,3.82,0,0,1,.25,1.4V50.6H91.51V46.19A1.62,1.62,0,0,0,91,44.93a1.94,1.94,0,0,0-2.64,0,1.64,1.64,0,0,0-.55,1.26V50.6H85.84V42.8h1.92v.58a3.41,3.41,0,0,1,1-.57A3.14,3.14,0,0,1,90,42.59Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116,42.8a3.49,3.49,0,0,1,1.29-.23v1.82a2.31,2.31,0,0,0-1.63.64,2.14,2.14,0,0,0-.67,1.56v4h-1.93V42.78H115v.6A3.7,3.7,0,0,1,116,42.8Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.64,42.59a4.29,4.29,0,0,1,1.65.31,4.16,4.16,0,0,1,1.34.86,4,4,0,0,1,.91,1.27,3.78,3.78,0,0,1,.33,1.57,3.69,3.69,0,0,1-.33,1.55,4,4,0,0,1-.91,1.28,4.34,4.34,0,0,1-1.34.86,4.55,4.55,0,0,1-3.3,0,4.34,4.34,0,0,1-1.34-.86,4,4,0,0,1-.91-1.28,3.69,3.69,0,0,1-.33-1.55,3.78,3.78,0,0,1,.33-1.57,4,4,0,0,1,.91-1.27A4.16,4.16,0,0,1,120,42.9,4.29,4.29,0,0,1,121.64,42.59Zm0,1.82a2.25,2.25,0,0,0-1.63.64,2.1,2.1,0,0,0,0,3.09,2.15,2.15,0,0,0,.74.48,2.65,2.65,0,0,0,.89.16,2.59,2.59,0,0,0,.88-.16,2.29,2.29,0,0,0,.75-.48,2.1,2.1,0,0,0,0-3.09A2.33,2.33,0,0,0,121.64,44.41Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.63,42.59a4.32,4.32,0,0,1,3,1.17,4.08,4.08,0,0,1,.9,1.27,3.78,3.78,0,0,1,.33,1.57,3.69,3.69,0,0,1-.33,1.55,4.12,4.12,0,0,1-.9,1.28,4.51,4.51,0,0,1-1.35.86,4.55,4.55,0,0,1-3.3,0,4.34,4.34,0,0,1-1.34-.86,4,4,0,0,1-.91-1.28,3.69,3.69,0,0,1-.33-1.55,3.78,3.78,0,0,1,.33-1.57,4,4,0,0,1,.91-1.27A4.16,4.16,0,0,1,129,42.9,4.32,4.32,0,0,1,130.63,42.59Zm0,1.82a2.26,2.26,0,0,0-1.63.64,2.12,2.12,0,0,0,0,3.09,2.15,2.15,0,0,0,.74.48,2.69,2.69,0,0,0,.89.16,2.55,2.55,0,0,0,.88-.16,2.44,2.44,0,0,0,.76-.48,2.12,2.12,0,0,0,0-3.09A2.36,2.36,0,0,0,130.63,44.41Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.08,42.78v.61a4.74,4.74,0,0,0-1.07-.58,4,4,0,0,0-1.4-.22,4.1,4.1,0,0,0-1.62.31,3.84,3.84,0,0,0-1.29.86,3.94,3.94,0,0,0-.85,1.27,4.1,4.1,0,0,0-.3,1.57A3.94,3.94,0,0,0,106,50.29a4.1,4.1,0,0,0,1.62.31h.16a4.24,4.24,0,0,0,1.64-.31V48.13h0a2.44,2.44,0,0,1-.76.48,2.55,2.55,0,0,1-.88.16l-.37,0h0a3,3,0,0,1-.52-.13,2.15,2.15,0,0,1-.74-.48,2.12,2.12,0,0,1,0-3.09,2.28,2.28,0,0,1,.74-.47,2.47,2.47,0,0,1,.89-.17,2.29,2.29,0,0,1,1.64.64,2,2,0,0,1,.67,1.55v4H112V42.78Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.76,42.78v.61a4.54,4.54,0,0,0-1.07-.58,3.67,3.67,0,0,0-.69-.17,4.43,4.43,0,0,0-.83-.07,3.92,3.92,0,0,0-1.59.31,3.72,3.72,0,0,0-1.25.86A3.87,3.87,0,0,0,94.52,45a4.29,4.29,0,0,0-.29,1.57h0a4,4,0,0,0,.3,1.55,4.15,4.15,0,0,0,.85,1.28,4.22,4.22,0,0,0,1.29.86,4.15,4.15,0,0,0,1.63.31h.28a4.24,4.24,0,0,0,1.52-.3V48.13h0a2.29,2.29,0,0,1-.75.48,2.59,2.59,0,0,1-.88.16c-.13,0-.25,0-.37,0h0a3,3,0,0,1-.52-.13,2.29,2.29,0,0,1-.75-.48,2.09,2.09,0,0,1-.67-1.55,2.17,2.17,0,0,1,.16-.81l0-.06a2.18,2.18,0,0,1,.48-.67,2.43,2.43,0,0,1,1.64-.64,2.26,2.26,0,0,1,1.63.64,2.06,2.06,0,0,1,.49.67l0,.06a2.25,2.25,0,0,1,.15.82v3a2,2,0,0,1-.67,1.54,2.24,2.24,0,0,1-1.63.65,2.22,2.22,0,0,1-1.15-.3l-1.4,1.31a4.3,4.3,0,0,0,1.19.6,4,4,0,0,0,1.36.22,4.29,4.29,0,0,0,1.65-.32,4.19,4.19,0,0,0,1.34-.87,3.88,3.88,0,0,0,.91-1.28,3.69,3.69,0,0,0,.33-1.55V42.78Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71,57.21v.51H68.72V54.81h2.15v.52H69.29v.73h1.32v.5H69.29v.65Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74.64,54.57v3.12h-.58v-.14a1.29,1.29,0,0,1-.65.17,1.16,1.16,0,0,1,0-2.32,1.4,1.4,0,0,1,.65.17v-1ZM74.06,57v-.9a.83.83,0,0,0-.55-.19.65.65,0,0,0-.67.64.63.63,0,0,0,.67.64A.83.83,0,0,0,74.06,57Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M78.3,55.45v2.24h-.57v-.15a1,1,0,0,1-.61.18c-.66,0-1-.3-1-1V55.45h.57v1.24c0,.35.17.52.49.52a.77.77,0,0,0,.51-.18V55.45Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M81.84,57.27a1.08,1.08,0,0,1-.87.45,1.16,1.16,0,1,1,0-2.31,1.07,1.07,0,0,1,.87.44l-.37.35a.59.59,0,0,0-.5-.28.65.65,0,1,0,0,1.29.59.59,0,0,0,.5-.28Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M85.51,55.45v2.24h-.57v-.16a1.22,1.22,0,0,1-.66.19,1.16,1.16,0,0,1,0-2.32,1.34,1.34,0,0,1,.66.19v-.14Zm-.57.67a.86.86,0,0,0-.55-.2.65.65,0,1,0,0,1.29.83.83,0,0,0,.55-.19Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M87.76,55.92v.8c0,.4.07.51.36.51l.26,0v.43a1.38,1.38,0,0,1-.52.08.64.64,0,0,1-.67-.7v-1.1h-.32v-.47h.32v-.87h.57v.87h.63v.47Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M89.76,54.91a.33.33,0,1,1,.33.33A.34.34,0,0,1,89.76,54.91Zm0,.57h.57v2.24h-.57Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M94.28,56.57a1.23,1.23,0,1,1-1.22-1.16A1.18,1.18,0,0,1,94.28,56.57Zm-.56,0a.66.66,0,1,0-.66.64A.65.65,0,0,0,93.72,56.57Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.86,56.47v1.25h-.58V56.47q0-.51-.48-.51a.71.71,0,0,0-.5.18v1.58h-.57V55.48h.57v.14a1.09,1.09,0,0,1,.6-.18C97.56,55.44,97.86,55.75,97.86,56.47Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M102.36,55.33v1h1.39v.51h-1.39v.85h-.57V54.81H104v.52Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107.69,56.57a1.23,1.23,0,1,1-1.23-1.16A1.19,1.19,0,0,1,107.69,56.57Zm-.57,0a.66.66,0,1,0-.66.64A.65.65,0,0,0,107.12,56.57Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111.25,55.45v2.24h-.58v-.15a1,1,0,0,1-.61.18c-.65,0-1-.3-1-1V55.45h.57v1.24c0,.35.17.52.49.52a.76.76,0,0,0,.5-.18V55.45Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M114.93,56.47v1.25h-.57V56.47a.44.44,0,0,0-.49-.51.71.71,0,0,0-.5.18v1.58h-.57V55.48h.57v.14a1.09,1.09,0,0,1,.6-.18C114.63,55.44,114.93,55.75,114.93,56.47Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118.72,54.57v3.12h-.58v-.14a1.29,1.29,0,0,1-.65.17,1.16,1.16,0,0,1,0-2.32,1.4,1.4,0,0,1,.65.17v-1ZM118.14,57v-.9a.83.83,0,0,0-.55-.19.65.65,0,0,0-.67.64.63.63,0,0,0,.67.64A.83.83,0,0,0,118.14,57Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M122.52,55.45v2.24h-.58v-.16a1.18,1.18,0,0,1-.65.19,1.16,1.16,0,0,1,0-2.32,1.33,1.33,0,0,1,.65.19v-.14Zm-.58.67a.86.86,0,0,0-.55-.2.65.65,0,1,0,0,1.29.83.83,0,0,0,.55-.19Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.77,55.92v.8c0,.4.06.51.35.51l.26,0v.43a1.33,1.33,0,0,1-.52.08.64.64,0,0,1-.67-.7v-1.1h-.32v-.47h.32v-.87h.58v.87h.62v.47Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.76,54.91a.33.33,0,1,1,.33.33A.34.34,0,0,1,126.76,54.91Zm0,.57h.57v2.24h-.57Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.29,56.57a1.23,1.23,0,1,1-1.23-1.16A1.19,1.19,0,0,1,131.29,56.57Zm-.57,0a.66.66,0,1,0-.66.64A.65.65,0,0,0,130.72,56.57Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.86,56.47v1.25h-.57V56.47a.44.44,0,0,0-.49-.51.71.71,0,0,0-.5.18v1.58h-.57V55.48h.57v.14a1.11,1.11,0,0,1,.6-.18C134.56,55.44,134.86,55.75,134.86,56.47Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M26.55,105.19v-3.85l-1.5,3.85h-.5l-1.5-3.85v3.85H21.91V99.85H23.5l1.3,3.34,1.29-3.34h1.6v5.34Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31.05,105.19v-.41a1.59,1.59,0,0,1-1.23.5A1.28,1.28,0,0,1,28.49,104a1.22,1.22,0,0,1,1.33-1.24,1.58,1.58,0,0,1,1.23.47v-.49c0-.39-.34-.65-.85-.65a1.6,1.6,0,0,0-1.11.46l-.4-.71a2.47,2.47,0,0,1,1.69-.61c.88,0,1.69.35,1.69,1.46v2.5Zm0-.93v-.48a1,1,0,0,0-.82-.34c-.4,0-.73.21-.73.58s.33.58.73.58A1,1,0,0,0,31.05,104.26Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M35.69,105.19v-2.35c0-.54-.28-.71-.71-.71a1.12,1.12,0,0,0-.88.45v2.61h-1V99.85h1v2a1.77,1.77,0,0,1,1.35-.59,1.1,1.1,0,0,1,1.25,1.21v2.75Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37.46,103.25a2,2,0,0,1,2-2,1.93,1.93,0,0,1,1.94,2.12v.24H38.53a1,1,0,0,0,1.11.86,1.58,1.58,0,0,0,1-.37l.46.67a2.42,2.42,0,0,1-1.59.53A2,2,0,0,1,37.46,103.25Zm2-1.19a.89.89,0,0,0-.94.82h1.9A.88.88,0,0,0,39.46,102.06Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41.8,104.68l.44-.73a2.21,2.21,0,0,0,1.34.53c.44,0,.64-.16.64-.4,0-.64-2.28-.12-2.28-1.64,0-.64.56-1.21,1.58-1.21a2.41,2.41,0,0,1,1.55.53l-.41.72a1.66,1.66,0,0,0-1.14-.45c-.37,0-.61.16-.61.37,0,.57,2.3.09,2.3,1.65,0,.71-.61,1.23-1.68,1.23A2.59,2.59,0,0,1,41.8,104.68Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M48.57,105.19v-2.35c0-.54-.28-.71-.71-.71a1.12,1.12,0,0,0-.88.45v2.61H46V99.85h1v2a1.77,1.77,0,0,1,1.35-.59,1.11,1.11,0,0,1,1.25,1.21v2.75Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M52.67,105.19V99.85h2.81A1.38,1.38,0,0,1,57,101.21a1.19,1.19,0,0,1-.92,1.23,1.28,1.28,0,0,1,1,1.3,1.4,1.4,0,0,1-1.55,1.45Zm3.18-3.78a.56.56,0,0,0-.62-.56H53.81V102h1.42A.55.55,0,0,0,55.85,101.41Zm.11,2.17a.61.61,0,0,0-.68-.61H53.81v1.22h1.47A.6.6,0,0,0,56,103.58Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M60.27,105.19v-.41a1.57,1.57,0,0,1-1.22.5A1.28,1.28,0,0,1,57.71,104a1.22,1.22,0,0,1,1.34-1.24,1.54,1.54,0,0,1,1.22.47v-.49c0-.39-.33-.65-.85-.65a1.62,1.62,0,0,0-1.11.46l-.4-.71a2.47,2.47,0,0,1,1.69-.61c.89,0,1.69.35,1.69,1.46v2.5Zm0-.93v-.48a1,1,0,0,0-.81-.34c-.4,0-.73.21-.73.58s.33.58.73.58A1,1,0,0,0,60.27,104.26Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M62.3,105.19V99.85h1v2a1.48,1.48,0,0,1,1.19-.59c1,0,1.71.77,1.71,2s-.73,2-1.71,2a1.49,1.49,0,0,1-1.19-.59v.5Zm1.89-.81a1.14,1.14,0,0,0,0-2.25,1.14,1.14,0,0,0-.88.45V104A1.15,1.15,0,0,0,64.19,104.38Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M69.59,105.19v-.49a1.82,1.82,0,0,1-1.36.58A1.1,1.1,0,0,1,67,104.07v-2.74h1v2.34a.62.62,0,0,0,.71.71,1.16,1.16,0,0,0,.88-.44v-2.61h1v3.86Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M74.93,105.19v-4.34H73.37v-1h4.25v1H76.07v4.34Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M78.23,100.3a.61.61,0,1,1,.6.61A.6.6,0,0,1,78.23,100.3Zm.1,4.89v-3.86h1v3.86Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M85.14,105.19v-2.44c0-.36-.16-.62-.57-.62a1,1,0,0,0-.8.45v2.61h-1v-2.44c0-.36-.16-.62-.57-.62a1,1,0,0,0-.8.45v2.61h-1v-3.86h1v.49a1.74,1.74,0,0,1,1.26-.59,1,1,0,0,1,1.07.69,1.68,1.68,0,0,1,1.33-.69,1,1,0,0,1,1.13,1.17v2.79Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M89.49,105.19v-.41a1.57,1.57,0,0,1-1.22.5A1.28,1.28,0,0,1,86.94,104a1.22,1.22,0,0,1,1.33-1.24,1.54,1.54,0,0,1,1.22.47v-.49c0-.39-.33-.65-.84-.65a1.6,1.6,0,0,0-1.11.46l-.4-.71a2.46,2.46,0,0,1,1.68-.61c.89,0,1.7.35,1.7,1.46v2.5Zm0-.93v-.48a1,1,0,0,0-.81-.34c-.4,0-.73.21-.73.58s.33.58.73.58A1,1,0,0,0,89.49,104.26Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M91.52,105.19V99.85h1v5.34Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M93.21,104.68l.44-.73a2.18,2.18,0,0,0,1.33.53c.44,0,.65-.16.65-.4,0-.64-2.29-.12-2.29-1.64,0-.64.56-1.21,1.59-1.21a2.45,2.45,0,0,1,1.55.53l-.41.72a1.66,1.66,0,0,0-1.14-.45c-.37,0-.61.16-.61.37,0,.57,2.29.09,2.29,1.65,0,.71-.6,1.23-1.67,1.23A2.57,2.57,0,0,1,93.21,104.68Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M97.26,100.3a.61.61,0,1,1,.6.61A.61.61,0,0,1,97.26,100.3Zm.1,4.89v-3.86h1v3.86Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M102,105.19v-2.34a.63.63,0,0,0-.71-.72,1.15,1.15,0,0,0-.88.45v2.61h-1v-3.86h1v.49a1.81,1.81,0,0,1,1.35-.59,1.12,1.12,0,0,1,1.26,1.23v2.73Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M106.33,105.19v-.41a1.57,1.57,0,0,1-1.22.5,1.28,1.28,0,0,1-1.33-1.28,1.22,1.22,0,0,1,1.33-1.24,1.54,1.54,0,0,1,1.22.47v-.49c0-.39-.33-.65-.84-.65a1.6,1.6,0,0,0-1.11.46l-.4-.71a2.46,2.46,0,0,1,1.68-.61c.89,0,1.7.35,1.7,1.46v2.5Zm0-.93v-.48a1,1,0,0,0-.81-.34c-.4,0-.73.21-.73.58s.33.58.73.58A1,1,0,0,0,106.33,104.26Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M22,114.19v-5h3.28v.56H22.59v1.61H25.2v.55H22.59v2.29Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25.87,112.37a1.8,1.8,0,1,1,1.79,1.91A1.78,1.78,0,0,1,25.87,112.37Zm3,0a1.22,1.22,0,1,0-1.21,1.4A1.26,1.26,0,0,0,28.87,112.37Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32.82,114.19v-.51a1.8,1.8,0,0,1-1.29.6,1,1,0,0,1-1.16-1.16v-2.56h.56V113c0,.64.33.82.82.82a1.39,1.39,0,0,0,1.07-.54v-2.67h.56v3.63Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37,114.19v-2.38c0-.64-.33-.84-.82-.84a1.38,1.38,0,0,0-1.07.57v2.65H34.5v-3.63h.57v.53a1.76,1.76,0,0,1,1.29-.62,1,1,0,0,1,1.15,1.17v2.55Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41.27,114.19v-.54a1.54,1.54,0,0,1-1.22.63c-.95,0-1.62-.72-1.62-1.9s.67-1.91,1.62-1.91a1.51,1.51,0,0,1,1.22.64v-1.93h.56v5Zm0-1v-1.64a1.33,1.33,0,0,0-1.08-.59c-.74,0-1.17.6-1.17,1.41s.43,1.39,1.17,1.39A1.34,1.34,0,0,0,41.27,113.2Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42.75,112.37a1.81,1.81,0,0,1,1.78-1.9,1.76,1.76,0,0,1,1.74,2v.14H43.35a1.26,1.26,0,0,0,1.29,1.25,1.56,1.56,0,0,0,1.13-.46l.27.36a2,2,0,0,1-1.44.57A1.8,1.8,0,0,1,42.75,112.37Zm1.77-1.43a1.2,1.2,0,0,0-1.18,1.2h2.38A1.17,1.17,0,0,0,44.52,110.94Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47.18,114.19v-3.63h.56v.58a1.54,1.54,0,0,1,1.21-.66v.58l-.22,0a1.35,1.35,0,0,0-1,.58v2.57Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M54.85,114.19c-.15-.13-.34-.33-.54-.53a2,2,0,0,1-1.45.62,1.4,1.4,0,0,1-1.55-1.4,1.69,1.69,0,0,1,1.1-1.49,2.45,2.45,0,0,1-.38-1.13,1.19,1.19,0,0,1,1.26-1.16,1,1,0,0,1,1.13,1c0,.75-.64,1.08-1.28,1.41.2.27.42.52.59.71s.4.46.59.67a5,5,0,0,0,.54-1.15l.48.22a6.2,6.2,0,0,1-.68,1.29c.3.31.61.61,1,1Zm-.88-.87c-.29-.3-.55-.59-.69-.76a8.91,8.91,0,0,1-.63-.8,1.26,1.26,0,0,0-.74,1.08,1,1,0,0,0,1,1A1.47,1.47,0,0,0,54,113.32Zm-1.06-2.18c.53-.26,1-.53,1-1a.55.55,0,0,0-.59-.57.7.7,0,0,0-.7.74A1.86,1.86,0,0,0,52.91,111.14Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58.17,111.69a2.51,2.51,0,0,1,2.58-2.59,2.23,2.23,0,0,1,1.9,1l-.52.29a1.68,1.68,0,0,0-1.38-.73,2,2,0,0,0,0,4.07,1.71,1.71,0,0,0,1.38-.73l.52.29a2.24,2.24,0,0,1-1.9,1A2.51,2.51,0,0,1,58.17,111.69Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M63.44,114.19v-5h3.29v.56H64.07v1.61h2.6v.55h-2.6v1.73h2.66v.56Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M67.51,111.69A2.49,2.49,0,1,1,70,114.28,2.45,2.45,0,0,1,67.51,111.69Zm4.33,0a1.85,1.85,0,1,0-1.85,2A1.87,1.87,0,0,0,71.84,111.69Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M23.21,136.19v-4.45H21.63v-.56h3.79v.56H23.83v4.45Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25.74,132.92a.41.41,0,0,1,.41-.41.41.41,0,1,1,0,.82A.41.41,0,0,1,25.74,132.92Zm0,2.93a.41.41,0,0,1,.41-.41.41.41,0,0,1,.41.41.42.42,0,0,1-.41.41A.41.41,0,0,1,25.74,135.85Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31,133.85v1.6h-.43v-1.6H29.13v-.39h1.44v-1.55H31v1.55h1.44v.39Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M33.29,135.67l.31-.47a1.31,1.31,0,0,0,1.08.51c1,0,1.41-1,1.41-2a1.41,1.41,0,0,0,0-.2,1.78,1.78,0,0,1-1.41.78,1.52,1.52,0,0,1-1.64-1.6,1.64,1.64,0,0,1,1.75-1.63c1.4,0,1.94,1.22,1.94,2.59s-.64,2.58-2,2.58A1.76,1.76,0,0,1,33.29,135.67ZM36.07,133a1.35,1.35,0,0,0-1.27-1.39,1.08,1.08,0,0,0-1.14,1.06,1,1,0,0,0,1.15,1.08A1.54,1.54,0,0,0,36.07,133Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M38,136.19l2-4.45h-2.7v-.56h3.42v.43l-2.05,4.58Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41.86,136.19l2-4.45h-2.7v-.56H44.6v.43l-2.05,4.58Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45,134.62v-.5h1.8v.5Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47.7,135.67l.31-.47a1.3,1.3,0,0,0,1.07.51c1,0,1.42-1,1.42-2a1.41,1.41,0,0,0,0-.2,1.8,1.8,0,0,1-1.41.78,1.52,1.52,0,0,1-1.65-1.6,1.65,1.65,0,0,1,1.76-1.63c1.4,0,1.94,1.22,1.94,2.59s-.64,2.58-2.05,2.58A1.76,1.76,0,0,1,47.7,135.67ZM50.47,133c-.06-.61-.39-1.39-1.26-1.39a1.09,1.09,0,0,0-1.15,1.06,1,1,0,0,0,1.16,1.08A1.54,1.54,0,0,0,50.47,133Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51.89,134.92a1.49,1.49,0,0,1,1.19-1.32A1.31,1.31,0,0,1,52,132.4c0-.9.88-1.3,1.71-1.3s1.72.4,1.72,1.3a1.32,1.32,0,0,1-1.12,1.2,1.49,1.49,0,0,1,1.2,1.32c0,.85-.81,1.36-1.8,1.36S51.89,135.77,51.89,134.92Zm3-.07c0-.65-.86-.93-1.17-1s-1.16.32-1.16,1,.54.87,1.16.87S54.85,135.39,54.85,134.85Zm-.08-2.36c0-.52-.49-.83-1.09-.83s-1.08.31-1.08.83.78.81,1.08.86S54.77,133.09,54.77,132.49Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M56.24,133.69c0-1.23.55-2.59,1.92-2.59s1.91,1.36,1.91,2.59-.54,2.59-1.91,2.59S56.24,134.9,56.24,133.69Zm3.2,0c0-1-.33-2-1.28-2s-1.28,1-1.28,2,.33,2,1.28,2S59.44,134.69,59.44,133.69Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M61.79,136.19V132l-.81.85-.37-.38,1.25-1.29h.55v5Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M63.4,136.19v-.51c1.8-1.41,2.78-2.24,2.78-3.1a.94.94,0,0,0-1.05-.92,1.7,1.7,0,0,0-1.36.63l-.38-.4a2.15,2.15,0,0,1,1.74-.79,1.53,1.53,0,0,1,1.69,1.48c0,1-1,1.95-2.44,3h2.46v.56Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M67.79,133.69c0-1.23.54-2.59,1.91-2.59s1.92,1.36,1.92,2.59-.55,2.59-1.92,2.59S67.79,134.9,67.79,133.69Zm3.19,0c0-1-.33-2-1.28-2s-1.28,1-1.28,2,.33,2,1.28,2S71,134.69,71,133.69Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M72.38,134.92a1.49,1.49,0,0,1,1.2-1.32,1.31,1.31,0,0,1-1.11-1.2c0-.9.88-1.3,1.71-1.3s1.72.4,1.72,1.3a1.32,1.32,0,0,1-1.12,1.2A1.49,1.49,0,0,1,76,134.92c0,.85-.81,1.36-1.79,1.36S72.38,135.77,72.38,134.92Zm3-.07c0-.65-.85-.93-1.16-1s-1.17.32-1.17,1,.55.87,1.17.87S75.34,135.39,75.34,134.85Zm-.07-2.36c0-.52-.49-.83-1.09-.83s-1.08.31-1.08.83.78.81,1.08.86S75.27,133.09,75.27,132.49Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.85,135.47l.39-.42a1.63,1.63,0,0,0,1.38.67,1.07,1.07,0,0,0,1.15-1.07,1.05,1.05,0,0,0-1.14-1.08,1.61,1.61,0,0,0-1.16.46l-.46-.15v-2.7h3.07v.56H77.64v1.74a1.68,1.68,0,0,1,1.17-.45,1.53,1.53,0,0,1,1.6,1.6,1.66,1.66,0,0,1-1.79,1.65A2.06,2.06,0,0,1,76.85,135.47Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M81,135.45l.37-.39a1.73,1.73,0,0,0,1.4.66c.72,0,1.17-.37,1.17-.94s-.51-.88-1.25-.88h-.52v-.57h.52c.63,0,1.16-.25,1.16-.82s-.51-.86-1.11-.86a1.71,1.71,0,0,0-1.33.61l-.34-.39a2.17,2.17,0,0,1,1.72-.78c1,0,1.69.49,1.69,1.33a1.22,1.22,0,0,1-1.08,1.17,1.27,1.27,0,0,1,1.16,1.24c0,.83-.68,1.44-1.78,1.44A2.12,2.12,0,0,1,81,135.45Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M85.46,135.47l.38-.42a1.63,1.63,0,0,0,1.38.67,1.08,1.08,0,0,0,1.16-1.07,1.06,1.06,0,0,0-1.15-1.08,1.61,1.61,0,0,0-1.16.46l-.46-.15v-2.7h3.07v.56H86.24v1.74a1.72,1.72,0,0,1,1.17-.45,1.53,1.53,0,0,1,1.6,1.6,1.65,1.65,0,0,1-1.79,1.65A2,2,0,0,1,85.46,135.47Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M22,145.19v-5h3.28v.56H22.59v1.61H25.2v.55H22.59v1.73h2.66v.56Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M26.1,141.92a.42.42,0,1,1,.42.41A.42.42,0,0,1,26.1,141.92Zm0,2.93a.42.42,0,0,1,.83,0,.42.42,0,0,1-.83,0Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34.22,145.19v-2.47c0-.45-.19-.75-.67-.75a1.27,1.27,0,0,0-1,.56v2.66H32v-2.47c0-.45-.19-.75-.67-.75a1.24,1.24,0,0,0-.95.57v2.65h-.56v-3.63h.56v.53a1.57,1.57,0,0,1,1.18-.62.94.94,0,0,1,1,.68,1.52,1.52,0,0,1,1.21-.68c.66,0,1,.37,1,1.1v2.62Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M38.17,145.19v-.42a1.55,1.55,0,0,1-1.2.51,1.21,1.21,0,0,1-1.26-1.2,1.18,1.18,0,0,1,1.26-1.2,1.53,1.53,0,0,1,1.2.49v-.65c0-.48-.39-.76-.91-.76a1.41,1.41,0,0,0-1.11.5l-.27-.39a1.92,1.92,0,0,1,1.45-.6c.77,0,1.41.35,1.41,1.22v2.5Zm0-.77v-.69a1.23,1.23,0,0,0-1-.44.8.8,0,1,0,0,1.58A1.21,1.21,0,0,0,38.17,144.42Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42.32,145.19V142.8c0-.65-.32-.83-.82-.83a1.38,1.38,0,0,0-1.06.57v2.65h-.57v-5h.57v1.91a1.72,1.72,0,0,1,1.29-.62,1,1,0,0,1,1.15,1.16v2.56Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M43.79,143.37a1.82,1.82,0,0,1,1.79-1.9,1.76,1.76,0,0,1,1.74,1.95v.14H44.4a1.26,1.26,0,0,0,1.29,1.25,1.58,1.58,0,0,0,1.13-.46l.27.36a2,2,0,0,1-1.44.57A1.81,1.81,0,0,1,43.79,143.37Zm1.78-1.43a1.2,1.2,0,0,0-1.18,1.2h2.38A1.17,1.17,0,0,0,45.57,141.94Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47.92,144.71l.28-.41a1.66,1.66,0,0,0,1.2.52c.55,0,.86-.26.86-.62,0-.88-2.24-.34-2.24-1.69,0-.57.48-1,1.34-1a1.77,1.77,0,0,1,1.34.53l-.26.39a1.38,1.38,0,0,0-1.08-.46c-.49,0-.8.25-.8.57,0,.79,2.24.27,2.24,1.68,0,.61-.49,1.1-1.42,1.1A2,2,0,0,1,47.92,144.71Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M54.17,145.19V142.8c0-.65-.32-.83-.82-.83a1.38,1.38,0,0,0-1.06.57v2.65h-.57v-5h.57v1.91a1.72,1.72,0,0,1,1.29-.62,1,1,0,0,1,1.15,1.16v2.56Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M55.55,143.36a3,3,0,0,1,3-3,2.3,2.3,0,0,1,2.37,2.38c0,1.17-.67,1.77-1.3,1.77a.64.64,0,0,1-.68-.61v-.05a1.55,1.55,0,0,1-1.2.66,1.12,1.12,0,0,1-1.14-1.22,1.88,1.88,0,0,1,1.76-1.89,1,1,0,0,1,1,.59l.1-.47h.51l-.43,2a.76.76,0,0,0,0,.15.35.35,0,0,0,.35.39c.29,0,.82-.33.82-1.36a2,2,0,0,0-2.13-2.13,2.77,2.77,0,0,0-2.69,2.69A2.08,2.08,0,0,0,58,145.46a2.51,2.51,0,0,0,1.4-.42l.14.2a2.92,2.92,0,0,1-1.57.47A2.32,2.32,0,0,1,55.55,143.36Zm3.44.09.22-1a.82.82,0,0,0-.77-.55,1.41,1.41,0,0,0-1.32,1.43.75.75,0,0,0,.76.84A1.41,1.41,0,0,0,59,143.45Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64.2,145.19l-1.3-1.63-.61.59v1h-.56v-5h.56v3.31l1.91-1.93h.71l-1.61,1.65,1.62,2Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M67.85,145.19v-.42a1.55,1.55,0,0,1-1.2.51,1.21,1.21,0,0,1-1.26-1.2,1.18,1.18,0,0,1,1.26-1.2,1.54,1.54,0,0,1,1.2.49v-.65c0-.48-.39-.76-.92-.76a1.44,1.44,0,0,0-1.11.5l-.26-.39a1.92,1.92,0,0,1,1.45-.6c.77,0,1.4.35,1.4,1.22v2.5Zm0-.77v-.69a1.23,1.23,0,0,0-1-.44.8.8,0,1,0,0,1.58A1.21,1.21,0,0,0,67.85,144.42Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M72,145.19v-2.38c0-.64-.33-.84-.82-.84a1.38,1.38,0,0,0-1.07.57v2.65h-.57v-3.63h.57v.53a1.76,1.76,0,0,1,1.29-.62,1,1,0,0,1,1.15,1.17v2.55Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M73.67,146.11l.29-.4a1.4,1.4,0,0,0,1.18.48,1,1,0,0,0,1.17-1.06v-.54a1.55,1.55,0,0,1-1.22.64,1.65,1.65,0,0,1-1.62-1.87c0-1.17.66-1.89,1.62-1.89a1.51,1.51,0,0,1,1.22.64v-.55h.56v3.57c0,1.15-.85,1.53-1.73,1.53A1.86,1.86,0,0,1,73.67,146.11Zm2.64-2v-1.59a1.37,1.37,0,0,0-1.08-.58c-.74,0-1.17.58-1.17,1.39s.43,1.37,1.17,1.37A1.35,1.35,0,0,0,76.31,144.14Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M80.26,145.19v-.42a1.55,1.55,0,0,1-1.2.51,1.21,1.21,0,0,1-1.26-1.2,1.18,1.18,0,0,1,1.26-1.2,1.53,1.53,0,0,1,1.2.49v-.65c0-.48-.39-.76-.91-.76a1.44,1.44,0,0,0-1.12.5l-.26-.39a1.92,1.92,0,0,1,1.45-.6c.77,0,1.4.35,1.4,1.22v2.5Zm0-.77v-.69a1.23,1.23,0,0,0-1-.44.8.8,0,1,0,0,1.58A1.21,1.21,0,0,0,80.26,144.42Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M82,145.19v-3.63h.57v.58a1.54,1.54,0,0,1,1.21-.66v.58l-.22,0a1.33,1.33,0,0,0-1,.58v2.57Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.22,143.37A1.8,1.8,0,1,1,86,145.28,1.78,1.78,0,0,1,84.22,143.37Zm3,0a1.21,1.21,0,1,0-1.2,1.4A1.26,1.26,0,0,0,87.21,143.37Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M88.51,143.37a1.8,1.8,0,1,1,1.79,1.91A1.78,1.78,0,0,1,88.51,143.37Zm3,0a1.21,1.21,0,1,0-1.2,1.4A1.26,1.26,0,0,0,91.5,143.37Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M92.8,143.37a1.81,1.81,0,0,1,1.79-1.9,1.77,1.77,0,0,1,1.74,1.95v.14H93.4a1.27,1.27,0,0,0,1.3,1.25,1.56,1.56,0,0,0,1.12-.46l.27.36a2,2,0,0,1-1.44.57A1.8,1.8,0,0,1,92.8,143.37Zm1.78-1.43a1.21,1.21,0,0,0-1.19,1.2h2.38A1.17,1.17,0,0,0,94.58,141.94Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M99.86,145.19v-.54a1.54,1.54,0,0,1-1.22.63c-1,0-1.62-.72-1.62-1.9s.67-1.91,1.62-1.91a1.51,1.51,0,0,1,1.22.64v-1.93h.56v5Zm0-1v-1.64a1.35,1.35,0,0,0-1.08-.59c-.74,0-1.17.6-1.17,1.41s.43,1.39,1.17,1.39A1.36,1.36,0,0,0,99.86,144.2Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M104,145.19v-.51a1.8,1.8,0,0,1-1.29.6,1,1,0,0,1-1.16-1.16v-2.56h.57V144c0,.64.32.82.82.82a1.38,1.38,0,0,0,1.06-.54v-2.67h.56v3.63Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M105.56,144.85a.42.42,0,0,1,.83,0,.42.42,0,0,1-.83,0Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M107.15,143.37a1.79,1.79,0,0,1,1.81-1.9,1.53,1.53,0,0,1,1.32.63l-.37.34A1.07,1.07,0,0,0,109,142a1.41,1.41,0,0,0,0,2.8,1.1,1.1,0,0,0,.92-.47l.37.35a1.53,1.53,0,0,1-1.32.63A1.8,1.8,0,0,1,107.15,143.37Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M110.87,143.37a1.79,1.79,0,1,1,1.79,1.91A1.78,1.78,0,0,1,110.87,143.37Zm3,0a1.21,1.21,0,1,0-1.2,1.4A1.26,1.26,0,0,0,113.86,143.37Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M119.74,145.19v-2.47c0-.45-.19-.75-.66-.75a1.27,1.27,0,0,0-1,.56v2.66h-.56v-2.47c0-.45-.19-.75-.67-.75a1.24,1.24,0,0,0-.95.57v2.65h-.56v-3.63h.56v.53a1.57,1.57,0,0,1,1.18-.62.93.93,0,0,1,1,.68,1.52,1.52,0,0,1,1.21-.68c.66,0,1,.37,1,1.1v2.62Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M22,167.19v-5h2a1.51,1.51,0,1,1,0,3H22.59v2Zm2.94-3.5a.93.93,0,0,0-1-.95H22.59v1.9h1.32A.93.93,0,0,0,24.91,163.69Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M28.47,167.19v-.42a1.57,1.57,0,0,1-1.2.51,1.21,1.21,0,0,1-1.26-1.2,1.18,1.18,0,0,1,1.26-1.2,1.54,1.54,0,0,1,1.2.49v-.65c0-.48-.39-.76-.92-.76a1.42,1.42,0,0,0-1.11.5l-.26-.39a1.91,1.91,0,0,1,1.45-.6c.77,0,1.4.35,1.4,1.22v2.5Zm0-.77v-.69a1.23,1.23,0,0,0-1-.44.8.8,0,1,0,0,1.58A1.21,1.21,0,0,0,28.47,166.42Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32.79,167.19v-.54a1.55,1.55,0,0,1-1.23.63c-.94,0-1.61-.72-1.61-1.9s.67-1.91,1.61-1.91a1.52,1.52,0,0,1,1.23.64v-1.93h.56v5Zm0-1v-1.64a1.35,1.35,0,0,0-1.08-.59c-.74,0-1.17.6-1.17,1.41s.43,1.39,1.17,1.39A1.36,1.36,0,0,0,32.79,166.2Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M38.85,167.19v-2.47c0-.45-.2-.75-.67-.75a1.27,1.27,0,0,0-1,.56v2.66h-.56v-2.47c0-.45-.19-.75-.67-.75a1.24,1.24,0,0,0-1,.57v2.65h-.57v-3.63H35v.53a1.53,1.53,0,0,1,1.17-.62.92.92,0,0,1,1,.68,1.54,1.54,0,0,1,1.22-.68c.66,0,1,.37,1,1.1v2.62Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M40.32,165.37a1.8,1.8,0,1,1,1.8,1.91A1.78,1.78,0,0,1,40.32,165.37Zm3,0a1.21,1.21,0,1,0-1.2,1.4A1.26,1.26,0,0,0,43.32,165.37Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47.45,167.19v-.54a1.54,1.54,0,0,1-1.22.63c-.95,0-1.62-.72-1.62-1.9s.67-1.91,1.62-1.91a1.51,1.51,0,0,1,1.22.64v-1.93H48v5Zm0-1v-1.64a1.33,1.33,0,0,0-1.08-.59c-.74,0-1.17.6-1.17,1.41s.43,1.39,1.17,1.39A1.34,1.34,0,0,0,47.45,166.2Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51.4,167.19v-.42a1.55,1.55,0,0,1-1.2.51,1.21,1.21,0,0,1-1.26-1.2,1.18,1.18,0,0,1,1.26-1.2,1.53,1.53,0,0,1,1.2.49v-.65c0-.48-.39-.76-.91-.76a1.41,1.41,0,0,0-1.11.5l-.27-.39a1.92,1.92,0,0,1,1.45-.6c.78,0,1.41.35,1.41,1.22v2.5Zm0-.77v-.69a1.22,1.22,0,0,0-1-.44.8.8,0,1,0,0,1.58A1.2,1.2,0,0,0,51.4,166.42Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M53,168.1a1.13,1.13,0,0,0,.31.06.53.53,0,0,0,.54-.39l.24-.55-1.51-3.66h.61l1.2,3,1.21-3h.61l-1.82,4.36a1.07,1.07,0,0,1-1.06.74,1.77,1.77,0,0,1-.41,0Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M59,167.19v-.42a1.58,1.58,0,0,1-1.2.51,1.21,1.21,0,0,1-1.26-1.2,1.18,1.18,0,0,1,1.26-1.2,1.55,1.55,0,0,1,1.2.49v-.65c0-.48-.39-.76-.92-.76a1.42,1.42,0,0,0-1.11.5l-.26-.39a1.91,1.91,0,0,1,1.45-.6c.77,0,1.4.35,1.4,1.22v2.5Zm0-.77v-.69a1.23,1.23,0,0,0-1-.44.8.8,0,1,0,0,1.58A1.21,1.21,0,0,0,59,166.42Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M67,167.19V163l-1.69,4.21H65L63.32,163v4.21H62.7v-5h.89L65.15,166l1.55-3.86h.9v5Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M68.53,165.37a1.8,1.8,0,1,1,1.79,1.91A1.78,1.78,0,0,1,68.53,165.37Zm3,0a1.22,1.22,0,1,0-1.21,1.4A1.26,1.26,0,0,0,71.53,165.37Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M75.66,167.19v-.54a1.56,1.56,0,0,1-1.23.63c-.94,0-1.61-.72-1.61-1.9s.67-1.91,1.61-1.91a1.53,1.53,0,0,1,1.23.64v-1.93h.56v5Zm0-1v-1.64a1.35,1.35,0,0,0-1.08-.59c-.74,0-1.17.6-1.17,1.41s.43,1.39,1.17,1.39A1.36,1.36,0,0,0,75.66,166.2Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M77.13,165.37a1.81,1.81,0,0,1,1.79-1.9,1.76,1.76,0,0,1,1.74,1.95v.14H77.73a1.27,1.27,0,0,0,1.3,1.25,1.58,1.58,0,0,0,1.13-.46l.27.36a2,2,0,0,1-1.44.57A1.81,1.81,0,0,1,77.13,165.37Zm1.78-1.43a1.2,1.2,0,0,0-1.18,1.2h2.38A1.17,1.17,0,0,0,78.91,163.94Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M81.66,168.14l-.28-.23a1.13,1.13,0,0,0,.49-.7h-.11a.36.36,0,0,1-.36-.38.39.39,0,0,1,.4-.4.51.51,0,0,1,.47.57A1.44,1.44,0,0,1,81.66,168.14Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M85.2,167.19v-5h2a1.51,1.51,0,1,1,0,3H85.83v2Zm2.94-3.5a.93.93,0,0,0-1-.95H85.83v1.9h1.31A.93.93,0,0,0,88.14,163.69Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M92,167.19v-.51a1.8,1.8,0,0,1-1.29.6,1,1,0,0,1-1.16-1.16v-2.56h.57V166c0,.64.32.82.81.82a1.39,1.39,0,0,0,1.07-.54v-2.67h.56v3.63Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M93.83,166.43v-2.37h-.6v-.5h.6v-1h.57v1h.73v.5H94.4v2.25c0,.27.12.46.36.46a.53.53,0,0,0,.38-.15l.17.42a.92.92,0,0,1-.67.24A.75.75,0,0,1,93.83,166.43Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98.19,167.19v-.42a1.58,1.58,0,0,1-1.2.51,1.22,1.22,0,0,1-1.27-1.2,1.19,1.19,0,0,1,1.27-1.2,1.55,1.55,0,0,1,1.2.49v-.65c0-.48-.39-.76-.92-.76a1.42,1.42,0,0,0-1.11.5l-.26-.39a1.91,1.91,0,0,1,1.45-.6c.77,0,1.4.35,1.4,1.22v2.5Zm0-.77v-.69a1.23,1.23,0,0,0-1-.44.8.8,0,1,0,0,1.58A1.21,1.21,0,0,0,98.19,166.42Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M99.88,167.19v-5h.56v5Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M101.47,162.67a.38.38,0,1,1,.76,0,.38.38,0,0,1-.76,0Zm.1,4.52v-3.63h.56v3.63Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M103,166.71l.28-.41a1.64,1.64,0,0,0,1.2.52c.55,0,.86-.26.86-.62,0-.88-2.25-.34-2.25-1.69,0-.57.48-1,1.35-1a1.77,1.77,0,0,1,1.34.53l-.26.39a1.38,1.38,0,0,0-1.08-.46c-.5,0-.81.25-.81.57,0,.79,2.25.27,2.25,1.68,0,.61-.49,1.1-1.42,1.1A1.94,1.94,0,0,1,103,166.71Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M109,167.19v-.42a1.55,1.55,0,0,1-1.2.51,1.21,1.21,0,0,1-1.26-1.2,1.18,1.18,0,0,1,1.26-1.2,1.54,1.54,0,0,1,1.2.49v-.65c0-.48-.39-.76-.92-.76a1.42,1.42,0,0,0-1.11.5l-.26-.39a1.92,1.92,0,0,1,1.45-.6c.77,0,1.4.35,1.4,1.22v2.5Zm0-.77v-.69a1.23,1.23,0,0,0-1-.44.8.8,0,1,0,0,1.58A1.21,1.21,0,0,0,109,166.42Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M113.33,167.19v-.54a1.54,1.54,0,0,1-1.22.63c-1,0-1.62-.72-1.62-1.9s.67-1.91,1.62-1.91a1.51,1.51,0,0,1,1.22.64v-1.93h.56v5Zm0-1v-1.64a1.35,1.35,0,0,0-1.08-.59c-.74,0-1.17.6-1.17,1.41s.43,1.39,1.17,1.39A1.36,1.36,0,0,0,113.33,166.2Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M117.28,167.19v-.42a1.55,1.55,0,0,1-1.2.51,1.21,1.21,0,0,1-1.26-1.2,1.18,1.18,0,0,1,1.26-1.2,1.53,1.53,0,0,1,1.2.49v-.65c0-.48-.39-.76-.91-.76a1.44,1.44,0,0,0-1.12.5l-.26-.39a1.92,1.92,0,0,1,1.45-.6c.77,0,1.4.35,1.4,1.22v2.5Zm0-.77v-.69a1.23,1.23,0,0,0-1-.44.8.8,0,1,0,0,1.58A1.21,1.21,0,0,0,117.28,166.42Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M121.44,167.19l-1.29-1.63-.61.59v1H119v-5h.57v3.31l1.9-1.93h.72l-1.61,1.65,1.61,2Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25,176.19l-1.9-2.26-.51.58v1.68H22v-5h.62v2.58l2.22-2.58h.78l-2.09,2.37,2.28,2.64Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M28.6,176.19v-.42a1.59,1.59,0,0,1-1.21.51,1.21,1.21,0,0,1-1.26-1.2,1.18,1.18,0,0,1,1.26-1.2,1.56,1.56,0,0,1,1.21.49v-.65c0-.48-.4-.76-.92-.76a1.41,1.41,0,0,0-1.11.5l-.26-.39a1.9,1.9,0,0,1,1.44-.6c.78,0,1.41.35,1.41,1.22v2.5Zm0-.77v-.69a1.25,1.25,0,0,0-1-.44.8.8,0,1,0,0,1.58A1.23,1.23,0,0,0,28.6,175.42Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M30.4,175.43v-2.37h-.6v-.5h.6v-1H31v1h.74v.5H31v2.25c0,.27.12.46.36.46a.52.52,0,0,0,.38-.15l.17.42a.9.9,0,0,1-.67.24A.75.75,0,0,1,30.4,175.43Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M35,176.19V173.8c0-.65-.32-.83-.82-.83a1.38,1.38,0,0,0-1.07.57v2.65H32.5v-5h.56v1.91a1.76,1.76,0,0,1,1.29-.62,1,1,0,0,1,1.16,1.16v2.56Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41,176.19v-2.47c0-.45-.2-.75-.67-.75a1.27,1.27,0,0,0-1,.56v2.66h-.56v-2.47c0-.45-.19-.75-.67-.75a1.24,1.24,0,0,0-.95.57v2.65h-.57v-3.63h.57v.53a1.53,1.53,0,0,1,1.17-.62.92.92,0,0,1,1,.68,1.54,1.54,0,0,1,1.22-.68c.66,0,1,.37,1,1.1v2.62Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45,176.19v-.42a1.55,1.55,0,0,1-1.2.51,1.21,1.21,0,0,1-1.26-1.2,1.18,1.18,0,0,1,1.26-1.2,1.54,1.54,0,0,1,1.2.49v-.65c0-.48-.39-.76-.92-.76a1.44,1.44,0,0,0-1.11.5l-.26-.39a1.92,1.92,0,0,1,1.45-.6c.77,0,1.4.35,1.4,1.22v2.5Zm0-.77v-.69a1.23,1.23,0,0,0-1-.44.8.8,0,1,0,0,1.58A1.21,1.21,0,0,0,45,175.42Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M49.11,176.19v-2.38c0-.64-.33-.84-.82-.84a1.38,1.38,0,0,0-1.07.57v2.65h-.57v-3.63h.57v.53a1.76,1.76,0,0,1,1.29-.62,1,1,0,0,1,1.15,1.17v2.55Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M53.42,176.19v-.54a1.54,1.54,0,0,1-1.22.63c-1,0-1.62-.72-1.62-1.9s.67-1.91,1.62-1.91a1.51,1.51,0,0,1,1.22.64v-1.93H54v5Zm0-1v-1.64a1.33,1.33,0,0,0-1.08-.59c-.74,0-1.17.6-1.17,1.41s.43,1.39,1.17,1.39A1.34,1.34,0,0,0,53.42,175.2Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M57.55,176.19v-.51a1.8,1.8,0,0,1-1.29.6,1,1,0,0,1-1.15-1.16v-2.56h.56V175c0,.64.32.82.82.82a1.38,1.38,0,0,0,1.06-.54v-2.67h.57v3.63Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M59.39,177.14l-.29-.23a1.13,1.13,0,0,0,.49-.7h-.1a.36.36,0,0,1-.36-.38.39.39,0,0,1,.39-.4A.51.51,0,0,1,60,176,1.47,1.47,0,0,1,59.39,177.14Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66.47,176.19l-2.92-4v4h-.62v-5h.64l2.88,3.91v-3.91h.62v5Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M68,174.37a1.82,1.82,0,0,1,1.79-1.9,1.76,1.76,0,0,1,1.74,1.95v.14H68.61a1.26,1.26,0,0,0,1.29,1.25,1.58,1.58,0,0,0,1.13-.46l.27.36a2,2,0,0,1-1.44.57A1.81,1.81,0,0,1,68,174.37Zm1.78-1.43a1.2,1.2,0,0,0-1.18,1.2H71A1.17,1.17,0,0,0,69.78,172.94Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M73,175.64v1.93h-.56v-5H73v.54a1.5,1.5,0,0,1,1.22-.63c1,0,1.62.72,1.62,1.9s-.66,1.91-1.62,1.91A1.51,1.51,0,0,1,73,175.64Zm2.25-1.27c0-.8-.44-1.4-1.17-1.4a1.37,1.37,0,0,0-1.08.58v1.64a1.37,1.37,0,0,0,1.08.58C74.81,175.77,75.25,175.17,75.25,174.37Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M79,176.19v-.42a1.55,1.55,0,0,1-1.2.51,1.21,1.21,0,0,1-1.26-1.2,1.18,1.18,0,0,1,1.26-1.2,1.53,1.53,0,0,1,1.2.49v-.65c0-.48-.39-.76-.91-.76a1.41,1.41,0,0,0-1.11.5l-.27-.39a1.94,1.94,0,0,1,1.45-.6c.78,0,1.41.35,1.41,1.22v2.5Zm0-.77v-.69a1.22,1.22,0,0,0-1-.44.8.8,0,1,0,0,1.58A1.2,1.2,0,0,0,79,175.42Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M80.69,176.19v-5h.56v5Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M23.21,185.19v-4.45H21.63v-.56h3.79v.56H23.83v4.45Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25.74,181.92a.41.41,0,0,1,.41-.41.41.41,0,1,1,0,.82A.41.41,0,0,1,25.74,181.92Zm0,2.93a.41.41,0,0,1,.41-.41.41.41,0,0,1,.41.41.42.42,0,0,1-.41.41A.41.41,0,0,1,25.74,184.85Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31,182.85v1.6h-.43v-1.6H29.13v-.39h1.44v-1.55H31v1.55h1.44v.39Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M33.29,184.67l.31-.47a1.31,1.31,0,0,0,1.08.51c1,0,1.41-1,1.41-2a1.41,1.41,0,0,0,0-.2,1.78,1.78,0,0,1-1.41.78,1.52,1.52,0,0,1-1.64-1.6,1.64,1.64,0,0,1,1.75-1.63c1.4,0,1.94,1.22,1.94,2.59s-.64,2.58-2,2.58A1.76,1.76,0,0,1,33.29,184.67ZM36.07,182a1.35,1.35,0,0,0-1.27-1.39,1.08,1.08,0,0,0-1.14,1.06,1,1,0,0,0,1.15,1.08A1.54,1.54,0,0,0,36.07,182Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M38,185.19l2-4.45h-2.7v-.56h3.42v.43l-2.05,4.58Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41.86,185.19l2-4.45h-2.7v-.56H44.6v.43l-2.05,4.58Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45,183.62v-.5h1.8v.5Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M48.4,185.19V181l-.8.85-.38-.38,1.26-1.29H49v5Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M49.83,183.62v-.5h1.8v.5Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M52.35,184.47l.39-.42a1.63,1.63,0,0,0,1.38.67,1.07,1.07,0,0,0,1.15-1.07,1.05,1.05,0,0,0-1.15-1.08A1.61,1.61,0,0,0,53,183l-.46-.15v-2.7h3.06v.56H53.13v1.74A1.72,1.72,0,0,1,54.3,182a1.53,1.53,0,0,1,1.6,1.6,1.65,1.65,0,0,1-1.78,1.65A2.06,2.06,0,0,1,52.35,184.47Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M56.5,184.45l.37-.39a1.73,1.73,0,0,0,1.39.66c.73,0,1.17-.37,1.17-.94s-.51-.88-1.24-.88h-.52v-.57h.52c.63,0,1.16-.25,1.16-.82s-.51-.86-1.12-.86a1.7,1.7,0,0,0-1.32.61l-.34-.39a2.17,2.17,0,0,1,1.72-.78c1,0,1.69.49,1.69,1.33a1.22,1.22,0,0,1-1.08,1.17,1.27,1.27,0,0,1,1.16,1.24c0,.83-.68,1.44-1.78,1.44A2.12,2.12,0,0,1,56.5,184.45Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M60.68,184.45l.36-.39a1.76,1.76,0,0,0,1.4.66c.73,0,1.17-.37,1.17-.94s-.51-.88-1.24-.88h-.52v-.57h.52c.63,0,1.16-.25,1.16-.82s-.51-.86-1.12-.86a1.69,1.69,0,0,0-1.32.61l-.35-.39a2.17,2.17,0,0,1,1.72-.78c1,0,1.69.49,1.69,1.33a1.22,1.22,0,0,1-1.07,1.17,1.27,1.27,0,0,1,1.16,1.24c0,.83-.68,1.44-1.78,1.44A2.1,2.1,0,0,1,60.68,184.45Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64.85,184.45l.37-.39a1.75,1.75,0,0,0,1.4.66c.73,0,1.17-.37,1.17-.94s-.51-.88-1.25-.88H66v-.57h.51c.63,0,1.17-.25,1.17-.82s-.51-.86-1.12-.86a1.69,1.69,0,0,0-1.32.61l-.35-.39a2.17,2.17,0,0,1,1.72-.78c1,0,1.69.49,1.69,1.33a1.22,1.22,0,0,1-1.07,1.17,1.26,1.26,0,0,1,1.15,1.24c0,.83-.67,1.44-1.78,1.44A2.13,2.13,0,0,1,64.85,184.45Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M69.2,182.69c0-1.23.54-2.59,1.91-2.59S73,181.46,73,182.69s-.55,2.59-1.92,2.59S69.2,183.9,69.2,182.69Zm3.19,0c0-1-.33-2-1.28-2s-1.27,1-1.27,2,.32,2,1.27,2S72.39,183.69,72.39,182.69Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M73.79,183.92A1.5,1.5,0,0,1,75,182.6a1.31,1.31,0,0,1-1.11-1.2c0-.9.88-1.3,1.71-1.3s1.72.4,1.72,1.3a1.32,1.32,0,0,1-1.12,1.2,1.49,1.49,0,0,1,1.19,1.32c0,.85-.81,1.36-1.79,1.36S73.79,184.77,73.79,183.92Zm3-.07c0-.65-.85-.93-1.16-1s-1.16.32-1.16,1,.54.87,1.16.87S76.75,184.39,76.75,183.85Zm-.07-2.36c0-.52-.49-.83-1.09-.83s-1.08.31-1.08.83.78.81,1.08.86S76.68,182.09,76.68,181.49Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M78.16,183.92a1.49,1.49,0,0,1,1.19-1.32,1.31,1.31,0,0,1-1.11-1.2c0-.9.88-1.3,1.71-1.3s1.72.4,1.72,1.3a1.32,1.32,0,0,1-1.12,1.2,1.49,1.49,0,0,1,1.2,1.32c0,.85-.81,1.36-1.8,1.36S78.16,184.77,78.16,183.92Zm3-.07c0-.65-.86-.93-1.17-1s-1.16.32-1.16,1,.54.87,1.16.87S81.12,184.39,81.12,183.85ZM81,181.49c0-.52-.49-.83-1.09-.83s-1.08.31-1.08.83.78.81,1.08.86S81,182.09,81,181.49Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M82.13,185.34,83.91,180h.45l-1.78,5.31Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M85.69,185.19V181l-.8.85-.38-.38,1.26-1.29h.54v5Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M87.28,182.69c0-1.23.54-2.59,1.91-2.59s1.92,1.36,1.92,2.59-.55,2.59-1.92,2.59S87.28,183.9,87.28,182.69Zm3.19,0c0-1-.32-2-1.28-2s-1.27,1-1.27,2,.32,2,1.27,2S90.47,183.69,90.47,182.69Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M92.39,185.19l2-4.45H91.72v-.56h3.41v.43l-2,4.58Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25.09,194.19l-.95-2.92-.95,2.92h-.56l-1.15-3.63h.58l.89,2.89.95-2.89h.49l.94,2.89.89-2.89h.59l-1.15,3.63Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M30.59,194.19l-.94-2.92-.95,2.92h-.56L27,190.56h.59l.88,2.89.95-2.89h.49l.95,2.89.88-2.89h.6l-1.16,3.63Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M36.1,194.19l-1-2.92-.95,2.92h-.56l-1.16-3.63h.59l.89,2.89.95-2.89h.49l.94,2.89.89-2.89h.59l-1.15,3.63Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M38,193.85a.42.42,0,0,1,.83,0,.42.42,0,0,1-.83,0Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42.34,194.19,41,192.56l-.61.59v1h-.56v-5h.56v3.31l1.91-1.93h.71l-1.61,1.65,1.62,2Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M46,194.19v-.42a1.58,1.58,0,0,1-1.2.51,1.22,1.22,0,0,1-1.27-1.2,1.19,1.19,0,0,1,1.27-1.2,1.55,1.55,0,0,1,1.2.49v-.65c0-.48-.39-.76-.92-.76a1.42,1.42,0,0,0-1.11.5l-.26-.39a1.91,1.91,0,0,1,1.45-.6c.77,0,1.4.35,1.4,1.22v2.5Zm0-.77v-.69a1.23,1.23,0,0,0-1-.44.8.8,0,1,0,0,1.58A1.21,1.21,0,0,0,46,193.42Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M50.14,194.19v-2.38c0-.64-.34-.84-.82-.84a1.4,1.4,0,0,0-1.08.57v2.65h-.56v-3.63h.56v.53a1.78,1.78,0,0,1,1.3-.62,1,1,0,0,1,1.15,1.17v2.55Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51.81,195.11l.29-.4a1.4,1.4,0,0,0,1.18.48,1,1,0,0,0,1.17-1.06v-.54a1.57,1.57,0,0,1-1.23.64,1.65,1.65,0,0,1-1.61-1.87c0-1.17.66-1.89,1.61-1.89a1.53,1.53,0,0,1,1.23.64v-.55H55v3.57c0,1.15-.85,1.53-1.73,1.53A1.86,1.86,0,0,1,51.81,195.11Zm2.64-2v-1.59a1.38,1.38,0,0,0-1.08-.58c-.74,0-1.17.58-1.17,1.39s.43,1.37,1.17,1.37A1.36,1.36,0,0,0,54.45,193.14Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58.4,194.19v-.42a1.55,1.55,0,0,1-1.2.51,1.21,1.21,0,0,1-1.26-1.2,1.18,1.18,0,0,1,1.26-1.2,1.54,1.54,0,0,1,1.2.49v-.65c0-.48-.39-.76-.92-.76a1.44,1.44,0,0,0-1.11.5l-.26-.39a1.92,1.92,0,0,1,1.45-.6c.77,0,1.4.35,1.4,1.22v2.5Zm0-.77v-.69a1.23,1.23,0,0,0-1-.44.8.8,0,1,0,0,1.58A1.21,1.21,0,0,0,58.4,193.42Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M60.09,194.19v-3.63h.57v.58a1.54,1.54,0,0,1,1.2-.66v.58l-.21,0a1.31,1.31,0,0,0-1,.58v2.57Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M62.36,192.37a1.8,1.8,0,1,1,1.79,1.91A1.78,1.78,0,0,1,62.36,192.37Zm3,0a1.21,1.21,0,1,0-1.2,1.4A1.26,1.26,0,0,0,65.35,192.37Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66.65,192.37a1.8,1.8,0,1,1,1.79,1.91A1.78,1.78,0,0,1,66.65,192.37Zm3,0a1.21,1.21,0,1,0-1.2,1.4A1.26,1.26,0,0,0,69.64,192.37Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M70.94,192.37a1.81,1.81,0,0,1,1.78-1.9,1.77,1.77,0,0,1,1.75,1.95v.14H71.54a1.27,1.27,0,0,0,1.3,1.25,1.56,1.56,0,0,0,1.12-.46l.27.36a2,2,0,0,1-1.44.57A1.8,1.8,0,0,1,70.94,192.37Zm1.78-1.43a1.2,1.2,0,0,0-1.19,1.2h2.38A1.17,1.17,0,0,0,72.72,190.94Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M78,194.19v-.54a1.56,1.56,0,0,1-1.23.63c-.94,0-1.61-.72-1.61-1.9s.67-1.91,1.61-1.91a1.53,1.53,0,0,1,1.23.64v-1.93h.56v5Zm0-1v-1.64a1.35,1.35,0,0,0-1.08-.59c-.74,0-1.18.6-1.18,1.41s.44,1.39,1.18,1.39A1.36,1.36,0,0,0,78,193.2Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M82.13,194.19v-.51a1.8,1.8,0,0,1-1.29.6,1,1,0,0,1-1.16-1.16v-2.56h.57V193c0,.64.32.82.81.82a1.39,1.39,0,0,0,1.07-.54v-2.67h.56v3.63Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M83.7,193.85a.42.42,0,0,1,.83,0,.42.42,0,0,1-.83,0Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M85.28,192.37a1.8,1.8,0,0,1,1.81-1.9,1.56,1.56,0,0,1,1.33.63l-.37.34a1.08,1.08,0,0,0-.93-.47,1.41,1.41,0,0,0,0,2.8,1.1,1.1,0,0,0,.93-.47l.37.35a1.56,1.56,0,0,1-1.33.63A1.8,1.8,0,0,1,85.28,192.37Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M89,192.37a1.8,1.8,0,1,1,1.8,1.91A1.78,1.78,0,0,1,89,192.37Zm3,0a1.21,1.21,0,1,0-1.2,1.4A1.26,1.26,0,0,0,92,192.37Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M97.88,194.19v-2.47c0-.45-.19-.75-.67-.75a1.27,1.27,0,0,0-1,.56v2.66h-.56v-2.47c0-.45-.19-.75-.67-.75a1.24,1.24,0,0,0-1,.57v2.65H93.5v-3.63h.57v.53a1.57,1.57,0,0,1,1.18-.62.92.92,0,0,1,1,.68,1.56,1.56,0,0,1,1.22-.68c.66,0,1,.37,1,1.1v2.62Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 0.13,
    y1: 195.72,
    x2: 156.03,
    y2: 195.72
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 0.13,
    y1: 139.02,
    x2: 156.03,
    y2: 139.02
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 0.13,
    y1: 82.33,
    x2: 156.03,
    y2: 82.33
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 0.13,
    y1: 25.64,
    x2: 156.03,
    y2: 25.64
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 0.13,
    y1: 224.06,
    x2: 156.03,
    y2: 224.06
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 0.13,
    y1: 167.37,
    x2: 156.03,
    y2: 167.37
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 0.13,
    y1: 110.68,
    x2: 156.03,
    y2: 110.68
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 0.13,
    y1: 53.98,
    x2: 156.03,
    y2: 53.98
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 106.42,
    y1: 249.57,
    x2: 106.42,
    y2: 0.13
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 49.73,
    y1: 249.57,
    x2: 49.73,
    y2: 0.13
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 134.77,
    y1: 249.57,
    x2: 134.77,
    y2: 0.13
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 78.08,
    y1: 249.57,
    x2: 78.08,
    y2: 0.13
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.38,
    y1: 249.57,
    x2: 21.38,
    y2: 0.13
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 183.32,
    y: 0.13,
    width: 155.91,
    height: 249.45
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.58,
    y: 36.35,
    width: 0.87,
    height: 6.11
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.58,
    y: 43.33,
    width: 0.87,
    height: 0.87
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.58,
    y: 45.08,
    width: 0.87,
    height: 0.87
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.58,
    y: 47.69,
    width: 0.87,
    height: 1.74
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.58,
    y: 50.31,
    width: 0.87,
    height: 1.74
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.58,
    y: 52.93,
    width: 0.87,
    height: 1.74
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.58,
    y: 55.54,
    width: 0.87,
    height: 0.87
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.58,
    y: 57.29,
    width: 0.87,
    height: 0.87
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.58,
    y: 59.9,
    width: 0.87,
    height: 0.87
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.58,
    y: 62.52,
    width: 0.87,
    height: 2.62
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.58,
    y: 66.01,
    width: 0.87,
    height: 1.74
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.58,
    y: 68.62,
    width: 0.87,
    height: 0.87
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.58,
    y: 70.37,
    width: 0.87,
    height: 0.87
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.58,
    y: 72.11,
    width: 0.87,
    height: 1.74
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.58,
    y: 75.6,
    width: 0.87,
    height: 1.74
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.58,
    y: 78.22,
    width: 0.87,
    height: 0.87
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.58,
    y: 80.84,
    width: 0.87,
    height: 1.74
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.58,
    y: 84.32,
    width: 0.87,
    height: 0.87
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 204.58,
    y: 86.94,
    width: 0.87,
    height: 6.11
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 205.45,
    y: 36.35,
    width: 0.87,
    height: 0.87
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 205.45,
    y: 41.59,
    width: 0.87,
    height: 0.87
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 205.45,
    y: 45.08,
    width: 0.87,
    height: 0.87
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 205.45,
    y: 48.56,
    width: 0.87,
    height: 0.87
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 205.45,
    y: 51.18,
    width: 0.87,
    height: 2.62
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 205.45,
    y: 55.54,
    width: 0.87,
    height: 0.87
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 205.45,
    y: 58.16,
    width: 0.87,
    height: 0.87
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 205.45,
    y: 59.9,
    width: 0.87,
    height: 0.87
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 205.45,
    y: 64.26,
    width: 0.87,
    height: 4.36
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 205.45,
    y: 69.5,
    width: 0.87,
    height: 0.87
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 205.45,
    y: 72.11,
    width: 0.87,
    height: 1.74
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 205.45,
    y: 74.73,
    width: 0.87,
    height: 1.74
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 205.45,
    y: 77.35,
    width: 0.87,
    height: 1.74
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 205.45,
    y: 80.84,
    width: 0.87,
    height: 2.62
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 205.45,
    y: 85.2,
    width: 0.87,
    height: 0.87
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 205.45,
    y: 86.94,
    width: 0.87,
    height: 0.87
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 205.45,
    y: 92.17,
    width: 0.87,
    height: 0.87
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 206.32,
    y: 36.35,
    width: 0.87,
    height: 0.87
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 206.32,
    y: 38.1,
    width: 0.87,
    height: 2.62
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 206.32,
    y: 41.59,
    width: 0.87,
    height: 0.87
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 206.32,
    y: 44.2,
    width: 0.87,
    height: 0.87
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 206.32,
    y: 45.95,
    width: 0.87,
    height: 1.74
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 206.32,
    y: 48.56,
    width: 0.87,
    height: 0.87
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 206.32,
    y: 52.05,
    width: 0.87,
    height: 3.49
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 206.32,
    y: 56.41,
    width: 0.87,
    height: 0.87
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 206.32,
    y: 58.16,
    width: 0.87,
    height: 0.87
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 206.32,
    y: 63.39,
    width: 0.87,
    height: 3.49
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 206.32,
    y: 67.75,
    width: 0.87,
    height: 1.74
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 206.32,
    y: 71.24,
    width: 0.87,
    height: 2.62
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 206.32,
    y: 75.6,
    width: 0.87,
    height: 0.87
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 206.32,
    y: 77.35,
    width: 0.87,
    height: 4.36
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 206.32,
    y: 82.58,
    width: 0.87,
    height: 1.74
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 206.32,
    y: 85.2,
    width: 0.87,
    height: 0.87
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 206.32,
    y: 86.94,
    width: 0.87,
    height: 0.87
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 206.32,
    y: 88.69,
    width: 0.87,
    height: 2.62
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 206.32,
    y: 92.17,
    width: 0.87,
    height: 0.87
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 207.2,
    y: 36.35,
    width: 0.87,
    height: 0.87
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 207.2,
    y: 38.1,
    width: 0.87,
    height: 2.62
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 207.2,
    y: 41.59,
    width: 0.87,
    height: 0.87
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 207.2,
    y: 44.2,
    width: 0.87,
    height: 0.87
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 207.2,
    y: 45.95,
    width: 0.87,
    height: 1.74
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 207.2,
    y: 53.8,
    width: 0.87,
    height: 0.87
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 207.2,
    y: 55.54,
    width: 0.87,
    height: 0.87
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 207.2,
    y: 63.39,
    width: 0.87,
    height: 3.49
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 207.2,
    y: 67.75,
    width: 0.87,
    height: 2.62
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 207.2,
    y: 71.24,
    width: 0.87,
    height: 0.87
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 207.2,
    y: 72.99,
    width: 0.87,
    height: 1.74
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 207.2,
    y: 76.47,
    width: 0.87,
    height: 0.87
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 207.2,
    y: 78.22,
    width: 0.87,
    height: 3.49
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 207.2,
    y: 83.45,
    width: 0.87,
    height: 1.74
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 207.2,
    y: 86.94,
    width: 0.87,
    height: 0.87
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 207.2,
    y: 88.69,
    width: 0.87,
    height: 2.62
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 207.2,
    y: 92.17,
    width: 0.87,
    height: 0.87
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.07,
    y: 36.35,
    width: 0.87,
    height: 0.87
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.07,
    y: 38.1,
    width: 0.87,
    height: 2.62
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.07,
    y: 41.59,
    width: 0.87,
    height: 0.87
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.07,
    y: 43.33,
    width: 0.87,
    height: 3.49
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.07,
    y: 48.56,
    width: 0.87,
    height: 1.74
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.07,
    y: 51.18,
    width: 0.87,
    height: 0.87
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.07,
    y: 52.93,
    width: 0.87,
    height: 0.87
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.07,
    y: 54.67,
    width: 0.87,
    height: 1.74
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.07,
    y: 57.29,
    width: 0.87,
    height: 0.87
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.07,
    y: 62.52,
    width: 0.87,
    height: 5.23
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.07,
    y: 69.5,
    width: 0.87,
    height: 0.87
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.07,
    y: 72.99,
    width: 0.87,
    height: 1.74
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.07,
    y: 75.6,
    width: 0.87,
    height: 0.87
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.07,
    y: 77.35,
    width: 0.87,
    height: 1.74
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.07,
    y: 79.96,
    width: 0.87,
    height: 0.87
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.07,
    y: 82.58,
    width: 0.87,
    height: 0.87
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.07,
    y: 85.2,
    width: 0.87,
    height: 0.87
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.07,
    y: 86.94,
    width: 0.87,
    height: 0.87
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.07,
    y: 88.69,
    width: 0.87,
    height: 2.62
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.07,
    y: 92.17,
    width: 0.87,
    height: 0.87
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.94,
    y: 36.35,
    width: 0.87,
    height: 0.87
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.94,
    y: 41.59,
    width: 0.87,
    height: 0.87
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.94,
    y: 47.69,
    width: 0.87,
    height: 1.74
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.94,
    y: 50.31,
    width: 0.87,
    height: 0.87
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.94,
    y: 52.05,
    width: 0.87,
    height: 1.74
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.94,
    y: 54.67,
    width: 0.87,
    height: 0.87
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.94,
    y: 61.65,
    width: 0.87,
    height: 1.74
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.94,
    y: 66.01,
    width: 0.87,
    height: 1.74
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.94,
    y: 70.37,
    width: 0.87,
    height: 1.74
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.94,
    y: 72.99,
    width: 0.87,
    height: 1.74
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.94,
    y: 75.6,
    width: 0.87,
    height: 0.87
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.94,
    y: 79.96,
    width: 0.87,
    height: 0.87
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.94,
    y: 83.45,
    width: 0.87,
    height: 0.87
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.94,
    y: 86.94,
    width: 0.87,
    height: 0.87
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 208.94,
    y: 92.17,
    width: 0.87,
    height: 0.87
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 36.35,
    width: 0.87,
    height: 6.11
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 43.33,
    width: 0.87,
    height: 0.87
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 45.08,
    width: 0.87,
    height: 0.87
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 46.82,
    width: 0.87,
    height: 0.87
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 48.56,
    width: 0.87,
    height: 0.87
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 50.31,
    width: 0.87,
    height: 0.87
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 52.05,
    width: 0.87,
    height: 0.87
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 53.8,
    width: 0.87,
    height: 0.87
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 55.54,
    width: 0.87,
    height: 0.87
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 57.29,
    width: 0.87,
    height: 0.87
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 59.03,
    width: 0.87,
    height: 0.87
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 60.77,
    width: 0.87,
    height: 0.87
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 62.52,
    width: 0.87,
    height: 0.87
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 64.26,
    width: 0.87,
    height: 0.87
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 66.01,
    width: 0.87,
    height: 0.87
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 67.75,
    width: 0.87,
    height: 0.87
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 69.5,
    width: 0.87,
    height: 0.87
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 71.24,
    width: 0.87,
    height: 0.87
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 72.99,
    width: 0.87,
    height: 0.87
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 74.73,
    width: 0.87,
    height: 0.87
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 76.47,
    width: 0.87,
    height: 0.87
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 78.22,
    width: 0.87,
    height: 0.87
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 79.96,
    width: 0.87,
    height: 0.87
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 81.71,
    width: 0.87,
    height: 0.87
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 83.45,
    width: 0.87,
    height: 0.87
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 85.2,
    width: 0.87,
    height: 0.87
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 209.81,
    y: 86.94,
    width: 0.87,
    height: 6.11
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.69,
    y: 43.33,
    width: 0.87,
    height: 0.87
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.69,
    y: 47.69,
    width: 0.87,
    height: 0.87
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.69,
    y: 50.31,
    width: 0.87,
    height: 5.23
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.69,
    y: 56.41,
    width: 0.87,
    height: 3.49
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.69,
    y: 61.65,
    width: 0.87,
    height: 1.74
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.69,
    y: 66.01,
    width: 0.87,
    height: 0.87
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.69,
    y: 67.75,
    width: 0.87,
    height: 0.87
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.69,
    y: 69.5,
    width: 0.87,
    height: 0.87
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.69,
    y: 71.24,
    width: 0.87,
    height: 1.74
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.69,
    y: 73.86,
    width: 0.87,
    height: 3.49
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.69,
    y: 78.22,
    width: 0.87,
    height: 1.74
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.69,
    y: 81.71,
    width: 0.87,
    height: 0.87
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 210.69,
    y: 84.32,
    width: 0.87,
    height: 1.74
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 211.56,
    y: 36.35,
    width: 0.87,
    height: 0.87
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 211.56,
    y: 38.97,
    width: 0.87,
    height: 5.23
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 211.56,
    y: 46.82,
    width: 0.87,
    height: 0.87
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 211.56,
    y: 51.18,
    width: 0.87,
    height: 2.62
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 211.56,
    y: 54.67,
    width: 0.87,
    height: 0.87
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 211.56,
    y: 57.29,
    width: 0.87,
    height: 1.74
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 211.56,
    y: 60.77,
    width: 0.87,
    height: 0.87
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 211.56,
    y: 62.52,
    width: 0.87,
    height: 6.11
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 211.56,
    y: 70.37,
    width: 0.87,
    height: 0.87
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 211.56,
    y: 72.99,
    width: 0.87,
    height: 4.36
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 211.56,
    y: 78.22,
    width: 0.87,
    height: 1.74
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 211.56,
    y: 80.84,
    width: 0.87,
    height: 1.74
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 211.56,
    y: 85.2,
    width: 0.87,
    height: 2.62
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 211.56,
    y: 88.69,
    width: 0.87,
    height: 0.87
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 211.56,
    y: 92.17,
    width: 0.87,
    height: 0.87
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 212.43,
    y: 37.23,
    width: 0.87,
    height: 0.87
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 212.43,
    y: 40.71,
    width: 0.87,
    height: 0.87
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 212.43,
    y: 43.33,
    width: 0.87,
    height: 0.87
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 212.43,
    y: 45.08,
    width: 0.87,
    height: 0.87
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 212.43,
    y: 46.82,
    width: 0.87,
    height: 2.62
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 212.43,
    y: 51.18,
    width: 0.87,
    height: 1.74
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 212.43,
    y: 57.29,
    width: 0.87,
    height: 0.87
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 212.43,
    y: 59.03,
    width: 0.87,
    height: 3.49
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 212.43,
    y: 64.26,
    width: 0.87,
    height: 1.74
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 212.43,
    y: 66.88,
    width: 0.87,
    height: 4.36
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 212.43,
    y: 72.11,
    width: 0.87,
    height: 0.87
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 212.43,
    y: 73.86,
    width: 0.87,
    height: 0.87
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 212.43,
    y: 75.6,
    width: 0.87,
    height: 4.36
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 212.43,
    y: 80.84,
    width: 0.87,
    height: 1.74
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 212.43,
    y: 84.32,
    width: 0.87,
    height: 1.74
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 212.43,
    y: 87.81,
    width: 0.87,
    height: 0.87
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.3,
    y: 37.23,
    width: 0.87,
    height: 0.87
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.3,
    y: 38.97,
    width: 0.87,
    height: 3.49
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.3,
    y: 44.2,
    width: 0.87,
    height: 0.87
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.3,
    y: 45.95,
    width: 0.87,
    height: 1.74
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.3,
    y: 49.44,
    width: 0.87,
    height: 0.87
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.3,
    y: 52.93,
    width: 0.87,
    height: 3.49
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.3,
    y: 59.03,
    width: 0.87,
    height: 0.87
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.3,
    y: 60.77,
    width: 0.87,
    height: 0.87
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.3,
    y: 62.52,
    width: 0.87,
    height: 2.62
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.3,
    y: 68.62,
    width: 0.87,
    height: 3.49
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.3,
    y: 73.86,
    width: 0.87,
    height: 1.74
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.3,
    y: 77.35,
    width: 0.87,
    height: 0.87
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.3,
    y: 79.96,
    width: 0.87,
    height: 0.87
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.3,
    y: 82.58,
    width: 0.87,
    height: 2.62
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.3,
    y: 86.07,
    width: 0.87,
    height: 0.87
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 213.3,
    y: 91.3,
    width: 0.87,
    height: 1.74
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 214.17,
    y: 38.1,
    width: 0.87,
    height: 0.87
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 214.17,
    y: 40.71,
    width: 0.87,
    height: 0.87
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 214.17,
    y: 43.33,
    width: 0.87,
    height: 0.87
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 214.17,
    y: 45.08,
    width: 0.87,
    height: 2.62
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 214.17,
    y: 49.44,
    width: 0.87,
    height: 0.87
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 214.17,
    y: 52.05,
    width: 0.87,
    height: 0.87
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 214.17,
    y: 53.8,
    width: 0.87,
    height: 1.74
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 214.17,
    y: 60.77,
    width: 0.87,
    height: 0.87
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 214.17,
    y: 63.39,
    width: 0.87,
    height: 2.62
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 214.17,
    y: 67.75,
    width: 0.87,
    height: 1.74
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 214.17,
    y: 73.86,
    width: 0.87,
    height: 1.74
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 214.17,
    y: 77.35,
    width: 0.87,
    height: 3.49
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 214.17,
    y: 81.71,
    width: 0.87,
    height: 0.87
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 214.17,
    y: 84.32,
    width: 0.87,
    height: 0.87
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 214.17,
    y: 89.56,
    width: 0.87,
    height: 0.87
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.05,
    y: 36.35,
    width: 0.87,
    height: 1.74
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.05,
    y: 38.97,
    width: 0.87,
    height: 0.87
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.05,
    y: 41.59,
    width: 0.87,
    height: 0.87
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.05,
    y: 43.33,
    width: 0.87,
    height: 0.87
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.05,
    y: 45.08,
    width: 0.87,
    height: 0.87
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.05,
    y: 50.31,
    width: 0.87,
    height: 2.62
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.05,
    y: 55.54,
    width: 0.87,
    height: 0.87
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.05,
    y: 59.03,
    width: 0.87,
    height: 0.87
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.05,
    y: 61.65,
    width: 0.87,
    height: 1.74
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.05,
    y: 64.26,
    width: 0.87,
    height: 0.87
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.05,
    y: 67.75,
    width: 0.87,
    height: 0.87
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.05,
    y: 69.5,
    width: 0.87,
    height: 0.87
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.05,
    y: 75.6,
    width: 0.87,
    height: 0.87
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.05,
    y: 77.35,
    width: 0.87,
    height: 0.87
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.05,
    y: 80.84,
    width: 0.87,
    height: 0.87
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.05,
    y: 83.45,
    width: 0.87,
    height: 2.62
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.05,
    y: 87.81,
    width: 0.87,
    height: 0.87
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.05,
    y: 89.56,
    width: 0.87,
    height: 3.49
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.92,
    y: 36.35,
    width: 0.87,
    height: 0.87
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.92,
    y: 38.1,
    width: 0.87,
    height: 0.87
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.92,
    y: 40.71,
    width: 0.87,
    height: 0.87
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.92,
    y: 46.82,
    width: 0.87,
    height: 1.74
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.92,
    y: 50.31,
    width: 0.87,
    height: 2.62
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.92,
    y: 55.54,
    width: 0.87,
    height: 0.87
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.92,
    y: 57.29,
    width: 0.87,
    height: 0.87
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.92,
    y: 59.03,
    width: 0.87,
    height: 0.87
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.92,
    y: 66.01,
    width: 0.87,
    height: 1.74
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.92,
    y: 68.62,
    width: 0.87,
    height: 0.87
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.92,
    y: 72.11,
    width: 0.87,
    height: 0.87
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.92,
    y: 76.47,
    width: 0.87,
    height: 1.74
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.92,
    y: 79.96,
    width: 0.87,
    height: 0.87
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.92,
    y: 81.71,
    width: 0.87,
    height: 0.87
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.92,
    y: 83.45,
    width: 0.87,
    height: 0.87
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.92,
    y: 85.2,
    width: 0.87,
    height: 0.87
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.92,
    y: 86.94,
    width: 0.87,
    height: 0.87
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.92,
    y: 89.56,
    width: 0.87,
    height: 0.87
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.92,
    y: 91.3,
    width: 0.87,
    height: 0.87
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 216.79,
    y: 37.23,
    width: 0.87,
    height: 1.74
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 216.79,
    y: 39.84,
    width: 0.87,
    height: 0.87
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 216.79,
    y: 41.59,
    width: 0.87,
    height: 1.74
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 216.79,
    y: 46.82,
    width: 0.87,
    height: 1.74
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 216.79,
    y: 51.18,
    width: 0.87,
    height: 2.62
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 216.79,
    y: 55.54,
    width: 0.87,
    height: 1.74
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 216.79,
    y: 62.52,
    width: 0.87,
    height: 2.62
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 216.79,
    y: 66.01,
    width: 0.87,
    height: 0.87
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 216.79,
    y: 69.5,
    width: 0.87,
    height: 0.87
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 216.79,
    y: 72.11,
    width: 0.87,
    height: 0.87
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 216.79,
    y: 73.86,
    width: 0.87,
    height: 0.87
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 216.79,
    y: 75.6,
    width: 0.87,
    height: 0.87
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 216.79,
    y: 79.09,
    width: 0.87,
    height: 2.62
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 216.79,
    y: 85.2,
    width: 0.87,
    height: 0.87
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 216.79,
    y: 86.94,
    width: 0.87,
    height: 1.74
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 216.79,
    y: 89.56,
    width: 0.87,
    height: 0.87
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 216.79,
    y: 92.17,
    width: 0.87,
    height: 0.87
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 217.66,
    y: 36.35,
    width: 0.87,
    height: 2.62
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 217.66,
    y: 40.71,
    width: 0.87,
    height: 0.87
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 217.66,
    y: 42.46,
    width: 0.87,
    height: 0.87
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 217.66,
    y: 45.95,
    width: 0.87,
    height: 1.74
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 217.66,
    y: 48.56,
    width: 0.87,
    height: 0.87
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 217.66,
    y: 51.18,
    width: 0.87,
    height: 0.87
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 217.66,
    y: 52.93,
    width: 0.87,
    height: 0.87
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 217.66,
    y: 55.54,
    width: 0.87,
    height: 4.36
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 217.66,
    y: 60.77,
    width: 0.87,
    height: 1.74
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 217.66,
    y: 63.39,
    width: 0.87,
    height: 2.62
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 217.66,
    y: 66.88,
    width: 0.87,
    height: 0.87
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 217.66,
    y: 69.5,
    width: 0.87,
    height: 1.74
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 217.66,
    y: 72.11,
    width: 0.87,
    height: 2.62
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 217.66,
    y: 79.09,
    width: 0.87,
    height: 0.87
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 217.66,
    y: 80.84,
    width: 0.87,
    height: 0.87
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 217.66,
    y: 82.58,
    width: 0.87,
    height: 3.49
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 217.66,
    y: 90.43,
    width: 0.87,
    height: 0.87
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 217.66,
    y: 92.17,
    width: 0.87,
    height: 0.87
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 218.54,
    y: 36.35,
    width: 0.87,
    height: 1.74
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 218.54,
    y: 38.97,
    width: 0.87,
    height: 0.87
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 218.54,
    y: 40.71,
    width: 0.87,
    height: 2.62
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 218.54,
    y: 44.2,
    width: 0.87,
    height: 0.87
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 218.54,
    y: 47.69,
    width: 0.87,
    height: 0.87
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 218.54,
    y: 49.44,
    width: 0.87,
    height: 0.87
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 218.54,
    y: 52.05,
    width: 0.87,
    height: 0.87
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 218.54,
    y: 53.8,
    width: 0.87,
    height: 2.62
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 218.54,
    y: 57.29,
    width: 0.87,
    height: 1.74
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 218.54,
    y: 59.9,
    width: 0.87,
    height: 0.87
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 218.54,
    y: 61.65,
    width: 0.87,
    height: 2.62
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 218.54,
    y: 66.01,
    width: 0.87,
    height: 0.87
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 218.54,
    y: 67.75,
    width: 0.87,
    height: 1.74
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 218.54,
    y: 70.37,
    width: 0.87,
    height: 1.74
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 218.54,
    y: 72.99,
    width: 0.87,
    height: 0.87
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 218.54,
    y: 76.47,
    width: 0.87,
    height: 0.87
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 218.54,
    y: 79.09,
    width: 0.87,
    height: 1.74
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 218.54,
    y: 82.58,
    width: 0.87,
    height: 3.49
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 218.54,
    y: 88.69,
    width: 0.87,
    height: 0.87
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 218.54,
    y: 92.17,
    width: 0.87,
    height: 0.87
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.41,
    y: 37.23,
    width: 0.87,
    height: 4.36
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.41,
    y: 42.46,
    width: 0.87,
    height: 0.87
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.41,
    y: 45.95,
    width: 0.87,
    height: 0.87
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.41,
    y: 49.44,
    width: 0.87,
    height: 0.87
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.41,
    y: 51.18,
    width: 0.87,
    height: 0.87
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.41,
    y: 53.8,
    width: 0.87,
    height: 0.87
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.41,
    y: 56.41,
    width: 0.87,
    height: 1.74
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.41,
    y: 63.39,
    width: 0.87,
    height: 1.74
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.41,
    y: 67.75,
    width: 0.87,
    height: 1.74
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.41,
    y: 70.37,
    width: 0.87,
    height: 3.49
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.41,
    y: 75.6,
    width: 0.87,
    height: 3.49
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.41,
    y: 79.96,
    width: 0.87,
    height: 0.87
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.41,
    y: 81.71,
    width: 0.87,
    height: 0.87
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.41,
    y: 83.45,
    width: 0.87,
    height: 0.87
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.41,
    y: 85.2,
    width: 0.87,
    height: 0.87
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 219.41,
    y: 90.43,
    width: 0.87,
    height: 1.74
  })), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 220.28,
    y: 39.84,
    width: 0.87,
    height: 4.36
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 220.28,
    y: 45.08,
    width: 0.87,
    height: 0.87
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 220.28,
    y: 51.18,
    width: 0.87,
    height: 0.87
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 220.28,
    y: 52.93,
    width: 0.87,
    height: 3.49
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 220.28,
    y: 58.16,
    width: 0.87,
    height: 0.87
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 220.28,
    y: 59.9,
    width: 0.87,
    height: 0.87
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 220.28,
    y: 61.65,
    width: 0.87,
    height: 4.36
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 220.28,
    y: 67.75,
    width: 0.87,
    height: 0.87
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 220.28,
    y: 69.5,
    width: 0.87,
    height: 1.74
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 220.28,
    y: 72.99,
    width: 0.87,
    height: 2.62
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 220.28,
    y: 77.35,
    width: 0.87,
    height: 6.11
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 220.28,
    y: 88.69,
    width: 0.87,
    height: 0.87
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 220.28,
    y: 90.43,
    width: 0.87,
    height: 1.74
  })), _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 221.15,
    y: 37.23,
    width: 0.87,
    height: 1.74
  })), _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 221.15,
    y: 39.84,
    width: 0.87,
    height: 0.87
  })), _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 221.15,
    y: 42.46,
    width: 0.87,
    height: 0.87
  })), _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 221.15,
    y: 45.08,
    width: 0.87,
    height: 0.87
  })), _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 221.15,
    y: 49.44,
    width: 0.87,
    height: 1.74
  })), _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 221.15,
    y: 54.67,
    width: 0.87,
    height: 2.62
  })), _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 221.15,
    y: 58.16,
    width: 0.87,
    height: 2.62
  })), _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 221.15,
    y: 63.39,
    width: 0.87,
    height: 0.87
  })), _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 221.15,
    y: 65.14,
    width: 0.87,
    height: 1.74
  })), _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 221.15,
    y: 68.62,
    width: 0.87,
    height: 0.87
  })), _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 221.15,
    y: 70.37,
    width: 0.87,
    height: 1.74
  })), _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 221.15,
    y: 73.86,
    width: 0.87,
    height: 0.87
  })), _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 221.15,
    y: 79.09,
    width: 0.87,
    height: 0.87
  })), _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 221.15,
    y: 80.84,
    width: 0.87,
    height: 1.74
  })), _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 221.15,
    y: 84.32,
    width: 0.87,
    height: 1.74
  })), _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 221.15,
    y: 87.81,
    width: 0.87,
    height: 1.74
  })), _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 221.15,
    y: 91.3,
    width: 0.87,
    height: 0.87
  })), _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.02,
    y: 36.35,
    width: 0.87,
    height: 2.62
  })), _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.02,
    y: 39.84,
    width: 0.87,
    height: 2.62
  })), _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.02,
    y: 44.2,
    width: 0.87,
    height: 0.87
  })), _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.02,
    y: 46.82,
    width: 0.87,
    height: 0.87
  })), _rect352 || (_rect352 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.02,
    y: 49.44,
    width: 0.87,
    height: 1.74
  })), _rect353 || (_rect353 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.02,
    y: 52.05,
    width: 0.87,
    height: 3.49
  })), _rect354 || (_rect354 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.02,
    y: 56.41,
    width: 0.87,
    height: 0.87
  })), _rect355 || (_rect355 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.02,
    y: 58.16,
    width: 0.87,
    height: 2.62
  })), _rect356 || (_rect356 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.02,
    y: 62.52,
    width: 0.87,
    height: 1.74
  })), _rect357 || (_rect357 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.02,
    y: 68.62,
    width: 0.87,
    height: 6.98
  })), _rect358 || (_rect358 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.02,
    y: 76.47,
    width: 0.87,
    height: 0.87
  })), _rect359 || (_rect359 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.02,
    y: 78.22,
    width: 0.87,
    height: 1.74
  })), _rect360 || (_rect360 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.02,
    y: 80.84,
    width: 0.87,
    height: 0.87
  })), _rect361 || (_rect361 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.02,
    y: 83.45,
    width: 0.87,
    height: 4.36
  })), _rect362 || (_rect362 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.02,
    y: 90.43,
    width: 0.87,
    height: 2.62
  })), _rect363 || (_rect363 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.9,
    y: 37.23,
    width: 0.87,
    height: 2.62
  })), _rect364 || (_rect364 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.9,
    y: 40.71,
    width: 0.87,
    height: 0.87
  })), _rect365 || (_rect365 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.9,
    y: 42.46,
    width: 0.87,
    height: 4.36
  })), _rect366 || (_rect366 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.9,
    y: 50.31,
    width: 0.87,
    height: 0.87
  })), _rect367 || (_rect367 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.9,
    y: 52.05,
    width: 0.87,
    height: 0.87
  })), _rect368 || (_rect368 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.9,
    y: 53.8,
    width: 0.87,
    height: 0.87
  })), _rect369 || (_rect369 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.9,
    y: 58.16,
    width: 0.87,
    height: 0.87
  })), _rect370 || (_rect370 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.9,
    y: 59.9,
    width: 0.87,
    height: 4.36
  })), _rect371 || (_rect371 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.9,
    y: 66.88,
    width: 0.87,
    height: 3.49
  })), _rect372 || (_rect372 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.9,
    y: 72.99,
    width: 0.87,
    height: 1.74
  })), _rect373 || (_rect373 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.9,
    y: 75.6,
    width: 0.87,
    height: 6.11
  })), _rect374 || (_rect374 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.9,
    y: 82.58,
    width: 0.87,
    height: 0.87
  })), _rect375 || (_rect375 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.9,
    y: 85.2,
    width: 0.87,
    height: 0.87
  })), _rect376 || (_rect376 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.9,
    y: 87.81,
    width: 0.87,
    height: 1.74
  })), _rect377 || (_rect377 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 223.77,
    y: 37.23,
    width: 0.87,
    height: 1.74
  })), _rect378 || (_rect378 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 223.77,
    y: 39.84,
    width: 0.87,
    height: 2.62
  })), _rect379 || (_rect379 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 223.77,
    y: 43.33,
    width: 0.87,
    height: 0.87
  })), _rect380 || (_rect380 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 223.77,
    y: 45.08,
    width: 0.87,
    height: 0.87
  })), _rect381 || (_rect381 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 223.77,
    y: 46.82,
    width: 0.87,
    height: 0.87
  })), _rect382 || (_rect382 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 223.77,
    y: 49.44,
    width: 0.87,
    height: 0.87
  })), _rect383 || (_rect383 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 223.77,
    y: 52.93,
    width: 0.87,
    height: 0.87
  })), _rect384 || (_rect384 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 223.77,
    y: 54.67,
    width: 0.87,
    height: 5.23
  })), _rect385 || (_rect385 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 223.77,
    y: 62.52,
    width: 0.87,
    height: 4.36
  })), _rect386 || (_rect386 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 223.77,
    y: 67.75,
    width: 0.87,
    height: 0.87
  })), _rect387 || (_rect387 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 223.77,
    y: 70.37,
    width: 0.87,
    height: 1.74
  })), _rect388 || (_rect388 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 223.77,
    y: 73.86,
    width: 0.87,
    height: 1.74
  })), _rect389 || (_rect389 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 223.77,
    y: 76.47,
    width: 0.87,
    height: 1.74
  })), _rect390 || (_rect390 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 223.77,
    y: 79.96,
    width: 0.87,
    height: 1.74
  })), _rect391 || (_rect391 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 223.77,
    y: 82.58,
    width: 0.87,
    height: 1.74
  })), _rect392 || (_rect392 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 223.77,
    y: 85.2,
    width: 0.87,
    height: 1.74
  })), _rect393 || (_rect393 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 223.77,
    y: 88.69,
    width: 0.87,
    height: 1.74
  })), _rect394 || (_rect394 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 223.77,
    y: 91.3,
    width: 0.87,
    height: 0.87
  })), _rect395 || (_rect395 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 224.64,
    y: 37.23,
    width: 0.87,
    height: 0.87
  })), _rect396 || (_rect396 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 224.64,
    y: 38.97,
    width: 0.87,
    height: 1.74
  })), _rect397 || (_rect397 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 224.64,
    y: 45.08,
    width: 0.87,
    height: 0.87
  })), _rect398 || (_rect398 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 224.64,
    y: 46.82,
    width: 0.87,
    height: 0.87
  })), _rect399 || (_rect399 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 224.64,
    y: 49.44,
    width: 0.87,
    height: 2.62
  })), _rect400 || (_rect400 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 224.64,
    y: 52.93,
    width: 0.87,
    height: 0.87
  })), _rect401 || (_rect401 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 224.64,
    y: 54.67,
    width: 0.87,
    height: 0.87
  })), _rect402 || (_rect402 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 224.64,
    y: 59.03,
    width: 0.87,
    height: 1.74
  })), _rect403 || (_rect403 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 224.64,
    y: 62.52,
    width: 0.87,
    height: 0.87
  })), _rect404 || (_rect404 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 224.64,
    y: 64.26,
    width: 0.87,
    height: 3.49
  })), _rect405 || (_rect405 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 224.64,
    y: 69.5,
    width: 0.87,
    height: 0.87
  })), _rect406 || (_rect406 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 224.64,
    y: 73.86,
    width: 0.87,
    height: 1.74
  })), _rect407 || (_rect407 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 224.64,
    y: 76.47,
    width: 0.87,
    height: 0.87
  })), _rect408 || (_rect408 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 224.64,
    y: 78.22,
    width: 0.87,
    height: 0.87
  })), _rect409 || (_rect409 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 224.64,
    y: 82.58,
    width: 0.87,
    height: 2.62
  })), _rect410 || (_rect410 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 224.64,
    y: 89.56,
    width: 0.87,
    height: 1.74
  })), _rect411 || (_rect411 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.51,
    y: 36.35,
    width: 0.87,
    height: 1.74
  })), _rect412 || (_rect412 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.51,
    y: 38.97,
    width: 0.87,
    height: 0.87
  })), _rect413 || (_rect413 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.51,
    y: 40.71,
    width: 0.87,
    height: 2.62
  })), _rect414 || (_rect414 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.51,
    y: 44.2,
    width: 0.87,
    height: 1.74
  })), _rect415 || (_rect415 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.51,
    y: 49.44,
    width: 0.87,
    height: 0.87
  })), _rect416 || (_rect416 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.51,
    y: 52.93,
    width: 0.87,
    height: 1.74
  })), _rect417 || (_rect417 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.51,
    y: 56.41,
    width: 0.87,
    height: 0.87
  })), _rect418 || (_rect418 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.51,
    y: 58.16,
    width: 0.87,
    height: 1.74
  })), _rect419 || (_rect419 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.51,
    y: 60.77,
    width: 0.87,
    height: 0.87
  })), _rect420 || (_rect420 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.51,
    y: 62.52,
    width: 0.87,
    height: 1.74
  })), _rect421 || (_rect421 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.51,
    y: 65.14,
    width: 0.87,
    height: 0.87
  })), _rect422 || (_rect422 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.51,
    y: 66.88,
    width: 0.87,
    height: 0.87
  })), _rect423 || (_rect423 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.51,
    y: 68.62,
    width: 0.87,
    height: 0.87
  })), _rect424 || (_rect424 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.51,
    y: 71.24,
    width: 0.87,
    height: 0.87
  })), _rect425 || (_rect425 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.51,
    y: 72.99,
    width: 0.87,
    height: 0.87
  })), _rect426 || (_rect426 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.51,
    y: 76.47,
    width: 0.87,
    height: 0.87
  })), _rect427 || (_rect427 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.51,
    y: 78.22,
    width: 0.87,
    height: 0.87
  })), _rect428 || (_rect428 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.51,
    y: 79.96,
    width: 0.87,
    height: 1.74
  })), _rect429 || (_rect429 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.51,
    y: 83.45,
    width: 0.87,
    height: 0.87
  })), _rect430 || (_rect430 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.51,
    y: 85.2,
    width: 0.87,
    height: 3.49
  })), _rect431 || (_rect431 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.51,
    y: 89.56,
    width: 0.87,
    height: 0.87
  })), _rect432 || (_rect432 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.51,
    y: 92.17,
    width: 0.87,
    height: 0.87
  })), _rect433 || (_rect433 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 226.39,
    y: 37.23,
    width: 0.87,
    height: 0.87
  })), _rect434 || (_rect434 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 226.39,
    y: 39.84,
    width: 0.87,
    height: 0.87
  })), _rect435 || (_rect435 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 226.39,
    y: 43.33,
    width: 0.87,
    height: 0.87
  })), _rect436 || (_rect436 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 226.39,
    y: 45.08,
    width: 0.87,
    height: 0.87
  })), _rect437 || (_rect437 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 226.39,
    y: 46.82,
    width: 0.87,
    height: 0.87
  })), _rect438 || (_rect438 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 226.39,
    y: 49.44,
    width: 0.87,
    height: 1.74
  })), _rect439 || (_rect439 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 226.39,
    y: 52.05,
    width: 0.87,
    height: 0.87
  })), _rect440 || (_rect440 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 226.39,
    y: 53.8,
    width: 0.87,
    height: 0.87
  })), _rect441 || (_rect441 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 226.39,
    y: 55.54,
    width: 0.87,
    height: 0.87
  })), _rect442 || (_rect442 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 226.39,
    y: 57.29,
    width: 0.87,
    height: 0.87
  })), _rect443 || (_rect443 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 226.39,
    y: 59.9,
    width: 0.87,
    height: 1.74
  })), _rect444 || (_rect444 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 226.39,
    y: 62.52,
    width: 0.87,
    height: 0.87
  })), _rect445 || (_rect445 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 226.39,
    y: 66.01,
    width: 0.87,
    height: 0.87
  })), _rect446 || (_rect446 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 226.39,
    y: 68.62,
    width: 0.87,
    height: 0.87
  })), _rect447 || (_rect447 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 226.39,
    y: 71.24,
    width: 0.87,
    height: 1.74
  })), _rect448 || (_rect448 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 226.39,
    y: 73.86,
    width: 0.87,
    height: 1.74
  })), _rect449 || (_rect449 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 226.39,
    y: 76.47,
    width: 0.87,
    height: 0.87
  })), _rect450 || (_rect450 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 226.39,
    y: 80.84,
    width: 0.87,
    height: 0.87
  })), _rect451 || (_rect451 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 226.39,
    y: 83.45,
    width: 0.87,
    height: 1.74
  })), _rect452 || (_rect452 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 226.39,
    y: 86.07,
    width: 0.87,
    height: 1.74
  })), _rect453 || (_rect453 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 226.39,
    y: 90.43,
    width: 0.87,
    height: 0.87
  })), _rect454 || (_rect454 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 226.39,
    y: 92.17,
    width: 0.87,
    height: 0.87
  })), _rect455 || (_rect455 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 227.26,
    y: 39.84,
    width: 0.87,
    height: 5.23
  })), _rect456 || (_rect456 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 227.26,
    y: 45.95,
    width: 0.87,
    height: 0.87
  })), _rect457 || (_rect457 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 227.26,
    y: 47.69,
    width: 0.87,
    height: 0.87
  })), _rect458 || (_rect458 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 227.26,
    y: 49.44,
    width: 0.87,
    height: 1.74
  })), _rect459 || (_rect459 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 227.26,
    y: 53.8,
    width: 0.87,
    height: 0.87
  })), _rect460 || (_rect460 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 227.26,
    y: 56.41,
    width: 0.87,
    height: 2.62
  })), _rect461 || (_rect461 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 227.26,
    y: 59.9,
    width: 0.87,
    height: 0.87
  })), _rect462 || (_rect462 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 227.26,
    y: 63.39,
    width: 0.87,
    height: 0.87
  })), _rect463 || (_rect463 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 227.26,
    y: 65.14,
    width: 0.87,
    height: 2.62
  })), _rect464 || (_rect464 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 227.26,
    y: 68.62,
    width: 0.87,
    height: 0.87
  })), _rect465 || (_rect465 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 227.26,
    y: 70.37,
    width: 0.87,
    height: 2.62
  })), _rect466 || (_rect466 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 227.26,
    y: 74.73,
    width: 0.87,
    height: 5.23
  })), _rect467 || (_rect467 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 227.26,
    y: 82.58,
    width: 0.87,
    height: 0.87
  })), _rect468 || (_rect468 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 227.26,
    y: 87.81,
    width: 0.87,
    height: 0.87
  })), _rect469 || (_rect469 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 227.26,
    y: 90.43,
    width: 0.87,
    height: 0.87
  })), _rect470 || (_rect470 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 227.26,
    y: 92.17,
    width: 0.87,
    height: 0.87
  })), _rect471 || (_rect471 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 228.13,
    y: 36.35,
    width: 0.87,
    height: 0.87
  })), _rect472 || (_rect472 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 228.13,
    y: 38.97,
    width: 0.87,
    height: 1.74
  })), _rect473 || (_rect473 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 228.13,
    y: 44.2,
    width: 0.87,
    height: 0.87
  })), _rect474 || (_rect474 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 228.13,
    y: 48.56,
    width: 0.87,
    height: 1.74
  })), _rect475 || (_rect475 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 228.13,
    y: 51.18,
    width: 0.87,
    height: 1.74
  })), _rect476 || (_rect476 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 228.13,
    y: 53.8,
    width: 0.87,
    height: 0.87
  })), _rect477 || (_rect477 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 228.13,
    y: 58.16,
    width: 0.87,
    height: 1.74
  })), _rect478 || (_rect478 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 228.13,
    y: 61.65,
    width: 0.87,
    height: 3.49
  })), _rect479 || (_rect479 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 228.13,
    y: 66.01,
    width: 0.87,
    height: 0.87
  })), _rect480 || (_rect480 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 228.13,
    y: 67.75,
    width: 0.87,
    height: 0.87
  })), _rect481 || (_rect481 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 228.13,
    y: 69.5,
    width: 0.87,
    height: 0.87
  })), _rect482 || (_rect482 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 228.13,
    y: 71.24,
    width: 0.87,
    height: 1.74
  })), _rect483 || (_rect483 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 228.13,
    y: 76.47,
    width: 0.87,
    height: 0.87
  })), _rect484 || (_rect484 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 228.13,
    y: 78.22,
    width: 0.87,
    height: 1.74
  })), _rect485 || (_rect485 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 228.13,
    y: 80.84,
    width: 0.87,
    height: 0.87
  })), _rect486 || (_rect486 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 228.13,
    y: 82.58,
    width: 0.87,
    height: 1.74
  })), _rect487 || (_rect487 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 228.13,
    y: 85.2,
    width: 0.87,
    height: 0.87
  })), _rect488 || (_rect488 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 228.13,
    y: 86.94,
    width: 0.87,
    height: 0.87
  })), _rect489 || (_rect489 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 228.13,
    y: 88.69,
    width: 0.87,
    height: 0.87
  })), _rect490 || (_rect490 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 228.13,
    y: 91.3,
    width: 0.87,
    height: 0.87
  })), _rect491 || (_rect491 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229,
    y: 36.35,
    width: 0.87,
    height: 4.36
  })), _rect492 || (_rect492 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229,
    y: 41.59,
    width: 0.87,
    height: 1.74
  })), _rect493 || (_rect493 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229,
    y: 45.95,
    width: 0.87,
    height: 0.87
  })), _rect494 || (_rect494 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229,
    y: 47.69,
    width: 0.87,
    height: 0.87
  })), _rect495 || (_rect495 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229,
    y: 49.44,
    width: 0.87,
    height: 0.87
  })), _rect496 || (_rect496 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229,
    y: 53.8,
    width: 0.87,
    height: 0.87
  })), _rect497 || (_rect497 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229,
    y: 56.41,
    width: 0.87,
    height: 2.62
  })), _rect498 || (_rect498 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229,
    y: 59.9,
    width: 0.87,
    height: 1.74
  })), _rect499 || (_rect499 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229,
    y: 64.26,
    width: 0.87,
    height: 0.87
  })), _rect500 || (_rect500 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229,
    y: 66.88,
    width: 0.87,
    height: 0.87
  })), _rect501 || (_rect501 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229,
    y: 68.62,
    width: 0.87,
    height: 2.62
  })), _rect502 || (_rect502 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229,
    y: 73.86,
    width: 0.87,
    height: 1.74
  })), _rect503 || (_rect503 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229,
    y: 76.47,
    width: 0.87,
    height: 2.62
  })), _rect504 || (_rect504 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229,
    y: 80.84,
    width: 0.87,
    height: 0.87
  })), _rect505 || (_rect505 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229,
    y: 82.58,
    width: 0.87,
    height: 0.87
  })), _rect506 || (_rect506 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229,
    y: 84.32,
    width: 0.87,
    height: 0.87
  })), _rect507 || (_rect507 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229,
    y: 86.07,
    width: 0.87,
    height: 0.87
  })), _rect508 || (_rect508 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229,
    y: 87.81,
    width: 0.87,
    height: 2.62
  })), _rect509 || (_rect509 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229,
    y: 91.3,
    width: 0.87,
    height: 1.74
  })), _rect510 || (_rect510 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.87,
    y: 36.35,
    width: 0.87,
    height: 0.87
  })), _rect511 || (_rect511 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.87,
    y: 38.97,
    width: 0.87,
    height: 2.62
  })), _rect512 || (_rect512 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.87,
    y: 42.46,
    width: 0.87,
    height: 1.74
  })), _rect513 || (_rect513 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.87,
    y: 45.08,
    width: 0.87,
    height: 1.74
  })), _rect514 || (_rect514 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.87,
    y: 52.05,
    width: 0.87,
    height: 1.74
  })), _rect515 || (_rect515 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.87,
    y: 54.67,
    width: 0.87,
    height: 1.74
  })), _rect516 || (_rect516 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.87,
    y: 57.29,
    width: 0.87,
    height: 1.74
  })), _rect517 || (_rect517 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.87,
    y: 60.77,
    width: 0.87,
    height: 1.74
  })), _rect518 || (_rect518 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.87,
    y: 64.26,
    width: 0.87,
    height: 1.74
  })), _rect519 || (_rect519 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.87,
    y: 66.88,
    width: 0.87,
    height: 1.74
  })), _rect520 || (_rect520 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.87,
    y: 70.37,
    width: 0.87,
    height: 1.74
  })), _rect521 || (_rect521 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.87,
    y: 72.99,
    width: 0.87,
    height: 0.87
  })), _rect522 || (_rect522 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.87,
    y: 75.6,
    width: 0.87,
    height: 0.87
  })), _rect523 || (_rect523 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.87,
    y: 78.22,
    width: 0.87,
    height: 0.87
  })), _rect524 || (_rect524 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.87,
    y: 80.84,
    width: 0.87,
    height: 0.87
  })), _rect525 || (_rect525 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.87,
    y: 83.45,
    width: 0.87,
    height: 2.62
  })), _rect526 || (_rect526 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.87,
    y: 86.94,
    width: 0.87,
    height: 1.74
  })), _rect527 || (_rect527 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.87,
    y: 89.56,
    width: 0.87,
    height: 3.49
  })), _rect528 || (_rect528 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 230.75,
    y: 37.23,
    width: 0.87,
    height: 0.87
  })), _rect529 || (_rect529 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 230.75,
    y: 38.97,
    width: 0.87,
    height: 5.23
  })), _rect530 || (_rect530 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 230.75,
    y: 45.95,
    width: 0.87,
    height: 0.87
  })), _rect531 || (_rect531 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 230.75,
    y: 47.69,
    width: 0.87,
    height: 1.74
  })), _rect532 || (_rect532 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 230.75,
    y: 51.18,
    width: 0.87,
    height: 1.74
  })), _rect533 || (_rect533 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 230.75,
    y: 53.8,
    width: 0.87,
    height: 1.74
  })), _rect534 || (_rect534 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 230.75,
    y: 56.41,
    width: 0.87,
    height: 3.49
  })), _rect535 || (_rect535 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 230.75,
    y: 60.77,
    width: 0.87,
    height: 6.98
  })), _rect536 || (_rect536 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 230.75,
    y: 70.37,
    width: 0.87,
    height: 0.87
  })), _rect537 || (_rect537 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 230.75,
    y: 72.11,
    width: 0.87,
    height: 0.87
  })), _rect538 || (_rect538 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 230.75,
    y: 73.86,
    width: 0.87,
    height: 1.74
  })), _rect539 || (_rect539 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 230.75,
    y: 76.47,
    width: 0.87,
    height: 0.87
  })), _rect540 || (_rect540 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 230.75,
    y: 79.09,
    width: 0.87,
    height: 2.62
  })), _rect541 || (_rect541 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 230.75,
    y: 85.2,
    width: 0.87,
    height: 5.23
  })), _rect542 || (_rect542 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 230.75,
    y: 91.3,
    width: 0.87,
    height: 0.87
  })), _rect543 || (_rect543 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.62,
    y: 36.35,
    width: 0.87,
    height: 0.87
  })), _rect544 || (_rect544 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.62,
    y: 38.1,
    width: 0.87,
    height: 2.62
  })), _rect545 || (_rect545 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.62,
    y: 43.33,
    width: 0.87,
    height: 1.74
  })), _rect546 || (_rect546 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.62,
    y: 47.69,
    width: 0.87,
    height: 2.62
  })), _rect547 || (_rect547 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.62,
    y: 51.18,
    width: 0.87,
    height: 1.74
  })), _rect548 || (_rect548 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.62,
    y: 54.67,
    width: 0.87,
    height: 0.87
  })), _rect549 || (_rect549 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.62,
    y: 56.41,
    width: 0.87,
    height: 0.87
  })), _rect550 || (_rect550 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.62,
    y: 60.77,
    width: 0.87,
    height: 2.62
  })), _rect551 || (_rect551 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.62,
    y: 66.01,
    width: 0.87,
    height: 0.87
  })), _rect552 || (_rect552 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.62,
    y: 68.62,
    width: 0.87,
    height: 0.87
  })), _rect553 || (_rect553 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.62,
    y: 70.37,
    width: 0.87,
    height: 0.87
  })), _rect554 || (_rect554 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.62,
    y: 72.11,
    width: 0.87,
    height: 0.87
  })), _rect555 || (_rect555 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.62,
    y: 73.86,
    width: 0.87,
    height: 0.87
  })), _rect556 || (_rect556 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.62,
    y: 75.6,
    width: 0.87,
    height: 2.62
  })), _rect557 || (_rect557 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.62,
    y: 80.84,
    width: 0.87,
    height: 2.62
  })), _rect558 || (_rect558 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.62,
    y: 85.2,
    width: 0.87,
    height: 0.87
  })), _rect559 || (_rect559 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.62,
    y: 88.69,
    width: 0.87,
    height: 0.87
  })), _rect560 || (_rect560 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 231.62,
    y: 90.43,
    width: 0.87,
    height: 0.87
  })), _rect561 || (_rect561 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 232.49,
    y: 37.23,
    width: 0.87,
    height: 0.87
  })), _rect562 || (_rect562 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 232.49,
    y: 38.97,
    width: 0.87,
    height: 1.74
  })), _rect563 || (_rect563 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 232.49,
    y: 41.59,
    width: 0.87,
    height: 0.87
  })), _rect564 || (_rect564 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 232.49,
    y: 43.33,
    width: 0.87,
    height: 0.87
  })), _rect565 || (_rect565 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 232.49,
    y: 45.08,
    width: 0.87,
    height: 0.87
  })), _rect566 || (_rect566 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 232.49,
    y: 46.82,
    width: 0.87,
    height: 0.87
  })), _rect567 || (_rect567 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 232.49,
    y: 50.31,
    width: 0.87,
    height: 1.74
  })), _rect568 || (_rect568 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 232.49,
    y: 56.41,
    width: 0.87,
    height: 2.62
  })), _rect569 || (_rect569 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 232.49,
    y: 59.9,
    width: 0.87,
    height: 0.87
  })), _rect570 || (_rect570 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 232.49,
    y: 62.52,
    width: 0.87,
    height: 0.87
  })), _rect571 || (_rect571 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 232.49,
    y: 64.26,
    width: 0.87,
    height: 0.87
  })), _rect572 || (_rect572 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 232.49,
    y: 66.01,
    width: 0.87,
    height: 0.87
  })), _rect573 || (_rect573 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 232.49,
    y: 67.75,
    width: 0.87,
    height: 0.87
  })), _rect574 || (_rect574 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 232.49,
    y: 69.5,
    width: 0.87,
    height: 0.87
  })), _rect575 || (_rect575 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 232.49,
    y: 71.24,
    width: 0.87,
    height: 2.62
  })), _rect576 || (_rect576 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 232.49,
    y: 75.6,
    width: 0.87,
    height: 0.87
  })), _rect577 || (_rect577 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 232.49,
    y: 78.22,
    width: 0.87,
    height: 2.62
  })), _rect578 || (_rect578 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 232.49,
    y: 85.2,
    width: 0.87,
    height: 0.87
  })), _rect579 || (_rect579 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 232.49,
    y: 86.94,
    width: 0.87,
    height: 0.87
  })), _rect580 || (_rect580 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 232.49,
    y: 88.69,
    width: 0.87,
    height: 1.74
  })), _rect581 || (_rect581 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 232.49,
    y: 91.3,
    width: 0.87,
    height: 1.74
  })), _rect582 || (_rect582 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.36,
    y: 38.97,
    width: 0.87,
    height: 1.74
  })), _rect583 || (_rect583 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.36,
    y: 43.33,
    width: 0.87,
    height: 0.87
  })), _rect584 || (_rect584 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.36,
    y: 45.95,
    width: 0.87,
    height: 0.87
  })), _rect585 || (_rect585 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.36,
    y: 48.56,
    width: 0.87,
    height: 2.62
  })), _rect586 || (_rect586 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.36,
    y: 54.67,
    width: 0.87,
    height: 1.74
  })), _rect587 || (_rect587 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.36,
    y: 58.16,
    width: 0.87,
    height: 3.49
  })), _rect588 || (_rect588 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.36,
    y: 62.52,
    width: 0.87,
    height: 0.87
  })), _rect589 || (_rect589 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.36,
    y: 66.01,
    width: 0.87,
    height: 0.87
  })), _rect590 || (_rect590 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.36,
    y: 67.75,
    width: 0.87,
    height: 0.87
  })), _rect591 || (_rect591 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.36,
    y: 72.99,
    width: 0.87,
    height: 0.87
  })), _rect592 || (_rect592 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.36,
    y: 74.73,
    width: 0.87,
    height: 0.87
  })), _rect593 || (_rect593 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.36,
    y: 78.22,
    width: 0.87,
    height: 1.74
  })), _rect594 || (_rect594 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.36,
    y: 80.84,
    width: 0.87,
    height: 0.87
  })), _rect595 || (_rect595 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.36,
    y: 83.45,
    width: 0.87,
    height: 2.62
  })), _rect596 || (_rect596 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.36,
    y: 88.69,
    width: 0.87,
    height: 3.49
  })), _rect597 || (_rect597 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 234.24,
    y: 37.23,
    width: 0.87,
    height: 1.74
  })), _rect598 || (_rect598 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 234.24,
    y: 39.84,
    width: 0.87,
    height: 7.85
  })), _rect599 || (_rect599 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 234.24,
    y: 48.56,
    width: 0.87,
    height: 3.49
  })), _rect600 || (_rect600 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 234.24,
    y: 55.54,
    width: 0.87,
    height: 2.62
  })), _rect601 || (_rect601 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 234.24,
    y: 59.03,
    width: 0.87,
    height: 7.85
  })), _rect602 || (_rect602 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 234.24,
    y: 68.62,
    width: 0.87,
    height: 0.87
  })), _rect603 || (_rect603 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 234.24,
    y: 71.24,
    width: 0.87,
    height: 2.62
  })), _rect604 || (_rect604 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 234.24,
    y: 75.6,
    width: 0.87,
    height: 0.87
  })), _rect605 || (_rect605 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 234.24,
    y: 77.35,
    width: 0.87,
    height: 0.87
  })), _rect606 || (_rect606 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 234.24,
    y: 79.96,
    width: 0.87,
    height: 1.74
  })), _rect607 || (_rect607 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 234.24,
    y: 82.58,
    width: 0.87,
    height: 6.98
  })), _rect608 || (_rect608 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 234.24,
    y: 90.43,
    width: 0.87,
    height: 0.87
  })), _rect609 || (_rect609 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 234.24,
    y: 92.17,
    width: 0.87,
    height: 0.87
  })), _rect610 || (_rect610 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.11,
    y: 36.35,
    width: 0.87,
    height: 0.87
  })), _rect611 || (_rect611 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.11,
    y: 40.71,
    width: 0.87,
    height: 0.87
  })), _rect612 || (_rect612 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.11,
    y: 44.2,
    width: 0.87,
    height: 1.74
  })), _rect613 || (_rect613 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.11,
    y: 46.82,
    width: 0.87,
    height: 0.87
  })), _rect614 || (_rect614 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.11,
    y: 50.31,
    width: 0.87,
    height: 0.87
  })), _rect615 || (_rect615 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.11,
    y: 52.93,
    width: 0.87,
    height: 1.74
  })), _rect616 || (_rect616 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.11,
    y: 57.29,
    width: 0.87,
    height: 1.74
  })), _rect617 || (_rect617 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.11,
    y: 59.9,
    width: 0.87,
    height: 2.62
  })), _rect618 || (_rect618 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.11,
    y: 63.39,
    width: 0.87,
    height: 0.87
  })), _rect619 || (_rect619 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.11,
    y: 66.01,
    width: 0.87,
    height: 1.74
  })), _rect620 || (_rect620 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.11,
    y: 68.62,
    width: 0.87,
    height: 0.87
  })), _rect621 || (_rect621 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.11,
    y: 72.11,
    width: 0.87,
    height: 1.74
  })), _rect622 || (_rect622 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.11,
    y: 74.73,
    width: 0.87,
    height: 0.87
  })), _rect623 || (_rect623 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.11,
    y: 78.22,
    width: 0.87,
    height: 0.87
  })), _rect624 || (_rect624 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.11,
    y: 81.71,
    width: 0.87,
    height: 0.87
  })), _rect625 || (_rect625 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.11,
    y: 84.32,
    width: 0.87,
    height: 0.87
  })), _rect626 || (_rect626 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.11,
    y: 87.81,
    width: 0.87,
    height: 0.87
  })), _rect627 || (_rect627 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.11,
    y: 89.56,
    width: 0.87,
    height: 2.62
  })), _rect628 || (_rect628 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.98,
    y: 36.35,
    width: 0.87,
    height: 3.49
  })), _rect629 || (_rect629 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.98,
    y: 40.71,
    width: 0.87,
    height: 2.62
  })), _rect630 || (_rect630 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.98,
    y: 45.95,
    width: 0.87,
    height: 0.87
  })), _rect631 || (_rect631 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.98,
    y: 50.31,
    width: 0.87,
    height: 1.74
  })), _rect632 || (_rect632 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.98,
    y: 54.67,
    width: 0.87,
    height: 0.87
  })), _rect633 || (_rect633 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.98,
    y: 57.29,
    width: 0.87,
    height: 0.87
  })), _rect634 || (_rect634 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.98,
    y: 60.77,
    width: 0.87,
    height: 1.74
  })), _rect635 || (_rect635 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.98,
    y: 64.26,
    width: 0.87,
    height: 0.87
  })), _rect636 || (_rect636 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.98,
    y: 66.88,
    width: 0.87,
    height: 1.74
  })), _rect637 || (_rect637 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.98,
    y: 70.37,
    width: 0.87,
    height: 0.87
  })), _rect638 || (_rect638 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.98,
    y: 75.6,
    width: 0.87,
    height: 0.87
  })), _rect639 || (_rect639 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.98,
    y: 78.22,
    width: 0.87,
    height: 0.87
  })), _rect640 || (_rect640 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.98,
    y: 81.71,
    width: 0.87,
    height: 1.74
  })), _rect641 || (_rect641 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.98,
    y: 84.32,
    width: 0.87,
    height: 1.74
  })), _rect642 || (_rect642 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.98,
    y: 87.81,
    width: 0.87,
    height: 0.87
  })), _rect643 || (_rect643 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.98,
    y: 91.3,
    width: 0.87,
    height: 0.87
  })), _rect644 || (_rect644 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 236.85,
    y: 39.84,
    width: 0.87,
    height: 1.74
  })), _rect645 || (_rect645 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 236.85,
    y: 42.46,
    width: 0.87,
    height: 2.62
  })), _rect646 || (_rect646 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 236.85,
    y: 46.82,
    width: 0.87,
    height: 1.74
  })), _rect647 || (_rect647 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 236.85,
    y: 49.44,
    width: 0.87,
    height: 1.74
  })), _rect648 || (_rect648 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 236.85,
    y: 52.05,
    width: 0.87,
    height: 6.11
  })), _rect649 || (_rect649 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 236.85,
    y: 59.9,
    width: 0.87,
    height: 1.74
  })), _rect650 || (_rect650 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 236.85,
    y: 62.52,
    width: 0.87,
    height: 2.62
  })), _rect651 || (_rect651 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 236.85,
    y: 66.01,
    width: 0.87,
    height: 2.62
  })), _rect652 || (_rect652 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 236.85,
    y: 70.37,
    width: 0.87,
    height: 4.36
  })), _rect653 || (_rect653 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 236.85,
    y: 79.09,
    width: 0.87,
    height: 1.74
  })), _rect654 || (_rect654 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 236.85,
    y: 81.71,
    width: 0.87,
    height: 1.74
  })), _rect655 || (_rect655 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 236.85,
    y: 86.07,
    width: 0.87,
    height: 5.23
  })), _rect656 || (_rect656 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 236.85,
    y: 92.17,
    width: 0.87,
    height: 0.87
  })), _rect657 || (_rect657 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 237.72,
    y: 41.59,
    width: 0.87,
    height: 0.87
  })), _rect658 || (_rect658 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 237.72,
    y: 43.33,
    width: 0.87,
    height: 2.62
  })), _rect659 || (_rect659 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 237.72,
    y: 46.82,
    width: 0.87,
    height: 0.87
  })), _rect660 || (_rect660 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 237.72,
    y: 48.56,
    width: 0.87,
    height: 3.49
  })), _rect661 || (_rect661 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 237.72,
    y: 54.67,
    width: 0.87,
    height: 0.87
  })), _rect662 || (_rect662 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 237.72,
    y: 61.65,
    width: 0.87,
    height: 1.74
  })), _rect663 || (_rect663 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 237.72,
    y: 67.75,
    width: 0.87,
    height: 0.87
  })), _rect664 || (_rect664 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 237.72,
    y: 69.5,
    width: 0.87,
    height: 0.87
  })), _rect665 || (_rect665 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 237.72,
    y: 72.11,
    width: 0.87,
    height: 0.87
  })), _rect666 || (_rect666 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 237.72,
    y: 74.73,
    width: 0.87,
    height: 1.74
  })), _rect667 || (_rect667 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 237.72,
    y: 77.35,
    width: 0.87,
    height: 0.87
  })), _rect668 || (_rect668 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 237.72,
    y: 79.09,
    width: 0.87,
    height: 1.74
  })), _rect669 || (_rect669 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 237.72,
    y: 82.58,
    width: 0.87,
    height: 0.87
  })), _rect670 || (_rect670 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 237.72,
    y: 86.94,
    width: 0.87,
    height: 0.87
  })), _rect671 || (_rect671 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 237.72,
    y: 89.56,
    width: 0.87,
    height: 0.87
  })), _rect672 || (_rect672 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 237.72,
    y: 92.17,
    width: 0.87,
    height: 0.87
  })), _rect673 || (_rect673 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.6,
    y: 37.23,
    width: 0.87,
    height: 1.74
  })), _rect674 || (_rect674 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.6,
    y: 40.71,
    width: 0.87,
    height: 0.87
  })), _rect675 || (_rect675 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.6,
    y: 47.69,
    width: 0.87,
    height: 0.87
  })), _rect676 || (_rect676 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.6,
    y: 49.44,
    width: 0.87,
    height: 0.87
  })), _rect677 || (_rect677 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.6,
    y: 51.18,
    width: 0.87,
    height: 0.87
  })), _rect678 || (_rect678 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.6,
    y: 52.93,
    width: 0.87,
    height: 0.87
  })), _rect679 || (_rect679 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.6,
    y: 55.54,
    width: 0.87,
    height: 1.74
  })), _rect680 || (_rect680 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.6,
    y: 59.03,
    width: 0.87,
    height: 0.87
  })), _rect681 || (_rect681 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.6,
    y: 61.65,
    width: 0.87,
    height: 1.74
  })), _rect682 || (_rect682 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.6,
    y: 70.37,
    width: 0.87,
    height: 0.87
  })), _rect683 || (_rect683 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.6,
    y: 72.11,
    width: 0.87,
    height: 0.87
  })), _rect684 || (_rect684 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.6,
    y: 77.35,
    width: 0.87,
    height: 0.87
  })), _rect685 || (_rect685 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.6,
    y: 81.71,
    width: 0.87,
    height: 0.87
  })), _rect686 || (_rect686 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.6,
    y: 84.32,
    width: 0.87,
    height: 0.87
  })), _rect687 || (_rect687 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.6,
    y: 87.81,
    width: 0.87,
    height: 1.74
  })), _rect688 || (_rect688 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.6,
    y: 90.43,
    width: 0.87,
    height: 2.62
  })), _rect689 || (_rect689 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.47,
    y: 36.35,
    width: 0.87,
    height: 0.87
  })), _rect690 || (_rect690 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.47,
    y: 39.84,
    width: 0.87,
    height: 0.87
  })), _rect691 || (_rect691 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.47,
    y: 41.59,
    width: 0.87,
    height: 1.74
  })), _rect692 || (_rect692 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.47,
    y: 44.2,
    width: 0.87,
    height: 5.23
  })), _rect693 || (_rect693 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.47,
    y: 52.05,
    width: 0.87,
    height: 1.74
  })), _rect694 || (_rect694 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.47,
    y: 54.67,
    width: 0.87,
    height: 2.62
  })), _rect695 || (_rect695 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.47,
    y: 58.16,
    width: 0.87,
    height: 2.62
  })), _rect696 || (_rect696 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.47,
    y: 61.65,
    width: 0.87,
    height: 1.74
  })), _rect697 || (_rect697 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.47,
    y: 65.14,
    width: 0.87,
    height: 2.62
  })), _rect698 || (_rect698 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.47,
    y: 68.62,
    width: 0.87,
    height: 2.62
  })), _rect699 || (_rect699 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.47,
    y: 72.11,
    width: 0.87,
    height: 2.62
  })), _rect700 || (_rect700 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.47,
    y: 75.6,
    width: 0.87,
    height: 2.62
  })), _rect701 || (_rect701 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.47,
    y: 79.96,
    width: 0.87,
    height: 0.87
  })), _rect702 || (_rect702 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.47,
    y: 81.71,
    width: 0.87,
    height: 0.87
  })), _rect703 || (_rect703 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.47,
    y: 83.45,
    width: 0.87,
    height: 4.36
  })), _rect704 || (_rect704 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.47,
    y: 88.69,
    width: 0.87,
    height: 2.62
  })), _rect705 || (_rect705 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 239.47,
    y: 92.17,
    width: 0.87,
    height: 0.87
  })), _rect706 || (_rect706 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 240.34,
    y: 36.35,
    width: 0.87,
    height: 0.87
  })), _rect707 || (_rect707 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 240.34,
    y: 38.1,
    width: 0.87,
    height: 0.87
  })), _rect708 || (_rect708 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 240.34,
    y: 44.2,
    width: 0.87,
    height: 0.87
  })), _rect709 || (_rect709 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 240.34,
    y: 49.44,
    width: 0.87,
    height: 3.49
  })), _rect710 || (_rect710 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 240.34,
    y: 54.67,
    width: 0.87,
    height: 0.87
  })), _rect711 || (_rect711 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 240.34,
    y: 58.16,
    width: 0.87,
    height: 1.74
  })), _rect712 || (_rect712 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 240.34,
    y: 62.52,
    width: 0.87,
    height: 0.87
  })), _rect713 || (_rect713 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 240.34,
    y: 64.26,
    width: 0.87,
    height: 1.74
  })), _rect714 || (_rect714 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 240.34,
    y: 66.88,
    width: 0.87,
    height: 1.74
  })), _rect715 || (_rect715 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 240.34,
    y: 69.5,
    width: 0.87,
    height: 0.87
  })), _rect716 || (_rect716 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 240.34,
    y: 71.24,
    width: 0.87,
    height: 0.87
  })), _rect717 || (_rect717 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 240.34,
    y: 75.6,
    width: 0.87,
    height: 0.87
  })), _rect718 || (_rect718 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 240.34,
    y: 78.22,
    width: 0.87,
    height: 2.62
  })), _rect719 || (_rect719 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 240.34,
    y: 82.58,
    width: 0.87,
    height: 1.74
  })), _rect720 || (_rect720 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 240.34,
    y: 86.07,
    width: 0.87,
    height: 0.87
  })), _rect721 || (_rect721 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 240.34,
    y: 91.3,
    width: 0.87,
    height: 0.87
  })), _rect722 || (_rect722 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.21,
    y: 36.35,
    width: 0.87,
    height: 1.74
  })), _rect723 || (_rect723 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.21,
    y: 38.97,
    width: 0.87,
    height: 0.87
  })), _rect724 || (_rect724 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.21,
    y: 41.59,
    width: 0.87,
    height: 0.87
  })), _rect725 || (_rect725 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.21,
    y: 44.2,
    width: 0.87,
    height: 0.87
  })), _rect726 || (_rect726 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.21,
    y: 46.82,
    width: 0.87,
    height: 6.11
  })), _rect727 || (_rect727 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.21,
    y: 55.54,
    width: 0.87,
    height: 0.87
  })), _rect728 || (_rect728 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.21,
    y: 57.29,
    width: 0.87,
    height: 0.87
  })), _rect729 || (_rect729 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.21,
    y: 59.03,
    width: 0.87,
    height: 0.87
  })), _rect730 || (_rect730 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.21,
    y: 60.77,
    width: 0.87,
    height: 1.74
  })), _rect731 || (_rect731 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.21,
    y: 65.14,
    width: 0.87,
    height: 0.87
  })), _rect732 || (_rect732 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.21,
    y: 68.62,
    width: 0.87,
    height: 1.74
  })), _rect733 || (_rect733 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.21,
    y: 72.11,
    width: 0.87,
    height: 1.74
  })), _rect734 || (_rect734 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.21,
    y: 74.73,
    width: 0.87,
    height: 1.74
  })), _rect735 || (_rect735 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.21,
    y: 79.09,
    width: 0.87,
    height: 1.74
  })), _rect736 || (_rect736 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.21,
    y: 82.58,
    width: 0.87,
    height: 0.87
  })), _rect737 || (_rect737 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.21,
    y: 86.07,
    width: 0.87,
    height: 0.87
  })), _rect738 || (_rect738 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.21,
    y: 90.43,
    width: 0.87,
    height: 0.87
  })), _rect739 || (_rect739 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.09,
    y: 36.35,
    width: 0.87,
    height: 0.87
  })), _rect740 || (_rect740 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.09,
    y: 39.84,
    width: 0.87,
    height: 0.87
  })), _rect741 || (_rect741 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.09,
    y: 43.33,
    width: 0.87,
    height: 1.74
  })), _rect742 || (_rect742 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.09,
    y: 45.95,
    width: 0.87,
    height: 0.87
  })), _rect743 || (_rect743 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.09,
    y: 47.69,
    width: 0.87,
    height: 1.74
  })), _rect744 || (_rect744 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.09,
    y: 51.18,
    width: 0.87,
    height: 0.87
  })), _rect745 || (_rect745 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.09,
    y: 53.8,
    width: 0.87,
    height: 1.74
  })), _rect746 || (_rect746 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.09,
    y: 57.29,
    width: 0.87,
    height: 2.62
  })), _rect747 || (_rect747 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.09,
    y: 61.65,
    width: 0.87,
    height: 2.62
  })), _rect748 || (_rect748 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.09,
    y: 65.14,
    width: 0.87,
    height: 3.49
  })), _rect749 || (_rect749 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.09,
    y: 69.5,
    width: 0.87,
    height: 0.87
  })), _rect750 || (_rect750 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.09,
    y: 72.11,
    width: 0.87,
    height: 0.87
  })), _rect751 || (_rect751 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.09,
    y: 75.6,
    width: 0.87,
    height: 1.74
  })), _rect752 || (_rect752 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.09,
    y: 82.58,
    width: 0.87,
    height: 0.87
  })), _rect753 || (_rect753 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.09,
    y: 84.32,
    width: 0.87,
    height: 4.36
  })), _rect754 || (_rect754 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.09,
    y: 89.56,
    width: 0.87,
    height: 2.62
  })), _rect755 || (_rect755 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.96,
    y: 37.23,
    width: 0.87,
    height: 0.87
  })), _rect756 || (_rect756 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.96,
    y: 38.97,
    width: 0.87,
    height: 0.87
  })), _rect757 || (_rect757 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.96,
    y: 40.71,
    width: 0.87,
    height: 1.74
  })), _rect758 || (_rect758 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.96,
    y: 43.33,
    width: 0.87,
    height: 0.87
  })), _rect759 || (_rect759 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.96,
    y: 50.31,
    width: 0.87,
    height: 0.87
  })), _rect760 || (_rect760 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.96,
    y: 52.05,
    width: 0.87,
    height: 0.87
  })), _rect761 || (_rect761 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.96,
    y: 53.8,
    width: 0.87,
    height: 0.87
  })), _rect762 || (_rect762 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.96,
    y: 59.9,
    width: 0.87,
    height: 0.87
  })), _rect763 || (_rect763 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.96,
    y: 61.65,
    width: 0.87,
    height: 0.87
  })), _rect764 || (_rect764 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.96,
    y: 64.26,
    width: 0.87,
    height: 0.87
  })), _rect765 || (_rect765 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.96,
    y: 66.88,
    width: 0.87,
    height: 1.74
  })), _rect766 || (_rect766 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.96,
    y: 74.73,
    width: 0.87,
    height: 0.87
  })), _rect767 || (_rect767 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.96,
    y: 77.35,
    width: 0.87,
    height: 0.87
  })), _rect768 || (_rect768 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.96,
    y: 79.09,
    width: 0.87,
    height: 3.49
  })), _rect769 || (_rect769 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.96,
    y: 85.2,
    width: 0.87,
    height: 0.87
  })), _rect770 || (_rect770 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.96,
    y: 87.81,
    width: 0.87,
    height: 0.87
  })), _rect771 || (_rect771 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.96,
    y: 89.56,
    width: 0.87,
    height: 0.87
  })), _rect772 || (_rect772 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 242.96,
    y: 91.3,
    width: 0.87,
    height: 0.87
  })), _rect773 || (_rect773 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 243.83,
    y: 40.71,
    width: 0.87,
    height: 0.87
  })), _rect774 || (_rect774 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 243.83,
    y: 42.46,
    width: 0.87,
    height: 1.74
  })), _rect775 || (_rect775 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 243.83,
    y: 45.08,
    width: 0.87,
    height: 0.87
  })), _rect776 || (_rect776 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 243.83,
    y: 46.82,
    width: 0.87,
    height: 0.87
  })), _rect777 || (_rect777 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 243.83,
    y: 48.56,
    width: 0.87,
    height: 0.87
  })), _rect778 || (_rect778 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 243.83,
    y: 50.31,
    width: 0.87,
    height: 2.62
  })), _rect779 || (_rect779 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 243.83,
    y: 53.8,
    width: 0.87,
    height: 0.87
  })), _rect780 || (_rect780 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 243.83,
    y: 55.54,
    width: 0.87,
    height: 0.87
  })), _rect781 || (_rect781 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 243.83,
    y: 58.16,
    width: 0.87,
    height: 1.74
  })), _rect782 || (_rect782 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 243.83,
    y: 62.52,
    width: 0.87,
    height: 0.87
  })), _rect783 || (_rect783 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 243.83,
    y: 65.14,
    width: 0.87,
    height: 0.87
  })), _rect784 || (_rect784 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 243.83,
    y: 72.11,
    width: 0.87,
    height: 0.87
  })), _rect785 || (_rect785 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 243.83,
    y: 73.86,
    width: 0.87,
    height: 0.87
  })), _rect786 || (_rect786 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 243.83,
    y: 76.47,
    width: 0.87,
    height: 1.74
  })), _rect787 || (_rect787 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 243.83,
    y: 79.09,
    width: 0.87,
    height: 1.74
  })), _rect788 || (_rect788 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 243.83,
    y: 85.2,
    width: 0.87,
    height: 1.74
  })), _rect789 || (_rect789 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 243.83,
    y: 89.56,
    width: 0.87,
    height: 0.87
  })), _rect790 || (_rect790 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 244.7,
    y: 37.23,
    width: 0.87,
    height: 2.62
  })), _rect791 || (_rect791 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 244.7,
    y: 40.71,
    width: 0.87,
    height: 4.36
  })), _rect792 || (_rect792 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 244.7,
    y: 45.95,
    width: 0.87,
    height: 1.74
  })), _rect793 || (_rect793 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 244.7,
    y: 49.44,
    width: 0.87,
    height: 1.74
  })), _rect794 || (_rect794 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 244.7,
    y: 52.93,
    width: 0.87,
    height: 0.87
  })), _rect795 || (_rect795 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 244.7,
    y: 55.54,
    width: 0.87,
    height: 2.62
  })), _rect796 || (_rect796 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 244.7,
    y: 59.03,
    width: 0.87,
    height: 6.98
  })), _rect797 || (_rect797 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 244.7,
    y: 66.88,
    width: 0.87,
    height: 0.87
  })), _rect798 || (_rect798 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 244.7,
    y: 68.62,
    width: 0.87,
    height: 2.62
  })), _rect799 || (_rect799 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 244.7,
    y: 72.11,
    width: 0.87,
    height: 3.49
  })), _rect800 || (_rect800 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 244.7,
    y: 76.47,
    width: 0.87,
    height: 0.87
  })), _rect801 || (_rect801 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 244.7,
    y: 78.22,
    width: 0.87,
    height: 1.74
  })), _rect802 || (_rect802 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 244.7,
    y: 80.84,
    width: 0.87,
    height: 1.74
  })), _rect803 || (_rect803 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 244.7,
    y: 83.45,
    width: 0.87,
    height: 2.62
  })), _rect804 || (_rect804 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 244.7,
    y: 86.94,
    width: 0.87,
    height: 2.62
  })), _rect805 || (_rect805 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 244.7,
    y: 90.43,
    width: 0.87,
    height: 2.62
  })), _rect806 || (_rect806 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 245.57,
    y: 36.35,
    width: 0.87,
    height: 1.74
  })), _rect807 || (_rect807 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 245.57,
    y: 38.97,
    width: 0.87,
    height: 0.87
  })), _rect808 || (_rect808 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 245.57,
    y: 40.71,
    width: 0.87,
    height: 0.87
  })), _rect809 || (_rect809 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 245.57,
    y: 42.46,
    width: 0.87,
    height: 1.74
  })), _rect810 || (_rect810 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 245.57,
    y: 47.69,
    width: 0.87,
    height: 2.62
  })), _rect811 || (_rect811 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 245.57,
    y: 51.18,
    width: 0.87,
    height: 1.74
  })), _rect812 || (_rect812 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 245.57,
    y: 53.8,
    width: 0.87,
    height: 0.87
  })), _rect813 || (_rect813 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 245.57,
    y: 56.41,
    width: 0.87,
    height: 1.74
  })), _rect814 || (_rect814 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 245.57,
    y: 59.9,
    width: 0.87,
    height: 0.87
  })), _rect815 || (_rect815 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 245.57,
    y: 61.65,
    width: 0.87,
    height: 0.87
  })), _rect816 || (_rect816 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 245.57,
    y: 67.75,
    width: 0.87,
    height: 0.87
  })), _rect817 || (_rect817 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 245.57,
    y: 75.6,
    width: 0.87,
    height: 2.62
  })), _rect818 || (_rect818 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 245.57,
    y: 79.96,
    width: 0.87,
    height: 2.62
  })), _rect819 || (_rect819 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 245.57,
    y: 84.32,
    width: 0.87,
    height: 1.74
  })), _rect820 || (_rect820 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 245.57,
    y: 88.69,
    width: 0.87,
    height: 0.87
  })), _rect821 || (_rect821 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 245.57,
    y: 92.17,
    width: 0.87,
    height: 0.87
  })), _rect822 || (_rect822 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 246.45,
    y: 37.23,
    width: 0.87,
    height: 0.87
  })), _rect823 || (_rect823 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 246.45,
    y: 40.71,
    width: 0.87,
    height: 2.62
  })), _rect824 || (_rect824 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 246.45,
    y: 45.95,
    width: 0.87,
    height: 0.87
  })), _rect825 || (_rect825 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 246.45,
    y: 51.18,
    width: 0.87,
    height: 1.74
  })), _rect826 || (_rect826 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 246.45,
    y: 53.8,
    width: 0.87,
    height: 0.87
  })), _rect827 || (_rect827 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 246.45,
    y: 56.41,
    width: 0.87,
    height: 0.87
  })), _rect828 || (_rect828 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 246.45,
    y: 58.16,
    width: 0.87,
    height: 0.87
  })), _rect829 || (_rect829 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 246.45,
    y: 59.9,
    width: 0.87,
    height: 2.62
  })), _rect830 || (_rect830 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 246.45,
    y: 64.26,
    width: 0.87,
    height: 0.87
  })), _rect831 || (_rect831 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 246.45,
    y: 71.24,
    width: 0.87,
    height: 0.87
  })), _rect832 || (_rect832 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 246.45,
    y: 73.86,
    width: 0.87,
    height: 0.87
  })), _rect833 || (_rect833 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 246.45,
    y: 77.35,
    width: 0.87,
    height: 0.87
  })), _rect834 || (_rect834 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 246.45,
    y: 79.09,
    width: 0.87,
    height: 1.74
  })), _rect835 || (_rect835 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 246.45,
    y: 81.71,
    width: 0.87,
    height: 0.87
  })), _rect836 || (_rect836 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 246.45,
    y: 84.32,
    width: 0.87,
    height: 2.62
  })), _rect837 || (_rect837 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 246.45,
    y: 88.69,
    width: 0.87,
    height: 1.74
  })), _rect838 || (_rect838 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 246.45,
    y: 91.3,
    width: 0.87,
    height: 1.74
  })), _rect839 || (_rect839 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 247.32,
    y: 36.35,
    width: 0.87,
    height: 0.87
  })), _rect840 || (_rect840 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 247.32,
    y: 39.84,
    width: 0.87,
    height: 1.74
  })), _rect841 || (_rect841 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 247.32,
    y: 42.46,
    width: 0.87,
    height: 0.87
  })), _rect842 || (_rect842 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 247.32,
    y: 45.08,
    width: 0.87,
    height: 1.74
  })), _rect843 || (_rect843 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 247.32,
    y: 48.56,
    width: 0.87,
    height: 0.87
  })), _rect844 || (_rect844 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 247.32,
    y: 52.93,
    width: 0.87,
    height: 6.11
  })), _rect845 || (_rect845 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 247.32,
    y: 59.9,
    width: 0.87,
    height: 0.87
  })), _rect846 || (_rect846 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 247.32,
    y: 63.39,
    width: 0.87,
    height: 1.74
  })), _rect847 || (_rect847 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 247.32,
    y: 66.88,
    width: 0.87,
    height: 0.87
  })), _rect848 || (_rect848 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 247.32,
    y: 71.24,
    width: 0.87,
    height: 1.74
  })), _rect849 || (_rect849 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 247.32,
    y: 73.86,
    width: 0.87,
    height: 1.74
  })), _rect850 || (_rect850 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 247.32,
    y: 78.22,
    width: 0.87,
    height: 1.74
  })), _rect851 || (_rect851 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 247.32,
    y: 82.58,
    width: 0.87,
    height: 0.87
  })), _rect852 || (_rect852 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 247.32,
    y: 84.32,
    width: 0.87,
    height: 1.74
  })), _rect853 || (_rect853 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 247.32,
    y: 86.94,
    width: 0.87,
    height: 0.87
  })), _rect854 || (_rect854 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 247.32,
    y: 89.56,
    width: 0.87,
    height: 0.87
  })), _rect855 || (_rect855 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 247.32,
    y: 91.3,
    width: 0.87,
    height: 1.74
  })), _rect856 || (_rect856 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 248.19,
    y: 36.35,
    width: 0.87,
    height: 1.74
  })), _rect857 || (_rect857 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 248.19,
    y: 41.59,
    width: 0.87,
    height: 0.87
  })), _rect858 || (_rect858 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 248.19,
    y: 44.2,
    width: 0.87,
    height: 0.87
  })), _rect859 || (_rect859 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 248.19,
    y: 47.69,
    width: 0.87,
    height: 0.87
  })), _rect860 || (_rect860 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 248.19,
    y: 50.31,
    width: 0.87,
    height: 1.74
  })), _rect861 || (_rect861 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 248.19,
    y: 53.8,
    width: 0.87,
    height: 0.87
  })), _rect862 || (_rect862 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 248.19,
    y: 55.54,
    width: 0.87,
    height: 0.87
  })), _rect863 || (_rect863 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 248.19,
    y: 60.77,
    width: 0.87,
    height: 1.74
  })), _rect864 || (_rect864 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 248.19,
    y: 66.01,
    width: 0.87,
    height: 0.87
  })), _rect865 || (_rect865 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 248.19,
    y: 67.75,
    width: 0.87,
    height: 2.62
  })), _rect866 || (_rect866 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 248.19,
    y: 71.24,
    width: 0.87,
    height: 0.87
  })), _rect867 || (_rect867 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 248.19,
    y: 72.99,
    width: 0.87,
    height: 0.87
  })), _rect868 || (_rect868 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 248.19,
    y: 76.47,
    width: 0.87,
    height: 1.74
  })), _rect869 || (_rect869 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 248.19,
    y: 83.45,
    width: 0.87,
    height: 0.87
  })), _rect870 || (_rect870 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 248.19,
    y: 90.43,
    width: 0.87,
    height: 0.87
  })), _rect871 || (_rect871 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.06,
    y: 37.23,
    width: 0.87,
    height: 0.87
  })), _rect872 || (_rect872 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.06,
    y: 40.71,
    width: 0.87,
    height: 0.87
  })), _rect873 || (_rect873 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.06,
    y: 42.46,
    width: 0.87,
    height: 2.62
  })), _rect874 || (_rect874 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.06,
    y: 45.95,
    width: 0.87,
    height: 0.87
  })), _rect875 || (_rect875 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.06,
    y: 47.69,
    width: 0.87,
    height: 0.87
  })), _rect876 || (_rect876 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.06,
    y: 49.44,
    width: 0.87,
    height: 3.49
  })), _rect877 || (_rect877 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.06,
    y: 53.8,
    width: 0.87,
    height: 0.87
  })), _rect878 || (_rect878 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.06,
    y: 56.41,
    width: 0.87,
    height: 0.87
  })), _rect879 || (_rect879 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.06,
    y: 61.65,
    width: 0.87,
    height: 0.87
  })), _rect880 || (_rect880 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.06,
    y: 66.88,
    width: 0.87,
    height: 1.74
  })), _rect881 || (_rect881 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.06,
    y: 74.73,
    width: 0.87,
    height: 0.87
  })), _rect882 || (_rect882 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.06,
    y: 77.35,
    width: 0.87,
    height: 0.87
  })), _rect883 || (_rect883 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.06,
    y: 79.96,
    width: 0.87,
    height: 2.62
  })), _rect884 || (_rect884 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.06,
    y: 87.81,
    width: 0.87,
    height: 0.87
  })), _rect885 || (_rect885 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.06,
    y: 90.43,
    width: 0.87,
    height: 2.62
  })), _rect886 || (_rect886 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.93,
    y: 36.35,
    width: 0.87,
    height: 0.87
  })), _rect887 || (_rect887 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.93,
    y: 38.1,
    width: 0.87,
    height: 1.74
  })), _rect888 || (_rect888 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.93,
    y: 41.59,
    width: 0.87,
    height: 1.74
  })), _rect889 || (_rect889 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.93,
    y: 44.2,
    width: 0.87,
    height: 1.74
  })), _rect890 || (_rect890 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.93,
    y: 48.56,
    width: 0.87,
    height: 1.74
  })), _rect891 || (_rect891 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.93,
    y: 52.05,
    width: 0.87,
    height: 0.87
  })), _rect892 || (_rect892 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.93,
    y: 53.8,
    width: 0.87,
    height: 2.62
  })), _rect893 || (_rect893 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.93,
    y: 58.16,
    width: 0.87,
    height: 3.49
  })), _rect894 || (_rect894 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.93,
    y: 62.52,
    width: 0.87,
    height: 0.87
  })), _rect895 || (_rect895 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.93,
    y: 64.26,
    width: 0.87,
    height: 2.62
  })), _rect896 || (_rect896 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.93,
    y: 67.75,
    width: 0.87,
    height: 0.87
  })), _rect897 || (_rect897 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.93,
    y: 69.5,
    width: 0.87,
    height: 1.74
  })), _rect898 || (_rect898 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.93,
    y: 72.11,
    width: 0.87,
    height: 1.74
  })), _rect899 || (_rect899 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.93,
    y: 74.73,
    width: 0.87,
    height: 0.87
  })), _rect900 || (_rect900 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.93,
    y: 76.47,
    width: 0.87,
    height: 1.74
  })), _rect901 || (_rect901 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.93,
    y: 79.96,
    width: 0.87,
    height: 0.87
  })), _rect902 || (_rect902 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.93,
    y: 83.45,
    width: 0.87,
    height: 1.74
  })), _rect903 || (_rect903 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.93,
    y: 86.07,
    width: 0.87,
    height: 2.62
  })), _rect904 || (_rect904 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.93,
    y: 90.43,
    width: 0.87,
    height: 0.87
  })), _rect905 || (_rect905 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.93,
    y: 92.17,
    width: 0.87,
    height: 0.87
  })), _rect906 || (_rect906 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.81,
    y: 36.35,
    width: 0.87,
    height: 2.62
  })), _rect907 || (_rect907 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.81,
    y: 42.46,
    width: 0.87,
    height: 0.87
  })), _rect908 || (_rect908 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.81,
    y: 45.08,
    width: 0.87,
    height: 0.87
  })), _rect909 || (_rect909 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.81,
    y: 47.69,
    width: 0.87,
    height: 0.87
  })), _rect910 || (_rect910 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.81,
    y: 51.18,
    width: 0.87,
    height: 3.49
  })), _rect911 || (_rect911 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.81,
    y: 56.41,
    width: 0.87,
    height: 0.87
  })), _rect912 || (_rect912 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.81,
    y: 59.03,
    width: 0.87,
    height: 0.87
  })), _rect913 || (_rect913 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.81,
    y: 61.65,
    width: 0.87,
    height: 0.87
  })), _rect914 || (_rect914 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.81,
    y: 64.26,
    width: 0.87,
    height: 1.74
  })), _rect915 || (_rect915 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.81,
    y: 67.75,
    width: 0.87,
    height: 2.62
  })), _rect916 || (_rect916 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.81,
    y: 72.99,
    width: 0.87,
    height: 2.62
  })), _rect917 || (_rect917 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.81,
    y: 76.47,
    width: 0.87,
    height: 1.74
  })), _rect918 || (_rect918 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.81,
    y: 79.96,
    width: 0.87,
    height: 0.87
  })), _rect919 || (_rect919 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.81,
    y: 81.71,
    width: 0.87,
    height: 1.74
  })), _rect920 || (_rect920 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.81,
    y: 88.69,
    width: 0.87,
    height: 0.87
  })), _rect921 || (_rect921 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.81,
    y: 90.43,
    width: 0.87,
    height: 1.74
  })), _rect922 || (_rect922 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 251.68,
    y: 38.1,
    width: 0.87,
    height: 1.74
  })), _rect923 || (_rect923 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 251.68,
    y: 40.71,
    width: 0.87,
    height: 1.74
  })), _rect924 || (_rect924 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 251.68,
    y: 44.2,
    width: 0.87,
    height: 0.87
  })), _rect925 || (_rect925 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 251.68,
    y: 46.82,
    width: 0.87,
    height: 1.74
  })), _rect926 || (_rect926 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 251.68,
    y: 51.18,
    width: 0.87,
    height: 0.87
  })), _rect927 || (_rect927 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 251.68,
    y: 55.54,
    width: 0.87,
    height: 0.87
  })), _rect928 || (_rect928 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 251.68,
    y: 58.16,
    width: 0.87,
    height: 0.87
  })), _rect929 || (_rect929 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 251.68,
    y: 60.77,
    width: 0.87,
    height: 1.74
  })), _rect930 || (_rect930 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 251.68,
    y: 65.14,
    width: 0.87,
    height: 4.36
  })), _rect931 || (_rect931 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 251.68,
    y: 71.24,
    width: 0.87,
    height: 2.62
  })), _rect932 || (_rect932 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 251.68,
    y: 76.47,
    width: 0.87,
    height: 2.62
  })), _rect933 || (_rect933 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 251.68,
    y: 81.71,
    width: 0.87,
    height: 2.62
  })), _rect934 || (_rect934 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 251.68,
    y: 85.2,
    width: 0.87,
    height: 0.87
  })), _rect935 || (_rect935 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 251.68,
    y: 86.94,
    width: 0.87,
    height: 0.87
  })), _rect936 || (_rect936 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 251.68,
    y: 88.69,
    width: 0.87,
    height: 2.62
  })), _rect937 || (_rect937 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 252.55,
    y: 36.35,
    width: 0.87,
    height: 0.87
  })), _rect938 || (_rect938 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 252.55,
    y: 38.97,
    width: 0.87,
    height: 0.87
  })), _rect939 || (_rect939 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 252.55,
    y: 42.46,
    width: 0.87,
    height: 0.87
  })), _rect940 || (_rect940 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 252.55,
    y: 45.08,
    width: 0.87,
    height: 2.62
  })), _rect941 || (_rect941 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 252.55,
    y: 48.56,
    width: 0.87,
    height: 2.62
  })), _rect942 || (_rect942 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 252.55,
    y: 53.8,
    width: 0.87,
    height: 4.36
  })), _rect943 || (_rect943 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 252.55,
    y: 59.9,
    width: 0.87,
    height: 1.74
  })), _rect944 || (_rect944 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 252.55,
    y: 65.14,
    width: 0.87,
    height: 0.87
  })), _rect945 || (_rect945 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 252.55,
    y: 70.37,
    width: 0.87,
    height: 1.74
  })), _rect946 || (_rect946 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 252.55,
    y: 72.99,
    width: 0.87,
    height: 2.62
  })), _rect947 || (_rect947 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 252.55,
    y: 77.35,
    width: 0.87,
    height: 0.87
  })), _rect948 || (_rect948 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 252.55,
    y: 79.09,
    width: 0.87,
    height: 0.87
  })), _rect949 || (_rect949 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 252.55,
    y: 80.84,
    width: 0.87,
    height: 0.87
  })), _rect950 || (_rect950 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 252.55,
    y: 85.2,
    width: 0.87,
    height: 1.74
  })), _rect951 || (_rect951 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 252.55,
    y: 87.81,
    width: 0.87,
    height: 1.74
  })), _rect952 || (_rect952 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 252.55,
    y: 91.3,
    width: 0.87,
    height: 0.87
  })), _rect953 || (_rect953 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.42,
    y: 37.23,
    width: 0.87,
    height: 1.74
  })), _rect954 || (_rect954 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.42,
    y: 39.84,
    width: 0.87,
    height: 0.87
  })), _rect955 || (_rect955 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.42,
    y: 41.59,
    width: 0.87,
    height: 0.87
  })), _rect956 || (_rect956 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.42,
    y: 44.2,
    width: 0.87,
    height: 1.74
  })), _rect957 || (_rect957 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.42,
    y: 46.82,
    width: 0.87,
    height: 1.74
  })), _rect958 || (_rect958 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.42,
    y: 50.31,
    width: 0.87,
    height: 0.87
  })), _rect959 || (_rect959 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.42,
    y: 52.05,
    width: 0.87,
    height: 0.87
  })), _rect960 || (_rect960 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.42,
    y: 54.67,
    width: 0.87,
    height: 0.87
  })), _rect961 || (_rect961 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.42,
    y: 57.29,
    width: 0.87,
    height: 1.74
  })), _rect962 || (_rect962 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.42,
    y: 60.77,
    width: 0.87,
    height: 0.87
  })), _rect963 || (_rect963 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.42,
    y: 62.52,
    width: 0.87,
    height: 4.36
  })), _rect964 || (_rect964 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.42,
    y: 67.75,
    width: 0.87,
    height: 0.87
  })), _rect965 || (_rect965 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.42,
    y: 69.5,
    width: 0.87,
    height: 2.62
  })), _rect966 || (_rect966 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.42,
    y: 72.99,
    width: 0.87,
    height: 1.74
  })), _rect967 || (_rect967 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.42,
    y: 77.35,
    width: 0.87,
    height: 1.74
  })), _rect968 || (_rect968 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.42,
    y: 79.96,
    width: 0.87,
    height: 0.87
  })), _rect969 || (_rect969 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.42,
    y: 81.71,
    width: 0.87,
    height: 0.87
  })), _rect970 || (_rect970 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.42,
    y: 84.32,
    width: 0.87,
    height: 5.23
  })), _rect971 || (_rect971 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.42,
    y: 90.43,
    width: 0.87,
    height: 0.87
  })), _rect972 || (_rect972 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.42,
    y: 92.17,
    width: 0.87,
    height: 0.87
  })), _rect973 || (_rect973 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 254.3,
    y: 43.33,
    width: 0.87,
    height: 5.23
  })), _rect974 || (_rect974 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 254.3,
    y: 51.18,
    width: 0.87,
    height: 0.87
  })), _rect975 || (_rect975 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 254.3,
    y: 56.41,
    width: 0.87,
    height: 3.49
  })), _rect976 || (_rect976 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 254.3,
    y: 62.52,
    width: 0.87,
    height: 0.87
  })), _rect977 || (_rect977 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 254.3,
    y: 66.01,
    width: 0.87,
    height: 0.87
  })), _rect978 || (_rect978 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 254.3,
    y: 67.75,
    width: 0.87,
    height: 0.87
  })), _rect979 || (_rect979 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 254.3,
    y: 69.5,
    width: 0.87,
    height: 0.87
  })), _rect980 || (_rect980 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 254.3,
    y: 71.24,
    width: 0.87,
    height: 0.87
  })), _rect981 || (_rect981 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 254.3,
    y: 72.99,
    width: 0.87,
    height: 0.87
  })), _rect982 || (_rect982 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 254.3,
    y: 75.6,
    width: 0.87,
    height: 2.62
  })), _rect983 || (_rect983 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 254.3,
    y: 81.71,
    width: 0.87,
    height: 2.62
  })), _rect984 || (_rect984 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 254.3,
    y: 85.2,
    width: 0.87,
    height: 0.87
  })), _rect985 || (_rect985 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 254.3,
    y: 88.69,
    width: 0.87,
    height: 1.74
  })), _rect986 || (_rect986 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.17,
    y: 36.35,
    width: 0.87,
    height: 6.11
  })), _rect987 || (_rect987 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.17,
    y: 43.33,
    width: 0.87,
    height: 4.36
  })), _rect988 || (_rect988 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.17,
    y: 49.44,
    width: 0.87,
    height: 1.74
  })), _rect989 || (_rect989 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.17,
    y: 52.05,
    width: 0.87,
    height: 1.74
  })), _rect990 || (_rect990 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.17,
    y: 54.67,
    width: 0.87,
    height: 1.74
  })), _rect991 || (_rect991 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.17,
    y: 57.29,
    width: 0.87,
    height: 0.87
  })), _rect992 || (_rect992 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.17,
    y: 59.03,
    width: 0.87,
    height: 1.74
  })), _rect993 || (_rect993 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.17,
    y: 62.52,
    width: 0.87,
    height: 0.87
  })), _rect994 || (_rect994 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.17,
    y: 64.26,
    width: 0.87,
    height: 0.87
  })), _rect995 || (_rect995 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.17,
    y: 66.01,
    width: 0.87,
    height: 1.74
  })), _rect996 || (_rect996 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.17,
    y: 68.62,
    width: 0.87,
    height: 2.62
  })), _rect997 || (_rect997 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.17,
    y: 73.86,
    width: 0.87,
    height: 0.87
  })), _rect998 || (_rect998 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.17,
    y: 75.6,
    width: 0.87,
    height: 0.87
  })), _rect999 || (_rect999 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.17,
    y: 78.22,
    width: 0.87,
    height: 1.74
  })), _rect1000 || (_rect1000 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.17,
    y: 82.58,
    width: 0.87,
    height: 1.74
  })), _rect1001 || (_rect1001 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.17,
    y: 85.2,
    width: 0.87,
    height: 0.87
  })), _rect1002 || (_rect1002 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.17,
    y: 86.94,
    width: 0.87,
    height: 0.87
  })), _rect1003 || (_rect1003 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.17,
    y: 88.69,
    width: 0.87,
    height: 0.87
  })), _rect1004 || (_rect1004 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.17,
    y: 90.43,
    width: 0.87,
    height: 1.74
  })), _rect1005 || (_rect1005 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.04,
    y: 36.35,
    width: 0.87,
    height: 0.87
  })), _rect1006 || (_rect1006 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.04,
    y: 41.59,
    width: 0.87,
    height: 0.87
  })), _rect1007 || (_rect1007 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.04,
    y: 43.33,
    width: 0.87,
    height: 0.87
  })), _rect1008 || (_rect1008 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.04,
    y: 47.69,
    width: 0.87,
    height: 3.49
  })), _rect1009 || (_rect1009 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.04,
    y: 52.93,
    width: 0.87,
    height: 0.87
  })), _rect1010 || (_rect1010 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.04,
    y: 55.54,
    width: 0.87,
    height: 1.74
  })), _rect1011 || (_rect1011 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.04,
    y: 58.16,
    width: 0.87,
    height: 5.23
  })), _rect1012 || (_rect1012 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.04,
    y: 66.01,
    width: 0.87,
    height: 0.87
  })), _rect1013 || (_rect1013 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.04,
    y: 69.5,
    width: 0.87,
    height: 0.87
  })), _rect1014 || (_rect1014 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.04,
    y: 72.11,
    width: 0.87,
    height: 0.87
  })), _rect1015 || (_rect1015 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.04,
    y: 73.86,
    width: 0.87,
    height: 0.87
  })), _rect1016 || (_rect1016 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.04,
    y: 78.22,
    width: 0.87,
    height: 0.87
  })), _rect1017 || (_rect1017 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.04,
    y: 79.96,
    width: 0.87,
    height: 0.87
  })), _rect1018 || (_rect1018 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.04,
    y: 81.71,
    width: 0.87,
    height: 0.87
  })), _rect1019 || (_rect1019 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.04,
    y: 83.45,
    width: 0.87,
    height: 0.87
  })), _rect1020 || (_rect1020 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.04,
    y: 85.2,
    width: 0.87,
    height: 0.87
  })), _rect1021 || (_rect1021 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.04,
    y: 88.69,
    width: 0.87,
    height: 3.49
  })), _rect1022 || (_rect1022 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.91,
    y: 36.35,
    width: 0.87,
    height: 0.87
  })), _rect1023 || (_rect1023 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.91,
    y: 38.1,
    width: 0.87,
    height: 2.62
  })), _rect1024 || (_rect1024 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.91,
    y: 41.59,
    width: 0.87,
    height: 0.87
  })), _rect1025 || (_rect1025 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.91,
    y: 43.33,
    width: 0.87,
    height: 1.74
  })), _rect1026 || (_rect1026 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.91,
    y: 45.95,
    width: 0.87,
    height: 0.87
  })), _rect1027 || (_rect1027 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.91,
    y: 50.31,
    width: 0.87,
    height: 0.87
  })), _rect1028 || (_rect1028 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.91,
    y: 52.93,
    width: 0.87,
    height: 0.87
  })), _rect1029 || (_rect1029 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.91,
    y: 54.67,
    width: 0.87,
    height: 0.87
  })), _rect1030 || (_rect1030 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.91,
    y: 57.29,
    width: 0.87,
    height: 1.74
  })), _rect1031 || (_rect1031 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.91,
    y: 60.77,
    width: 0.87,
    height: 6.11
  })), _rect1032 || (_rect1032 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.91,
    y: 67.75,
    width: 0.87,
    height: 0.87
  })), _rect1033 || (_rect1033 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.91,
    y: 69.5,
    width: 0.87,
    height: 0.87
  })), _rect1034 || (_rect1034 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.91,
    y: 71.24,
    width: 0.87,
    height: 1.74
  })), _rect1035 || (_rect1035 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.91,
    y: 75.6,
    width: 0.87,
    height: 0.87
  })), _rect1036 || (_rect1036 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.91,
    y: 81.71,
    width: 0.87,
    height: 2.62
  })), _rect1037 || (_rect1037 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.91,
    y: 85.2,
    width: 0.87,
    height: 4.36
  })), _rect1038 || (_rect1038 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.78,
    y: 36.35,
    width: 0.87,
    height: 0.87
  })), _rect1039 || (_rect1039 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.78,
    y: 38.1,
    width: 0.87,
    height: 2.62
  })), _rect1040 || (_rect1040 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.78,
    y: 41.59,
    width: 0.87,
    height: 0.87
  })), _rect1041 || (_rect1041 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.78,
    y: 43.33,
    width: 0.87,
    height: 0.87
  })), _rect1042 || (_rect1042 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.78,
    y: 45.95,
    width: 0.87,
    height: 0.87
  })), _rect1043 || (_rect1043 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.78,
    y: 47.69,
    width: 0.87,
    height: 0.87
  })), _rect1044 || (_rect1044 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.78,
    y: 50.31,
    width: 0.87,
    height: 0.87
  })), _rect1045 || (_rect1045 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.78,
    y: 52.05,
    width: 0.87,
    height: 1.74
  })), _rect1046 || (_rect1046 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.78,
    y: 56.41,
    width: 0.87,
    height: 0.87
  })), _rect1047 || (_rect1047 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.78,
    y: 58.16,
    width: 0.87,
    height: 0.87
  })), _rect1048 || (_rect1048 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.78,
    y: 60.77,
    width: 0.87,
    height: 0.87
  })), _rect1049 || (_rect1049 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.78,
    y: 63.39,
    width: 0.87,
    height: 2.62
  })), _rect1050 || (_rect1050 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.78,
    y: 67.75,
    width: 0.87,
    height: 0.87
  })), _rect1051 || (_rect1051 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.78,
    y: 69.5,
    width: 0.87,
    height: 0.87
  })), _rect1052 || (_rect1052 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.78,
    y: 72.99,
    width: 0.87,
    height: 0.87
  })), _rect1053 || (_rect1053 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.78,
    y: 74.73,
    width: 0.87,
    height: 0.87
  })), _rect1054 || (_rect1054 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.78,
    y: 76.47,
    width: 0.87,
    height: 1.74
  })), _rect1055 || (_rect1055 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.78,
    y: 79.96,
    width: 0.87,
    height: 1.74
  })), _rect1056 || (_rect1056 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.78,
    y: 86.07,
    width: 0.87,
    height: 0.87
  })), _rect1057 || (_rect1057 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.78,
    y: 88.69,
    width: 0.87,
    height: 1.74
  })), _rect1058 || (_rect1058 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.78,
    y: 92.17,
    width: 0.87,
    height: 0.87
  })), _rect1059 || (_rect1059 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.66,
    y: 36.35,
    width: 0.87,
    height: 0.87
  })), _rect1060 || (_rect1060 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.66,
    y: 38.1,
    width: 0.87,
    height: 2.62
  })), _rect1061 || (_rect1061 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.66,
    y: 41.59,
    width: 0.87,
    height: 0.87
  })), _rect1062 || (_rect1062 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.66,
    y: 44.2,
    width: 0.87,
    height: 0.87
  })), _rect1063 || (_rect1063 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.66,
    y: 45.95,
    width: 0.87,
    height: 0.87
  })), _rect1064 || (_rect1064 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.66,
    y: 47.69,
    width: 0.87,
    height: 0.87
  })), _rect1065 || (_rect1065 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.66,
    y: 49.44,
    width: 0.87,
    height: 0.87
  })), _rect1066 || (_rect1066 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.66,
    y: 51.18,
    width: 0.87,
    height: 2.62
  })), _rect1067 || (_rect1067 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.66,
    y: 54.67,
    width: 0.87,
    height: 0.87
  })), _rect1068 || (_rect1068 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.66,
    y: 56.41,
    width: 0.87,
    height: 3.49
  })), _rect1069 || (_rect1069 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.66,
    y: 60.77,
    width: 0.87,
    height: 0.87
  })), _rect1070 || (_rect1070 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.66,
    y: 63.39,
    width: 0.87,
    height: 0.87
  })), _rect1071 || (_rect1071 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.66,
    y: 65.14,
    width: 0.87,
    height: 0.87
  })), _rect1072 || (_rect1072 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.66,
    y: 67.75,
    width: 0.87,
    height: 2.62
  })), _rect1073 || (_rect1073 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.66,
    y: 72.11,
    width: 0.87,
    height: 0.87
  })), _rect1074 || (_rect1074 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.66,
    y: 75.6,
    width: 0.87,
    height: 0.87
  })), _rect1075 || (_rect1075 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.66,
    y: 78.22,
    width: 0.87,
    height: 1.74
  })), _rect1076 || (_rect1076 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.66,
    y: 82.58,
    width: 0.87,
    height: 1.74
  })), _rect1077 || (_rect1077 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.66,
    y: 85.2,
    width: 0.87,
    height: 1.74
  })), _rect1078 || (_rect1078 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.66,
    y: 87.81,
    width: 0.87,
    height: 0.87
  })), _rect1079 || (_rect1079 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.66,
    y: 92.17,
    width: 0.87,
    height: 0.87
  })), _rect1080 || (_rect1080 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.53,
    y: 36.35,
    width: 0.87,
    height: 0.87
  })), _rect1081 || (_rect1081 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.53,
    y: 41.59,
    width: 0.87,
    height: 0.87
  })), _rect1082 || (_rect1082 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.53,
    y: 44.2,
    width: 0.87,
    height: 3.49
  })), _rect1083 || (_rect1083 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.53,
    y: 49.44,
    width: 0.87,
    height: 0.87
  })), _rect1084 || (_rect1084 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.53,
    y: 52.05,
    width: 0.87,
    height: 0.87
  })), _rect1085 || (_rect1085 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.53,
    y: 54.67,
    width: 0.87,
    height: 5.23
  })), _rect1086 || (_rect1086 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.53,
    y: 66.01,
    width: 0.87,
    height: 1.74
  })), _rect1087 || (_rect1087 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.53,
    y: 68.62,
    width: 0.87,
    height: 0.87
  })), _rect1088 || (_rect1088 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.53,
    y: 71.24,
    width: 0.87,
    height: 0.87
  })), _rect1089 || (_rect1089 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.53,
    y: 73.86,
    width: 0.87,
    height: 2.62
  })), _rect1090 || (_rect1090 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.53,
    y: 79.09,
    width: 0.87,
    height: 0.87
  })), _rect1091 || (_rect1091 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.53,
    y: 80.84,
    width: 0.87,
    height: 0.87
  })), _rect1092 || (_rect1092 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.53,
    y: 84.32,
    width: 0.87,
    height: 1.74
  })), _rect1093 || (_rect1093 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.53,
    y: 86.94,
    width: 0.87,
    height: 1.74
  })), _rect1094 || (_rect1094 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.53,
    y: 90.43,
    width: 0.87,
    height: 1.74
  })), _rect1095 || (_rect1095 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 260.4,
    y: 36.35,
    width: 0.87,
    height: 6.11
  })), _rect1096 || (_rect1096 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 260.4,
    y: 43.33,
    width: 0.87,
    height: 0.87
  })), _rect1097 || (_rect1097 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 260.4,
    y: 48.56,
    width: 0.87,
    height: 1.74
  })), _rect1098 || (_rect1098 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 260.4,
    y: 52.05,
    width: 0.87,
    height: 2.62
  })), _rect1099 || (_rect1099 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 260.4,
    y: 55.54,
    width: 0.87,
    height: 0.87
  })), _rect1100 || (_rect1100 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 260.4,
    y: 58.16,
    width: 0.87,
    height: 0.87
  })), _rect1101 || (_rect1101 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 260.4,
    y: 61.65,
    width: 0.87,
    height: 2.62
  })), _rect1102 || (_rect1102 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 260.4,
    y: 65.14,
    width: 0.87,
    height: 0.87
  })), _rect1103 || (_rect1103 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 260.4,
    y: 66.88,
    width: 0.87,
    height: 0.87
  })), _rect1104 || (_rect1104 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 260.4,
    y: 68.62,
    width: 0.87,
    height: 2.62
  })), _rect1105 || (_rect1105 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 260.4,
    y: 75.6,
    width: 0.87,
    height: 3.49
  })), _rect1106 || (_rect1106 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 260.4,
    y: 79.96,
    width: 0.87,
    height: 3.49
  })), _rect1107 || (_rect1107 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 260.4,
    y: 86.94,
    width: 0.87,
    height: 0.87
  })), _rect1108 || (_rect1108 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 260.4,
    y: 90.43,
    width: 0.87,
    height: 0.87
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "339.23 249.57 314.42 208.24 289.62 249.57 339.23 249.57"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M204.75,120.19l1.74-2.48a5.2,5.2,0,0,0,3.57,1.42c.63,0,1.22-.16,1.22-.59,0-1.06-6.16,0-6.16-4.35,0-1.87,1.56-3.66,4.59-3.66a7.33,7.33,0,0,1,4.69,1.54l-1.79,2.37a5.56,5.56,0,0,0-3.25-1.09c-.66,0-.84.21-.84.5,0,1,6.14.15,6.14,4.26,0,2.43-1.8,3.84-4.77,3.84A7.31,7.31,0,0,1,204.75,120.19Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M217.8,121.75v-8.14h-3V110.7h9.26v2.91h-3v8.14Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M231.67,121.75l-.4-1.29h-4l-.4,1.29H223.1l4.08-11h4.21l4.07,11ZM229.28,114l-1.09,3.56h2.18Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M242.14,121.75l-1.52-3.48h-1.21v3.48h-3.35v-11H242a3.68,3.68,0,0,1,4,3.79,3.56,3.56,0,0,1-2,3.35l2,3.91Zm.4-7.27c0-.6-.53-.87-1.1-.87h-2v1.74h2C242,115.35,242.54,115.09,242.54,114.48Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M249.5,121.75v-8.14h-3V110.7h9.27v2.91h-3v8.14Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M260.37,120.19l1.74-2.48a5.17,5.17,0,0,0,3.56,1.42c.63,0,1.23-.16,1.23-.59,0-1.06-6.17,0-6.17-4.35,0-1.87,1.56-3.66,4.6-3.66a7.3,7.3,0,0,1,4.68,1.54l-1.79,2.37a5.56,5.56,0,0,0-3.24-1.09c-.67,0-.85.21-.85.5,0,1,6.15.15,6.15,4.26,0,2.43-1.81,3.84-4.77,3.84A7.29,7.29,0,0,1,260.37,120.19Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M281.15,121.75v-6.64l-2.47,6.64h-1.49l-2.47-6.64v6.64h-3.35v-11H276l1.94,5.3,1.93-5.3h4.63v11Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M293.66,121.75l-.39-1.29h-4l-.4,1.29H285.1l4.07-11h4.21l4.08,11ZM291.28,114l-1.1,3.56h2.19Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M304.14,121.75l-1.53-3.48H301.4v3.48h-3.34v-11H304a3.67,3.67,0,0,1,4,3.79,3.56,3.56,0,0,1-2,3.35l2,3.91Zm.39-7.27c0-.6-.53-.87-1.09-.87h-2v1.74h2C304,115.35,304.53,115.09,304.53,114.48Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M311.49,121.75v-8.14h-3V110.7h9.26v2.91h-3v8.14Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M208.47,147.21l-2.23-3.05v3.05h-1v-4.68h1l2.16,2.94v-2.94h1v4.68Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M210.11,145.51a1.73,1.73,0,0,1,1.75-1.77,1.69,1.69,0,0,1,1.7,1.86v.21H211a.9.9,0,0,0,1,.75,1.43,1.43,0,0,0,.9-.33l.4.59a2.11,2.11,0,0,1-1.39.47A1.71,1.71,0,0,1,210.11,145.51Zm1.75-1a.79.79,0,0,0-.83.72h1.67A.78.78,0,0,0,211.86,144.47Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M215.09,146.77v1.72h-.89v-4.67h.89v.43a1.3,1.3,0,0,1,1-.51c.87,0,1.5.64,1.5,1.77s-.63,1.78-1.5,1.78A1.3,1.3,0,0,1,215.09,146.77Zm1.62-1.26a.88.88,0,0,0-.86-1,1,1,0,0,0-.76.39v1.19a1,1,0,0,0,.76.39A.89.89,0,0,0,216.71,145.51Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M220.31,147.21v-.36a1.38,1.38,0,0,1-1.07.44,1.12,1.12,0,0,1-1.17-1.12,1.07,1.07,0,0,1,1.17-1.09,1.36,1.36,0,0,1,1.07.41v-.43c0-.34-.29-.56-.74-.56a1.43,1.43,0,0,0-1,.4l-.35-.63a2.21,2.21,0,0,1,1.48-.53c.78,0,1.49.31,1.49,1.28v2.19Zm0-.82V146a.92.92,0,0,0-.71-.3c-.35,0-.64.19-.64.51s.29.51.64.51A.89.89,0,0,0,220.31,146.39Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M222.08,147.21v-4.68H223v4.68Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M225.45,144.87a2.44,2.44,0,1,1,2.44,2.42A2.35,2.35,0,0,1,225.45,144.87Zm3.86,0a1.42,1.42,0,1,0-1.42,1.54A1.42,1.42,0,0,0,229.31,144.87Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M231.21,147.21V144.6h-.56v-.78h.56v-.14a1.1,1.1,0,0,1,1.13-1.22,1.18,1.18,0,0,1,.88.33l-.33.54a.5.5,0,0,0-.37-.14c-.25,0-.42.16-.42.49v.14h.68v.78h-.68v2.61Zm2.29,0V144.6h-.56v-.78h.56v-.14a1.1,1.1,0,0,1,1.13-1.22,1.49,1.49,0,0,1,.65.14l-.19.66a.47.47,0,0,0-.28-.07c-.25,0-.42.16-.42.49v.14h.68v.78h-.68v2.61Zm2-4.28a.53.53,0,1,1,1.06,0,.53.53,0,1,1-1.06,0Zm.08,4.28v-3.39h.89v3.39Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M237.14,145.51a1.72,1.72,0,0,1,1.79-1.77,1.59,1.59,0,0,1,1.34.61l-.58.55a.84.84,0,0,0-.72-.37,1,1,0,0,0,0,2,.86.86,0,0,0,.72-.37l.58.54a1.59,1.59,0,0,1-1.34.62A1.71,1.71,0,0,1,237.14,145.51Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M240.63,145.51a1.73,1.73,0,0,1,1.75-1.77,1.69,1.69,0,0,1,1.7,1.86v.21h-2.52a.9.9,0,0,0,1,.75,1.43,1.43,0,0,0,.9-.33l.4.59a2.11,2.11,0,0,1-1.39.47A1.71,1.71,0,0,1,240.63,145.51Zm1.75-1a.79.79,0,0,0-.83.72h1.67A.78.78,0,0,0,242.38,144.47Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M244.42,146.77l.39-.65a1.9,1.9,0,0,0,1.17.47c.38,0,.57-.15.57-.36,0-.55-2-.1-2-1.43,0-.56.49-1.06,1.39-1.06a2.2,2.2,0,0,1,1.36.46l-.36.63a1.45,1.45,0,0,0-1-.39c-.32,0-.53.14-.53.33,0,.5,2,.08,2,1.44,0,.63-.54,1.08-1.47,1.08A2.35,2.35,0,0,1,244.42,146.77Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M247.94,144.34a.57.57,0,1,1,.57.57A.58.58,0,0,1,247.94,144.34Zm0,2.38a.57.57,0,1,1,.57.56A.58.58,0,0,1,247.94,146.72Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M208.15,155.61l-1.77-2.1-.47.53v1.57h-.58v-4.67h.58v2.4l2.07-2.4h.72l-1.94,2.21,2.12,2.46Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M211.51,155.61v-.39a1.43,1.43,0,0,1-1.12.47,1.12,1.12,0,0,1-1.18-1.12,1.1,1.1,0,0,1,1.18-1.11,1.42,1.42,0,0,1,1.12.45v-.61c0-.45-.36-.71-.85-.71a1.32,1.32,0,0,0-1,.47l-.24-.36a1.74,1.74,0,0,1,1.35-.56c.72,0,1.31.32,1.31,1.14v2.33Zm0-.72v-.64a1.12,1.12,0,0,0-.92-.42.75.75,0,1,0,0,1.48A1.12,1.12,0,0,0,211.51,154.89Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M213.2,154.9v-2.21h-.56v-.47h.56v-.92h.53v.92h.69v.47h-.69v2.1c0,.25.11.43.34.43a.48.48,0,0,0,.35-.15l.16.4a.87.87,0,0,1-.63.22A.69.69,0,0,1,213.2,154.9Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M217.44,155.61v-2.23c0-.6-.3-.77-.76-.77a1.32,1.32,0,0,0-1,.52v2.48h-.52v-4.67h.52v1.77a1.66,1.66,0,0,1,1.21-.57,1,1,0,0,1,1.08,1.08v2.39Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M223.1,155.61v-2.3c0-.43-.18-.7-.63-.7a1.13,1.13,0,0,0-.89.52v2.48h-.53v-2.3c0-.43-.17-.7-.62-.7a1.19,1.19,0,0,0-.89.52v2.48H219v-3.39h.53v.49a1.5,1.5,0,0,1,1.1-.57.86.86,0,0,1,.9.63,1.43,1.43,0,0,1,1.14-.63c.61,0,.94.34.94,1v2.45Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M226.79,155.61v-.39a1.47,1.47,0,0,1-1.13.47,1.12,1.12,0,0,1-1.17-1.12,1.09,1.09,0,0,1,1.17-1.11,1.44,1.44,0,0,1,1.13.45v-.61c0-.45-.37-.71-.86-.71a1.33,1.33,0,0,0-1,.47l-.24-.36a1.76,1.76,0,0,1,1.35-.56c.72,0,1.31.32,1.31,1.14v2.33Zm0-.72v-.64a1.15,1.15,0,0,0-.93-.42.75.75,0,1,0,0,1.48A1.15,1.15,0,0,0,226.79,154.89Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M230.66,155.61v-2.22c0-.6-.31-.78-.77-.78a1.32,1.32,0,0,0-1,.52v2.48h-.52v-3.39h.52v.49a1.68,1.68,0,0,1,1.21-.57,1,1,0,0,1,1.07,1.09v2.38Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M234.68,155.61v-.51a1.42,1.42,0,0,1-1.14.59c-.88,0-1.51-.67-1.51-1.77a1.57,1.57,0,0,1,1.51-1.78,1.41,1.41,0,0,1,1.14.59v-1.79h.53v4.67Zm0-.93v-1.53a1.25,1.25,0,0,0-1-.54c-.68,0-1.09.56-1.09,1.31s.41,1.3,1.09,1.3A1.23,1.23,0,0,0,234.68,154.68Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M238.54,155.61v-.48a1.67,1.67,0,0,1-1.21.56,1,1,0,0,1-1.08-1.08v-2.39h.53v2.23c0,.6.3.77.76.77a1.31,1.31,0,0,0,1-.51v-2.49h.52v3.39Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M242.66,154.66a.76.76,0,0,1-.76-.75.76.76,0,0,1,1.52,0A.76.76,0,0,1,242.66,154.66Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M246.26,155.61v-4.67h1.88a1.41,1.41,0,1,1,0,2.81h-1.29v1.86Zm2.74-3.27a.87.87,0,0,0-.93-.89h-1.22v1.78h1.22A.87.87,0,0,0,249,152.34Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M250.07,153.91a1.67,1.67,0,1,1,1.67,1.78A1.65,1.65,0,0,1,250.07,153.91Zm2.79,0a1.13,1.13,0,1,0-1.12,1.31A1.18,1.18,0,0,0,252.86,153.91Z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M256.57,155.61l-1.21-1.52-.57.55v1h-.52v-4.67h.52V154l1.78-1.8h.66l-1.49,1.54,1.5,1.85Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M260.15,155.61v-2.23c0-.6-.3-.77-.76-.77a1.28,1.28,0,0,0-1,.52v2.48h-.53v-4.67h.53v1.77a1.64,1.64,0,0,1,1.2-.57,1,1,0,0,1,1.08,1.08v2.39Z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M263.84,155.61v-.39a1.43,1.43,0,0,1-1.12.47,1.11,1.11,0,0,1-1.17-1.12,1.09,1.09,0,0,1,1.17-1.11,1.42,1.42,0,0,1,1.12.45v-.61c0-.45-.36-.71-.85-.71a1.32,1.32,0,0,0-1,.47l-.24-.36a1.74,1.74,0,0,1,1.35-.56c.72,0,1.31.32,1.31,1.14v2.33Zm0-.72v-.64a1.12,1.12,0,0,0-.92-.42.75.75,0,1,0,0,1.48A1.12,1.12,0,0,0,263.84,154.89Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M265.42,155.61v-3.39H266v.54a1.44,1.44,0,0,1,1.13-.61v.54l-.21,0a1.23,1.23,0,0,0-.92.54v2.4Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M269.85,155.61v-.39a1.45,1.45,0,0,1-1.12.47,1.12,1.12,0,0,1-1.18-1.12,1.1,1.1,0,0,1,1.18-1.11,1.42,1.42,0,0,1,1.12.45v-.61c0-.45-.37-.71-.86-.71a1.31,1.31,0,0,0-1,.47l-.25-.36a1.77,1.77,0,0,1,1.35-.56c.73,0,1.31.32,1.31,1.14v2.33Zm0-.72v-.64a1.13,1.13,0,0,0-.93-.42.75.75,0,1,0,0,1.48A1.13,1.13,0,0,0,269.85,154.89Z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M274,154.66a.76.76,0,0,1-.76-.75.76.76,0,1,1,1.51,0A.76.76,0,0,1,274,154.66Z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M277.39,153.27a2.34,2.34,0,0,1,2.41-2.41,2.08,2.08,0,0,1,1.77.92l-.49.28a1.55,1.55,0,0,0-1.28-.68,1.9,1.9,0,0,0,0,3.79,1.55,1.55,0,0,0,1.28-.68l.49.27a2.09,2.09,0,0,1-1.77.93A2.34,2.34,0,0,1,277.39,153.27Z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M284.58,155.61v-2.23c0-.6-.3-.77-.76-.77a1.28,1.28,0,0,0-1,.52v2.48h-.53v-4.67h.53v1.77a1.64,1.64,0,0,1,1.2-.57,1,1,0,0,1,1.08,1.08v2.39Z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M286.07,151.39a.36.36,0,0,1,.35-.36.35.35,0,0,1,.35.36.34.34,0,0,1-.35.35A.35.35,0,0,1,286.07,151.39Zm.09,4.22v-3.39h.52v3.39Z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M287.84,154.9v-2.21h-.56v-.47h.56v-.92h.53v.92h.69v.47h-.69v2.1c0,.25.11.43.34.43a.48.48,0,0,0,.35-.15l.16.4a.87.87,0,0,1-.63.22A.69.69,0,0,1,287.84,154.9Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M292.72,155.61l-.89-2.72-.88,2.72h-.52l-1.08-3.39h.54l.83,2.7.89-2.7h.46l.88,2.7.82-2.7h.56l-1.08,3.39Z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M297,155.61v-.39a1.43,1.43,0,0,1-1.12.47,1.11,1.11,0,0,1-1.17-1.12,1.09,1.09,0,0,1,1.17-1.11,1.42,1.42,0,0,1,1.12.45v-.61c0-.45-.36-.71-.85-.71a1.32,1.32,0,0,0-1,.47l-.24-.36a1.76,1.76,0,0,1,1.35-.56c.72,0,1.31.32,1.31,1.14v2.33Zm0-.72v-.64a1.12,1.12,0,0,0-.92-.42.75.75,0,1,0,0,1.48A1.12,1.12,0,0,0,297,154.89Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M300.91,155.61v-2.22c0-.6-.3-.78-.76-.78a1.32,1.32,0,0,0-1,.52v2.48h-.53v-3.39h.53v.49a1.68,1.68,0,0,1,1.21-.57,1,1,0,0,1,1.07,1.09v2.38Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M205.33,164v-4.68h2.08a1.18,1.18,0,0,1,1.31,1.19,1.07,1.07,0,0,1-.82,1.08,1.16,1.16,0,0,1,.91,1.15,1.22,1.22,0,0,1-1.35,1.26Zm2.79-3.4a.74.74,0,0,0-.81-.76h-1.4v1.51h1.4A.73.73,0,0,0,208.12,160.61Zm.09,2.07a.79.79,0,0,0-.86-.8h-1.44v1.61h1.44A.77.77,0,0,0,208.21,162.68Z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M209.62,159.79a.36.36,0,1,1,.71,0,.36.36,0,0,1-.71,0Zm.09,4.22v-3.39h.53V164Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M211.29,164v-3.39h.52v.54a1.45,1.45,0,0,1,1.13-.61v.54l-.2,0a1.27,1.27,0,0,0-.93.54V164Z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M213.7,163.3v-2.21h-.56v-.47h.56v-.92h.53v.92h.69v.47h-.69v2.1c0,.25.12.43.34.43a.5.5,0,0,0,.36-.15l.15.4a.82.82,0,0,1-.62.22A.69.69,0,0,1,213.7,163.3Z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M217.77,164v-.39a1.45,1.45,0,0,1-1.12.47,1.13,1.13,0,0,1-1.18-1.12,1.1,1.1,0,0,1,1.18-1.11,1.42,1.42,0,0,1,1.12.45v-.61c0-.45-.37-.71-.86-.71a1.31,1.31,0,0,0-1,.47l-.25-.36a1.77,1.77,0,0,1,1.35-.56c.73,0,1.31.32,1.31,1.14V164Zm0-.72v-.64a1.13,1.13,0,0,0-.93-.42.75.75,0,1,0,0,1.48A1.13,1.13,0,0,0,217.77,163.29Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M223.43,164v-2.3c0-.43-.18-.7-.62-.7a1.16,1.16,0,0,0-.9.52V164h-.52v-2.3c0-.43-.18-.7-.63-.7a1.17,1.17,0,0,0-.88.52V164h-.53v-3.39h.53v.49a1.47,1.47,0,0,1,1.09-.57.87.87,0,0,1,.91.63,1.41,1.41,0,0,1,1.13-.63c.62,0,1,.34,1,1V164Z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M224.81,162.31a1.68,1.68,0,1,1,1.67,1.78A1.65,1.65,0,0,1,224.81,162.31Zm2.79,0a1.13,1.13,0,1,0-2.24,0,1.13,1.13,0,1,0,2.24,0Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M231.46,164v-.51a1.4,1.4,0,0,1-1.14.59c-.88,0-1.51-.67-1.51-1.77a1.57,1.57,0,0,1,1.51-1.78,1.41,1.41,0,0,1,1.14.59v-1.8H232V164Zm0-.93v-1.52a1.23,1.23,0,0,0-1-.55c-.68,0-1.09.56-1.09,1.31s.41,1.3,1.09,1.3A1.23,1.23,0,0,0,231.46,163.08Z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M232.84,162.31a1.69,1.69,0,0,1,1.67-1.77,1.64,1.64,0,0,1,1.62,1.81v.14H233.4a1.19,1.19,0,0,0,1.21,1.17,1.48,1.48,0,0,0,1-.44l.25.34a1.83,1.83,0,0,1-1.34.53A1.68,1.68,0,0,1,232.84,162.31ZM234.5,161a1.13,1.13,0,0,0-1.11,1.12h2.22A1.09,1.09,0,0,0,234.5,161Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M239.52,163.06a.75.75,0,1,1,.76-.75A.76.76,0,0,1,239.52,163.06Z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M243.13,164v-4.68h2.08a1.18,1.18,0,0,1,1.31,1.19,1.07,1.07,0,0,1-.82,1.08,1.16,1.16,0,0,1,.91,1.15,1.22,1.22,0,0,1-1.35,1.26Zm2.79-3.4a.74.74,0,0,0-.81-.76h-1.4v1.51h1.4A.73.73,0,0,0,245.92,160.61Zm.09,2.07a.79.79,0,0,0-.86-.8h-1.44v1.61h1.44A.78.78,0,0,0,246,162.68Z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M249.79,164v-.48a1.67,1.67,0,0,1-1.2.56,1,1,0,0,1-1.08-1.08v-2.39H248v2.23c0,.6.3.77.76.77a1.27,1.27,0,0,0,1-.51v-2.49h.53V164Z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M251.47,163.3v-2.21h-.56v-.47h.56v-.92H252v.92h.69v.47H252v2.1c0,.25.12.43.34.43a.5.5,0,0,0,.36-.15l.15.4a.82.82,0,0,1-.62.22A.69.69,0,0,1,251.47,163.3Z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M256.35,164l-.88-2.72-.88,2.72h-.53L253,160.62h.55l.83,2.7.89-2.7h.45l.88,2.7.83-2.7H258L256.89,164Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M260.68,164v-.39a1.45,1.45,0,0,1-1.12.47,1.13,1.13,0,0,1-1.18-1.12,1.1,1.1,0,0,1,1.18-1.11,1.42,1.42,0,0,1,1.12.45v-.61c0-.45-.37-.71-.86-.71a1.31,1.31,0,0,0-1,.47l-.25-.36a1.77,1.77,0,0,1,1.35-.56c.73,0,1.31.32,1.31,1.14V164Zm0-.72v-.64a1.13,1.13,0,0,0-.93-.42.75.75,0,1,0,0,1.48A1.13,1.13,0,0,0,260.68,163.29Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M262.26,164v-4.68h.52V164Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M266.38,163.06a.75.75,0,1,1,.76-.75A.76.76,0,0,1,266.38,163.06Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M270,164v-4.68h.58V164Z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M271.74,163.3v-2.21h-.56v-.47h.56v-.92h.54v.92H273v.47h-.68v2.1c0,.25.11.43.33.43a.48.48,0,0,0,.36-.15l.15.4a.82.82,0,0,1-.62.22A.7.7,0,0,1,271.74,163.3Z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M275.81,164v-.39a1.43,1.43,0,0,1-1.12.47,1.13,1.13,0,0,1-1.18-1.12,1.1,1.1,0,0,1,1.18-1.11,1.42,1.42,0,0,1,1.12.45v-.61c0-.45-.36-.71-.85-.71a1.32,1.32,0,0,0-1,.47l-.24-.36a1.74,1.74,0,0,1,1.35-.56c.72,0,1.31.32,1.31,1.14V164Zm0-.72v-.64a1.12,1.12,0,0,0-.92-.42.75.75,0,1,0,0,1.48A1.12,1.12,0,0,0,275.81,163.29Z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M279.68,164v-2.23c0-.6-.3-.77-.76-.77a1.28,1.28,0,0,0-1,.52V164h-.53v-4.68h.53v1.78a1.64,1.64,0,0,1,1.2-.57,1,1,0,0,1,1.08,1.08V164Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M283.37,164v-.39a1.43,1.43,0,0,1-1.12.47,1.13,1.13,0,0,1-1.18-1.12,1.1,1.1,0,0,1,1.18-1.11,1.42,1.42,0,0,1,1.12.45v-.61c0-.45-.36-.71-.85-.71a1.32,1.32,0,0,0-1,.47l-.24-.36a1.74,1.74,0,0,1,1.35-.56c.72,0,1.31.32,1.31,1.14V164Zm0-.72v-.64a1.12,1.12,0,0,0-.92-.42.75.75,0,1,0,0,1.48A1.12,1.12,0,0,0,283.37,163.29Z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M285,164v-3.39h.53v.54a1.44,1.44,0,0,1,1.13-.61v.54l-.21,0a1.23,1.23,0,0,0-.92.54V164Z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M287.17,159.79a.36.36,0,1,1,.71,0,.36.36,0,0,1-.71,0Zm.09,4.22v-3.39h.53V164Z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M205.33,172.41v-4.68h1.6a2.34,2.34,0,1,1,0,4.68Zm3.39-2.34a1.71,1.71,0,0,0-1.79-1.82h-1v3.64h1A1.72,1.72,0,0,0,208.72,170.07Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M212.32,172.41V172a1.43,1.43,0,0,1-1.12.47,1.13,1.13,0,0,1-1.17-1.12,1.09,1.09,0,0,1,1.17-1.11,1.42,1.42,0,0,1,1.12.45v-.61c0-.45-.36-.7-.85-.7a1.31,1.31,0,0,0-1,.46l-.24-.36a1.76,1.76,0,0,1,1.35-.56c.72,0,1.31.32,1.31,1.14v2.33Zm0-.72v-.64a1.12,1.12,0,0,0-.92-.42.75.75,0,1,0,0,1.48A1.12,1.12,0,0,0,212.32,171.69Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M218,172.41v-2.3c0-.43-.18-.7-.63-.7a1.13,1.13,0,0,0-.89.52v2.48h-.53v-2.3c0-.43-.17-.7-.62-.7a1.19,1.19,0,0,0-.89.52v2.48h-.53V169h.53v.49a1.5,1.5,0,0,1,1.1-.57.86.86,0,0,1,.9.63,1.43,1.43,0,0,1,1.14-.63c.61,0,.94.34.94,1v2.45Z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M221.68,172.41V172a1.47,1.47,0,0,1-1.13.47,1.13,1.13,0,0,1-1.17-1.12,1.09,1.09,0,0,1,1.17-1.11,1.44,1.44,0,0,1,1.13.45v-.61c0-.45-.37-.7-.86-.7a1.32,1.32,0,0,0-1,.46l-.24-.36a1.76,1.76,0,0,1,1.35-.56c.72,0,1.31.32,1.31,1.14v2.33Zm0-.72v-.64a1.15,1.15,0,0,0-.93-.42.75.75,0,1,0,0,1.48A1.15,1.15,0,0,0,221.68,171.69Z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M225.56,172.41l-1.21-1.52-.57.55v1h-.52v-4.68h.52v3.09l1.78-1.8h.67l-1.5,1.54,1.5,1.85Z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M229.4,171.46a.75.75,0,1,1,.76-.75A.76.76,0,0,1,229.4,171.46Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M233,172.41v-4.68h1.59a2.34,2.34,0,1,1,0,4.68Zm3.39-2.34a1.72,1.72,0,0,0-1.8-1.82h-1v3.64h1A1.72,1.72,0,0,0,236.4,170.07Z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M240.18,172.41v-2.23c0-.6-.31-.77-.77-.77a1.3,1.3,0,0,0-1,.52v2.48h-.53v-4.68h.53v1.78a1.64,1.64,0,0,1,1.2-.57A1,1,0,0,1,240.7,170v2.39Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M243.86,172.41V172a1.43,1.43,0,0,1-1.12.47,1.13,1.13,0,0,1-1.17-1.12,1.09,1.09,0,0,1,1.17-1.11,1.41,1.41,0,0,1,1.12.45v-.61c0-.45-.36-.7-.85-.7a1.31,1.31,0,0,0-1,.46l-.24-.36a1.76,1.76,0,0,1,1.35-.56c.72,0,1.31.32,1.31,1.14v2.33Zm0-.72v-.64a1.12,1.12,0,0,0-.92-.42.75.75,0,1,0,0,1.48A1.12,1.12,0,0,0,243.86,171.69Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M245.45,172.41V169H246v.54a1.45,1.45,0,0,1,1.13-.61v.54l-.2,0a1.27,1.27,0,0,0-.93.54v2.4Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M249.87,172.41V172a1.43,1.43,0,0,1-1.12.47,1.13,1.13,0,0,1-1.18-1.12,1.1,1.1,0,0,1,1.18-1.11,1.42,1.42,0,0,1,1.12.45v-.61c0-.45-.36-.7-.85-.7a1.31,1.31,0,0,0-1,.46l-.25-.36a1.78,1.78,0,0,1,1.36-.56c.72,0,1.31.32,1.31,1.14v2.33Zm0-.72v-.64a1.12,1.12,0,0,0-.92-.42.75.75,0,1,0,0,1.48A1.12,1.12,0,0,0,249.87,171.69Z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M253.74,172.41v-2.22c0-.6-.31-.78-.76-.78a1.32,1.32,0,0,0-1,.52v2.48h-.53V169H252v.49a1.66,1.66,0,0,1,1.21-.57,1,1,0,0,1,1.07,1.09v2.38Z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M208.47,186.81l-.29-.79h-2l-.3.79h-1.13l1.8-4.67h1.25l1.8,4.67Zm-1.29-3.68-.73,2h1.46Z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M212.2,186.81v-.43a1.6,1.6,0,0,1-1.19.51,1,1,0,0,1-1.09-1.06v-2.41h.89v2.06a.55.55,0,0,0,.62.62,1,1,0,0,0,.77-.39v-2.29h.89v3.39Z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M213.68,186.36l.39-.64a1.87,1.87,0,0,0,1.16.47c.39,0,.57-.15.57-.36,0-.55-2-.1-2-1.43,0-.56.49-1.06,1.39-1.06a2.17,2.17,0,0,1,1.35.46l-.35.63a1.47,1.47,0,0,0-1-.39c-.33,0-.54.14-.54.33,0,.5,2,.08,2,1.44,0,.63-.53,1.08-1.47,1.08A2.27,2.27,0,0,1,213.68,186.36Z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M217.5,186V184.2h-.57v-.78h.57v-.92h.88v.92h.69v.78h-.69v1.52c0,.22.12.38.31.38A.42.42,0,0,0,219,186l.19.68a1.08,1.08,0,0,1-.74.22A.84.84,0,0,1,217.5,186Z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M219.68,186.81v-3.39h.89v.46a1.46,1.46,0,0,1,1.08-.54v.87a.9.9,0,0,0-.25,0,1.12,1.12,0,0,0-.83.38v2.24Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M224.23,186.81v-.36a1.38,1.38,0,0,1-1.07.44,1.12,1.12,0,0,1-1.17-1.12,1.07,1.07,0,0,1,1.17-1.09,1.36,1.36,0,0,1,1.07.41v-.43c0-.34-.29-.56-.74-.56a1.43,1.43,0,0,0-1,.4l-.35-.63a2.21,2.21,0,0,1,1.48-.53c.78,0,1.49.31,1.49,1.28v2.19Zm0-.82v-.42a.92.92,0,0,0-.71-.3c-.35,0-.64.19-.64.51s.29.51.64.51A.89.89,0,0,0,224.23,186Z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M226,186.81v-4.67h.89v4.67Z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M227.69,182.53a.53.53,0,1,1,1.05,0,.53.53,0,1,1-1.05,0Zm.08,4.28v-3.39h.89v3.39Z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M231.57,186.81v-.36a1.38,1.38,0,0,1-1.07.44,1.12,1.12,0,0,1-1.17-1.12,1.07,1.07,0,0,1,1.17-1.09,1.35,1.35,0,0,1,1.07.41v-.43c0-.34-.29-.56-.74-.56a1.41,1.41,0,0,0-1,.4l-.35-.63a2.17,2.17,0,0,1,1.47-.53c.78,0,1.49.31,1.49,1.28v2.19Zm0-.82v-.42a.89.89,0,0,0-.71-.3c-.35,0-.64.19-.64.51s.29.51.64.51A.86.86,0,0,0,231.57,186Z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M234.94,184.47a2.44,2.44,0,1,1,2.44,2.42A2.35,2.35,0,0,1,234.94,184.47Zm3.86,0a1.42,1.42,0,1,0-1.42,1.54A1.42,1.42,0,0,0,238.8,184.47Z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M240.7,186.81V184.2h-.56v-.78h.56v-.14a1.1,1.1,0,0,1,1.13-1.22,1.21,1.21,0,0,1,.89.33l-.34.54a.5.5,0,0,0-.37-.14c-.25,0-.42.16-.42.49v.14h.69v.78h-.69v2.61Zm2.29,0V184.2h-.56v-.78H243v-.14a1.1,1.1,0,0,1,1.13-1.22,1.49,1.49,0,0,1,.65.14l-.18.66a.5.5,0,0,0-.29-.07c-.25,0-.42.16-.42.49v.14h.69v.78h-.69v2.61Zm2-4.28a.53.53,0,0,1,1.06,0,.53.53,0,0,1-1.06,0Zm.08,4.28v-3.39H246v3.39Z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M246.63,185.11a1.72,1.72,0,0,1,1.79-1.77,1.57,1.57,0,0,1,1.34.61l-.58.55a.83.83,0,0,0-.72-.37,1,1,0,0,0,0,2,.85.85,0,0,0,.72-.37l.58.54a1.58,1.58,0,0,1-1.34.62A1.73,1.73,0,0,1,246.63,185.11Z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M250.12,185.11a1.73,1.73,0,0,1,1.75-1.77,1.69,1.69,0,0,1,1.7,1.86v.21h-2.52a.91.91,0,0,0,1,.75,1.4,1.4,0,0,0,.89-.33l.4.59a2.09,2.09,0,0,1-1.39.47A1.71,1.71,0,0,1,250.12,185.11Zm1.75-1a.77.77,0,0,0-.82.72h1.66A.78.78,0,0,0,251.87,184.07Z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M253.92,186.36l.38-.64a1.9,1.9,0,0,0,1.17.47c.39,0,.57-.15.57-.36,0-.55-2-.1-2-1.43,0-.56.49-1.06,1.39-1.06a2.2,2.2,0,0,1,1.36.46l-.36.63a1.45,1.45,0,0,0-1-.39c-.32,0-.53.14-.53.33,0,.5,2,.08,2,1.44,0,.63-.53,1.08-1.47,1.08A2.25,2.25,0,0,1,253.92,186.36Z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M257.44,183.94a.57.57,0,1,1,.56.57A.57.57,0,0,1,257.44,183.94Zm0,2.38a.57.57,0,1,1,.56.56A.57.57,0,0,1,257.44,186.32Z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M205.05,194.55l.35-.45a1.91,1.91,0,0,0,1.46.67c.84,0,1.1-.45,1.1-.81,0-1.2-2.76-.53-2.76-2.2,0-.77.68-1.3,1.61-1.3a2.17,2.17,0,0,1,1.65.66l-.35.42a1.77,1.77,0,0,0-1.35-.56c-.56,0-1,.3-1,.75,0,1.05,2.76.44,2.76,2.19,0,.67-.46,1.37-1.72,1.37A2.33,2.33,0,0,1,205.05,194.55Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M209.26,196.05a.75.75,0,0,0,.29.06.48.48,0,0,0,.5-.36l.23-.51-1.42-3.42h.58l1.12,2.78,1.13-2.78h.56l-1.69,4.07a1,1,0,0,1-1,.69,1.44,1.44,0,0,1-.37-.05Z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M215.25,195.21v-.51a1.41,1.41,0,0,1-1.14.59c-.88,0-1.51-.67-1.51-1.77a1.57,1.57,0,0,1,1.51-1.78,1.41,1.41,0,0,1,1.14.59v-1.8h.52v4.68Zm0-.93v-1.52a1.25,1.25,0,0,0-1-.55c-.69,0-1.09.56-1.09,1.31s.4,1.3,1.09,1.3A1.24,1.24,0,0,0,215.25,194.28Z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M219.11,195.21V193c0-.6-.3-.78-.76-.78a1.32,1.32,0,0,0-1,.52v2.48h-.53v-3.39h.53v.49a1.68,1.68,0,0,1,1.21-.57,1,1,0,0,1,1.07,1.09v2.38Z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M220.49,193.51a1.69,1.69,0,0,1,1.67-1.77,1.64,1.64,0,0,1,1.62,1.81v.14h-2.73a1.19,1.19,0,0,0,1.21,1.17,1.46,1.46,0,0,0,1.05-.44l.26.35a1.91,1.91,0,0,1-1.35.52A1.68,1.68,0,0,1,220.49,193.51Zm1.66-1.34a1.13,1.13,0,0,0-1.11,1.12h2.22A1.09,1.09,0,0,0,222.15,192.17Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M224.52,196.05a.75.75,0,0,0,.29.06.48.48,0,0,0,.5-.36l.23-.51-1.42-3.42h.58l1.12,2.78,1.13-2.78h.56l-1.69,4.07a1,1,0,0,1-1,.69,1.44,1.44,0,0,1-.37-.05Z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M230.61,194.26a.75.75,0,1,1,.75-.75A.76.76,0,0,1,230.61,194.26Z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M237.54,195.21l-.41-1.05h-2.32l-.42,1.05h-.66l1.88-4.68h.72l1.88,4.68ZM236,191.13l-1,2.52h2Z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M241.25,195.21v-.51a1.42,1.42,0,0,1-1.14.59c-.89,0-1.51-.67-1.51-1.77s.62-1.78,1.51-1.78a1.43,1.43,0,0,1,1.14.59v-1.8h.52v4.68Zm0-.93v-1.52a1.26,1.26,0,0,0-1-.55c-.69,0-1.09.56-1.09,1.31s.4,1.3,1.09,1.3A1.26,1.26,0,0,0,241.25,194.28Z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M242.62,193.51a1.69,1.69,0,0,1,1.67-1.77,1.65,1.65,0,0,1,1.63,1.81v.14h-2.74a1.2,1.2,0,0,0,1.22,1.17,1.49,1.49,0,0,0,1-.44l.25.35a1.89,1.89,0,0,1-1.35.52A1.68,1.68,0,0,1,242.62,193.51Zm1.66-1.34a1.12,1.12,0,0,0-1.1,1.12h2.22A1.11,1.11,0,0,0,244.28,192.17Z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M246.76,195.21v-4.68h.53v4.68Z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M250.45,195.21v-.39a1.43,1.43,0,0,1-1.12.47,1.13,1.13,0,0,1-1.18-1.12,1.1,1.1,0,0,1,1.18-1.11,1.42,1.42,0,0,1,1.12.45v-.61c0-.45-.36-.71-.85-.71a1.32,1.32,0,0,0-1,.47l-.24-.36a1.74,1.74,0,0,1,1.35-.56c.72,0,1.31.32,1.31,1.14v2.33Zm0-.72v-.64a1.12,1.12,0,0,0-.92-.42.75.75,0,1,0,0,1.48A1.12,1.12,0,0,0,250.45,194.49Z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M251.94,191a.36.36,0,1,1,.71,0,.36.36,0,0,1-.71,0Zm.09,4.22v-3.39h.53v3.39Z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M256.06,195.21v-.51a1.41,1.41,0,0,1-1.14.59c-.89,0-1.51-.67-1.51-1.77s.62-1.78,1.51-1.78a1.41,1.41,0,0,1,1.14.59v-1.8h.52v4.68Zm0-.93v-1.52a1.25,1.25,0,0,0-1-.55c-.69,0-1.09.56-1.09,1.31s.4,1.3,1.09,1.3A1.24,1.24,0,0,0,256.06,194.28Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M257.44,193.51a1.69,1.69,0,0,1,1.66-1.77,1.64,1.64,0,0,1,1.63,1.81v.14H258a1.19,1.19,0,0,0,1.21,1.17,1.48,1.48,0,0,0,1.05-.44l.25.35a1.88,1.88,0,0,1-1.34.52A1.68,1.68,0,0,1,257.44,193.51Zm1.66-1.34a1.13,1.13,0,0,0-1.11,1.12h2.22A1.1,1.1,0,0,0,259.1,192.17Z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M264.12,194.26a.75.75,0,0,1,0-1.5.75.75,0,1,1,0,1.5Z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M268.88,195.21v-4.16H267.4v-.52H271v.52h-1.49v4.16Z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M273.15,195.21v-.39a1.47,1.47,0,0,1-1.13.47,1.13,1.13,0,0,1-1.17-1.12,1.09,1.09,0,0,1,1.17-1.11,1.44,1.44,0,0,1,1.13.45v-.61c0-.45-.37-.71-.86-.71a1.33,1.33,0,0,0-1,.47l-.24-.36a1.76,1.76,0,0,1,1.35-.56c.72,0,1.31.32,1.31,1.14v2.33Zm0-.72v-.64a1.15,1.15,0,0,0-.93-.42.75.75,0,1,0,0,1.48A1.15,1.15,0,0,0,273.15,194.49Z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M274.44,194.76l.26-.38a1.56,1.56,0,0,0,1.12.48c.52,0,.8-.24.8-.58,0-.82-2.09-.31-2.09-1.57,0-.53.45-1,1.25-1a1.72,1.72,0,0,1,1.26.49l-.25.36a1.32,1.32,0,0,0-1-.42c-.46,0-.75.23-.75.53,0,.73,2.1.25,2.1,1.57,0,.57-.46,1-1.33,1A1.79,1.79,0,0,1,274.44,194.76Z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M282.06,195.21v-2.3c0-.43-.18-.7-.62-.7a1.16,1.16,0,0,0-.9.52v2.48H280v-2.3c0-.43-.18-.7-.62-.7a1.17,1.17,0,0,0-.89.52v2.48H278v-3.39h.53v.49a1.48,1.48,0,0,1,1.1-.57.86.86,0,0,1,.9.63,1.41,1.41,0,0,1,1.13-.63c.62,0,.95.34.95,1v2.45Z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M285.75,195.21v-.39a1.43,1.43,0,0,1-1.12.47,1.13,1.13,0,0,1-1.18-1.12,1.1,1.1,0,0,1,1.18-1.11,1.42,1.42,0,0,1,1.12.45v-.61c0-.45-.36-.71-.85-.71a1.32,1.32,0,0,0-1,.47l-.24-.36a1.74,1.74,0,0,1,1.35-.56c.72,0,1.31.32,1.31,1.14v2.33Zm0-.72v-.64a1.12,1.12,0,0,0-.92-.42.75.75,0,1,0,0,1.48A1.12,1.12,0,0,0,285.75,194.49Z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M289.62,195.21V193c0-.6-.3-.78-.76-.78a1.32,1.32,0,0,0-1,.52v2.48h-.53v-3.39h.53v.49a1.68,1.68,0,0,1,1.21-.57,1,1,0,0,1,1.07,1.09v2.38Z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M291.11,191a.36.36,0,0,1,.35-.36.35.35,0,0,1,.35.36.34.34,0,0,1-.35.35A.35.35,0,0,1,291.11,191Zm.09,4.22v-3.39h.52v3.39Z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M294.89,195.21v-.39a1.46,1.46,0,0,1-1.12.47,1.13,1.13,0,0,1-1.18-1.12,1.1,1.1,0,0,1,1.18-1.11,1.43,1.43,0,0,1,1.12.45v-.61c0-.45-.37-.71-.86-.71a1.31,1.31,0,0,0-1,.47l-.25-.36a1.77,1.77,0,0,1,1.35-.56c.72,0,1.31.32,1.31,1.14v2.33Zm0-.72v-.64a1.14,1.14,0,0,0-.93-.42.75.75,0,1,0,0,1.48A1.14,1.14,0,0,0,294.89,194.49Z"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 183.32,
    y1: 195.72,
    x2: 339.23,
    y2: 195.72
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 183.32,
    y1: 139.02,
    x2: 339.23,
    y2: 139.02
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 183.32,
    y1: 82.33,
    x2: 339.23,
    y2: 82.33
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 183.32,
    y1: 25.64,
    x2: 339.23,
    y2: 25.64
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 183.32,
    y1: 224.06,
    x2: 339.23,
    y2: 224.06
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 183.32,
    y1: 167.37,
    x2: 339.23,
    y2: 167.37
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 183.32,
    y1: 110.68,
    x2: 339.23,
    y2: 110.68
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 183.32,
    y1: 53.98,
    x2: 339.23,
    y2: 53.98
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 289.62,
    y1: 249.57,
    x2: 289.62,
    y2: 0.13
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 232.93,
    y1: 249.57,
    x2: 232.93,
    y2: 0.13
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 317.97,
    y1: 249.57,
    x2: 317.97,
    y2: 0.13
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 261.27,
    y1: 249.57,
    x2: 261.27,
    y2: 0.13
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 204.58,
    y1: 249.57,
    x2: 204.58,
    y2: 0.13
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M.51,266.1v-5.33H3.89v.41H1v2H3.83v.41H1v2.53Z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M4.83,266.1v-3.86h.41v.66a1.67,1.67,0,0,1,1.31-.74v.46a.75.75,0,0,0-.21,0,1.48,1.48,0,0,0-1.1.69v2.81Z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M7.15,264.17a1.86,1.86,0,1,1,1.84,2A1.87,1.87,0,0,1,7.15,264.17Zm3.26,0A1.5,1.5,0,0,0,9,262.52a1.67,1.67,0,0,0,0,3.3A1.5,1.5,0,0,0,10.41,264.17Z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M14.54,266.1v-2.61c0-.75-.38-1-.94-1a1.64,1.64,0,0,0-1.25.66v2.92h-.42v-3.86h.42v.58a2,2,0,0,1,1.39-.68c.78,0,1.21.39,1.21,1.26v2.7Z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M16.33,265.36v-2.75h-.64v-.37h.64v-1.06h.42v1.06h.79v.37h-.79v2.68c0,.32.13.53.4.53a.64.64,0,0,0,.44-.18l.16.32a.91.91,0,0,1-.66.24C16.58,266.2,16.33,265.89,16.33,265.36Z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M183.7,266.1v-5.33h2.19a1.32,1.32,0,0,1,1.47,1.36,1.2,1.2,0,0,1-.93,1.22,1.34,1.34,0,0,1,1,1.31,1.38,1.38,0,0,1-1.53,1.44Zm3.18-3.92a1,1,0,0,0-1-1h-1.68v2h1.68A1,1,0,0,0,186.88,262.18Zm.11,2.45a1,1,0,0,0-1.12-1.06h-1.71v2.12h1.71A1,1,0,0,0,187,264.63Z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M191.06,266.1v-.45a1.7,1.7,0,0,1-1.31.55,1.3,1.3,0,0,1-1.35-1.29,1.28,1.28,0,0,1,1.35-1.28,1.7,1.7,0,0,1,1.31.55v-.78a.91.91,0,0,0-1-.89,1.53,1.53,0,0,0-1.22.57l-.23-.29a1.89,1.89,0,0,1,1.49-.65c.78,0,1.41.38,1.41,1.24v2.72Zm0-.76v-.85a1.42,1.42,0,0,0-1.17-.53,1,1,0,1,0,0,1.91A1.44,1.44,0,0,0,191.06,265.34Z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M192.56,264.17a1.88,1.88,0,0,1,1.87-2,1.62,1.62,0,0,1,1.37.66l-.29.26a1.21,1.21,0,0,0-1.06-.54,1.66,1.66,0,0,0,0,3.3,1.24,1.24,0,0,0,1.06-.54l.29.25a1.6,1.6,0,0,1-1.37.67A1.89,1.89,0,0,1,192.56,264.17Z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M199.4,266.1l-1.54-1.84-.72.68v1.16h-.41v-5.33h.41v3.68l2.27-2.21H200l-1.8,1.74L200,266.1Z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M270.32,265.35l.3-.34a2.19,2.19,0,0,0,1.67.77c1.09,0,1.4-.61,1.4-1.06,0-1.57-3.2-.75-3.2-2.62,0-.87.78-1.42,1.75-1.42a2.31,2.31,0,0,1,1.81.75l-.31.34a1.87,1.87,0,0,0-1.52-.67c-.71,0-1.25.4-1.25,1,0,1.37,3.2.62,3.2,2.61,0,.68-.46,1.51-1.9,1.51A2.47,2.47,0,0,1,270.32,265.35Z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M275.14,261.31a.32.32,0,1,1,.32.32A.32.32,0,0,1,275.14,261.31Zm.11,4.79v-3.86h.42v3.86Z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M276.76,266.1v-.34l2.29-3.15h-2.29v-.37h2.82v.34l-2.31,3.15h2.35v.37Z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M280.5,264.17a1.92,1.92,0,0,1,1.85-2,1.85,1.85,0,0,1,1.83,2.05v.11H281a1.51,1.51,0,0,0,1.51,1.54,1.72,1.72,0,0,0,1.26-.54l.22.27a2,2,0,0,1-1.52.63A1.9,1.9,0,0,1,280.5,264.17Zm1.84-1.67A1.45,1.45,0,0,0,281,264h2.8A1.42,1.42,0,0,0,282.34,262.5Z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M285.12,262.54a.36.36,0,0,1,.36-.36.36.36,0,0,1,.35.36.35.35,0,0,1-.35.34A.36.36,0,0,1,285.12,262.54Zm0,3.28a.36.36,0,0,1,.36-.34.35.35,0,1,1,0,.69A.36.36,0,0,1,285.12,265.82Z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M289,265.33l.31-.31a1.68,1.68,0,0,0,1.49.76,1.28,1.28,0,0,0,1.34-1.29,1.25,1.25,0,0,0-1.33-1.3,1.83,1.83,0,0,0-1.3.52l-.34-.14v-2.8h3.08v.41h-2.63v2.09a1.9,1.9,0,0,1,1.28-.49,1.63,1.63,0,0,1,1.7,1.7,1.7,1.7,0,0,1-1.8,1.72A2,2,0,0,1,289,265.33Z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M293.59,265.82a.36.36,0,0,1,.71,0,.36.36,0,0,1-.71,0Z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M295.41,265.33l.3-.31a1.7,1.7,0,0,0,1.5.76,1.28,1.28,0,0,0,1.33-1.29,1.24,1.24,0,0,0-1.32-1.3,1.83,1.83,0,0,0-1.3.52l-.34-.14v-2.8h3.08v.41H296v2.09a1.9,1.9,0,0,1,1.27-.49,1.63,1.63,0,0,1,1.71,1.7,1.7,1.7,0,0,1-1.8,1.72A2,2,0,0,1,295.41,265.33Z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M299.9,264.17a1.89,1.89,0,0,1,1.88-2,1.59,1.59,0,0,1,1.36.66l-.28.26a1.22,1.22,0,0,0-1.06-.54,1.66,1.66,0,0,0,0,3.3,1.25,1.25,0,0,0,1.06-.54l.28.25a1.57,1.57,0,0,1-1.36.67A1.9,1.9,0,0,1,299.9,264.17Z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M308.67,266.1v-2.7c0-.54-.23-.88-.78-.88a1.43,1.43,0,0,0-1.1.66v2.92h-.42v-2.7c0-.54-.23-.88-.77-.88a1.47,1.47,0,0,0-1.11.66v2.92h-.42v-3.86h.42v.58a1.73,1.73,0,0,1,1.25-.68,1,1,0,0,1,1,.73,1.62,1.62,0,0,1,1.28-.73c.71,0,1.06.4,1.06,1.18v2.78Z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M315,266.1l-1.28-1.7-1.29,1.7h-.5l1.53-2L312,262.24h.5l1.2,1.59,1.19-1.59h.49L314,264.12l1.52,2Z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M318.18,264.77a1.6,1.6,0,0,1,1.33-1.42c-.63-.17-1.24-.57-1.24-1.29,0-.94.89-1.37,1.73-1.37s1.73.43,1.73,1.37c0,.72-.61,1.12-1.24,1.29a1.59,1.59,0,0,1,1.32,1.42c0,.86-.79,1.43-1.81,1.43S318.18,265.64,318.18,264.77Zm3.17,0c0-.81-1-1.13-1.35-1.17s-1.35.36-1.35,1.17c0,.65.64,1,1.35,1S321.35,265.38,321.35,264.73Zm-.09-2.62c0-.64-.57-1-1.26-1s-1.26.37-1.26,1,.94,1,1.26,1.05S321.26,262.86,321.26,262.11Z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M322.8,265.82a.36.36,0,0,1,.36-.34.35.35,0,1,1,0,.69A.36.36,0,0,1,322.8,265.82Z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M324.5,264.77a1.6,1.6,0,0,1,1.33-1.42c-.63-.17-1.24-.57-1.24-1.29,0-.94.89-1.37,1.73-1.37s1.73.43,1.73,1.37c0,.72-.61,1.12-1.24,1.29a1.59,1.59,0,0,1,1.32,1.42c0,.86-.79,1.43-1.81,1.43S324.5,265.64,324.5,264.77Zm3.17,0c0-.81-1-1.13-1.35-1.17s-1.35.36-1.35,1.17c0,.65.64,1,1.35,1S327.67,265.38,327.67,264.73Zm-.09-2.62c0-.64-.57-1-1.26-1s-1.26.37-1.26,1,.94,1,1.26,1.05S327.58,262.86,327.58,262.11Z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M329,264.17a1.89,1.89,0,0,1,1.87-2,1.61,1.61,0,0,1,1.37.66l-.29.26a1.21,1.21,0,0,0-1.05-.54,1.66,1.66,0,0,0,0,3.3,1.23,1.23,0,0,0,1.05-.54l.29.25a1.59,1.59,0,0,1-1.37.67A1.89,1.89,0,0,1,329,264.17Z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M337.8,266.1v-2.7c0-.54-.23-.88-.78-.88a1.41,1.41,0,0,0-1.1.66v2.92h-.43v-2.7c0-.54-.22-.88-.76-.88a1.47,1.47,0,0,0-1.11.66v2.92h-.42v-3.86h.42v.58a1.71,1.71,0,0,1,1.24-.68,1,1,0,0,1,1,.73,1.59,1.59,0,0,1,1.28-.73c.71,0,1,.4,1,1.18v2.78Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideMaterial1);
export default __webpack_public_path__ + "static/media/guideMaterial1.b95f49a5efc2d968af981b6a1d244755.svg";
export { ForwardRef as ReactComponent };